import React, { useEffect, useState, Fragment, useRef } from "react";
import axios from "axios";
import { uri } from "../../../../help/Api";
import { insh, sto, premiA } from "../../../../Context/InshData";
import { getLS } from "../../../../utils/useLS";
import { autos, transToPurch, transToSal } from "../../../../Context/Local";
import { inshF } from "../../../../Context/InshFront";
import moment from "moment";
import PropTypes from "prop-types";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Zoom from "@material-ui/core/Zoom";
import { useHistory, useLocation } from "react-router-dom";
import HomeBcode from "../../../../barcode/HomeBcode";
import dataF from "../../../../Server/dataF.json";
// f d
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Slide from "@material-ui/core/Slide";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// f e
import Autocomplete, {
    createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Fab from "@material-ui/core/Fab";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

// t
import MaterialTable, { MTableToolbar } from "material-table";
import { TableIcons as tableIcons } from "../../../../Elemnts/TableIcons";
import {
    Delete,
} from "@material-ui/icons";

// ===================================================== btn load
import clsx from "clsx";
// ===================================================== btn load

import Hidden from "@material-ui/core/Hidden";
import {
    useStylesUp,
    useStylesAuto,
    useStylesTF,
    useStylesBA,
    useStylesFU,
    useStylesCAB,
    useStylesLbl,
    SaleCheckbox,
    useStylesDSM,
    StyledMenuItem,
    StyledMenu,
    useStylesSN,
} from "../../../../St/comps/UseStyle";

import { stElemnt } from "../../../../St/comps/cStyle";
import { Mtb } from "../../../../St/comps/vstyle";

import "../../../../St/comps/csStyle.css";
import BackdropScI from "../../../../services/BackdropScI";

import FavCard from "../../Elemnt/FavCard";
import ReConnect from "../../../../Start/ReConnect";
import { getInveTypeIndex } from "../../../../modules/utils";
import { getDefaultOmla } from "../../../../services/omlat-services";
import CustomersDialog from "../../../Customers/customers/customersDialog";
import { useTranslation } from "react-i18next";
import toast, { Toaster } from "react-hot-toast";
import {
    handleDirectPrintCasair,
    handleDirectPrintTemp2,
    PrintInvoiceDirectly,
} from "../components/printSerivce";
import ExtVoucherDialog from "../components/ExtVoucherDialog";
import DeleteConfirmDialog from "../../../../components/DeleteConfirmDialog";
import PaidWindowForm from "../components/paidwidow/paidwindowform";
import { useLocalStorage } from "react-use";
import { Box, colors, Typography } from "@material-ui/core";
import InvoiceItemsModals from "../models/InvoiceItemsModel";
import InvItemsTable from "./invoiceTable";
import ItemsDialog from "../../../bascDatas/Tab1/items/AddItems/ItamsDialog";
import InvoiceFooter from "./invoiceFooter";
import CustomerDialogData from "../../../Customers/customers/CustomerDialogData";
import MainInvoiceAppar from "./MainInvoiceAppar";
import MainInvoiceHeader from "./MainInvoiceHeader";
import i18next from "i18next";
import InvoicesExpenses from "./InvoicesExpenses/InvoicesExpenses";
import MainInvoiceDownItems from "./MainInvoiceDownItems";
import { GetItemFromOptions } from "../../../../services/global-services";
import { generateDocument } from "../../../Settings/invoice-settings/invoice-templates/test-template";
import printJS from "print-js";
import ImportExcel from "../../../bascDatas/Tab1/items/ImportExcel/ImportExcel";
import SearchInvoiceScreean, { defualtValueSearch } from "../models/search-model/SearchInvoiceScreean";
import OutstandingInvoice from "../models/Outstanding/OutstandingInvoice";
import { addArchaiveFile, addMultiArchaiveFile, getDataItemsNoApi, handleDownloadFiles, handleInputSearchCustomers, handleMultiDownloadFiles, viewHandleCustomers, viewHandleSearchInv, viewItemsHandleInv } from "../components/SearchItemsFunction";
import { checkValueQ, getAlertValQ } from "../components/ShareFunctionsInv";
import ItemsFromOthers from "../models/ItemsFromOthers/ItemsFromOthers";
import InvoiceTypePrintA4 from "../models/InvoiceTypePrintA4";
import ExitConfirmDialog from "../../../../components/ExitConfirmDialog";
import { selectDateOrTime, selectDateOrTimeCar } from "../../../../services/saleAnalysis-services";
import { render } from "@testing-library/react";


//=====================================================================
let nevEve = "always",
    nl = null;

const useStylestolb = makeStyles((theme) => ({
    toolbarWrapper: {
        "& .MuiToolbar-gutters": {
            paddingLeft: 0,
            paddingRight: 0,
        },
    },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

let LetvalueCurrUnits = null;
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            keepMounted
        >
            {value === index && (
                <Box >
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
export default function MainInvoiceClass(props) {
    const { AutoOptions, isPurches, isStock, isMake, isDialog, post } = props;
    // const cl = (c) => {
    //     console.log(c);
    // };

    const [showSc, setShowSc] = useState(true);
    const isSavingRef = useRef(false);

    // let isKham = AutoOptions?.IsKham?.id;
    const clasup = useStylesUp();
    const clasSM = useStylesDSM();
    const clasBA = useStylesBA();
    const clasFu = useStylesFU();
    const clasCAB = useStylesCAB();
    const clasSN = useStylesSN();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const claslbl = useStylesLbl();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const clstoolbar = useStylestolb();
    const [gets, setGets] = useState(insh.tbname);
    const [maxShifts, setMaxShifts] = useState(AutoOptions.maxShift.id);
    const [currentUserName, setCurrentUserName] = useState(AutoOptions.maxShift.name);
    const [openPrint, setOpenPrint] = useState({ open: false, localInv: {}, invType: 1, invKind: 1 });
    const [invDisc, setInvDisc] = useState(insh.InvDisc);
    const [invsSearchTable, setInvsSearchTable] = useState([]);
    const [excelData, setExcelData] = useState([]);
    const [outstandData, setOutstandData] = useState([]);

    const [idata, setIData] = useState(() => {
        return { ...insh.IdataInvs, date: moment(new Date()).format("YYYY-MM-DD"), post: post };
    }); //is data in ta
    //is data in ta
    const [allow, setAllow] = useState({ c: false, s: false, it: false, cud: false });

    const [file, setFile] = useState(null);
    const [files, setFiles] = useState([]);
    /* Anemation */
    const [transition, setTransition] = React.useState(undefined);
    function TransitionUp(props) {
        return <Slide {...props} direction="up" />;
    }
    function TransitionRight(props) {
        return <Slide {...props} direction="right" />;
    }
    function TransitionDown(props) {
        return <Slide {...props} direction="down" />;
    }

    const [isOpenSy, setIsOpenSy] = useState(false);
    const [allowKeyboard, setAllowKeyboard] = useState(false);
    //rsa
    const [isOpenCustomer, setIsOpenCustomer] = useState(false);
    const [isOpenCustomerData, setIsOpenCustomerData] = useState(false);
    const [isOpenItems, setIsOpenItems] = useState(false);
    const handleOpenCustomerData = () => {
        setAllow({ ...allow, cud: !isOpenCustomerData });
        setIsOpenCustomerData(!isOpenCustomerData);
    }; // E rsa
    const handleOpenCustomer = () => {
        setAllow({ ...allow, c: !isOpenCustomer });
        setIsOpenCustomer(!isOpenCustomer);
    }; // E rsa
    const handleOpenItems = () => {
        setAllow({ ...allow, it: !isOpenItems });
        setIsOpenItems(!isOpenItems);
    }; // E rsa
    // s Dup


    // s DDown
    const [openDw, setOpenDw] = useState(false);

    const handOpenDw = (Transition) => {
        setTransition(() => Transition);
        setOpenDw(true);
    };
    const handCloseDw = () => {
        setOpenDw(false);
    };

    const [subInfo, setSubInfo] = useState(insh.InfoSub);
    const [idSearch, setIdSearch] = useState(false);
    const countItem = AutoOptions?.InvItems?.length === 300 || AutoOptions?.InvItems?.length === 400 ? true : false;
    const countCustomers = AutoOptions?.Customers?.length === 250 ? true : false;
    const inputRef = useRef(null);
    const [localCashe, setLocalCashe] = useState([]);
    const [cacheItems, setCacheItems] = useState([]);
    const [optionsItemsSearch, setOptionsItemsSearch] = useState(AutoOptions?.InvItems);

    const [counts, setCounts] = useState({ curr: 0 });
    const [showPaid, setShowPaid] = useLocalStorage("show-paid-window", false);
    /* s DcuD  */
    const [openCuD, setOpenCuD] = React.useState(false);

    const [dialog, setDialog] = React.useState(inshF.dia);

    const handleClDia = (prop, state) => setDialog({ ...dialog, [prop]: state });
    const [openDwt, setOpenDwt] = useState(false);

    const handOpenDwt = (Transition) => {
        setTransition(() => Transition);
        setOpenDwt(true);
    };
    const handCloseDwt = () => {
        setOpenDwt(false);
    };

    const SearchActivityReports = {
        barcode: '',
        curr: {},
        symbol: '',
        barcodeS: '',
        groupS: { id: -1, name: "الكل ", parentId: -1 },
        groupSe: { id: -1, name: "الكل ", parentId: -1 },
        group: { id: -1, name: "الكل", parentId: -1 },
        currS: {},
        barcodeNormal: "",
        isData: false,

    };
    const [rptParams, setRptParams] = useState(SearchActivityReports);

    const [fildSearch, setFildSearch] = useState(false);
    const [openGetItems, setOpenGetItems] = useState(false);

    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });
    const [exitDialog, setExitDialog] = useState({ isOpen: false });
    /* s DcuD and McuD */
    /* s PMD */
    const [openPMD, setOpenPMD] = useState(false);
    //const [typePress, setTypePress] = useState("save");
    let typePress = "save";
    const handleClickOpenPMD = (Transition) => {
        setTransition(() => Transition);
        setOpenPMD(true);
    };
    const handleClickOpenPaid = (type) => {
        typePress = type;
        // setValueBankPMD
        setOpenPMD(true);
    };
    const handClosePMD = async (state) => {
        if (state === "cancle") await restPM(state);
        await setOpenPMD(false);
    };
    /* e PMD */

    /* s BCSD */

    const [barcodes, setBarcodes] = useState("");
    const { t: transForm } = useTranslation(["forms"]);
    const _onDetected = async (result) => {
        const res = [];
        // const item = currencies[barcodes_eds.indexOf(result)];
        // const item = AutoOptions.Items[barcodes_eds.indexOf(result)];
        // res.push(item.units);

        // if (res.length > 0) {
        //     await BefBarcodedataCurrencie(item.id, item.units);
        //     setIsBarcode(true);
        // }
    };
    /* e BCSD */

    const [lbl, setLbl] = React.useState(insh.Lbl);
    const [switchState, setSwitchState] = React.useState(insh.SwitchState);


    const chashVSnetwork = (valChecked) => {

        if (valChecked == true && valueType.id !== 1) {
            const text = transForm("network").toString();
            setLbl({ ...lbl, chashNetwork: text });
            setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
            setValueBankPMD(AutoOptions.Banks[0]); //getAutobanks(0);
            setUiElement({ ...uiElement, bank: false });
            setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });
            setIData({ ...idata, pay_type: 2, bank: AutoOptions.Banks[0].id });
        } else if (valChecked == false && valueType.id !== 1) {
            setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setValueBankPMD(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
            setUiElement({ ...uiElement, bank: true, stock: false });
            setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id });
            setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
        } else if (parseFloat(payment.paidup) > 0 && valChecked === true && valueType.id === 1) {
            const text = transForm("network").toString();
            setLbl({ ...lbl, chashNetwork: text });
            setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
            setValueBankPMD(AutoOptions.Banks[0]); //getAutobanks(0);
            setUiElement({ ...uiElement, bank: false });
            setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });
            setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });
        }
        else if (parseFloat(payment.paidup) > 0 && valChecked == false && valueType.id == 1) {
            setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setValueBankPMD(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
            setUiElement({ ...uiElement, bank: true });
            setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
            setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, stock: AutoOptions.Stocks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });
        }
    };

    const updatePrem = async (event) => {
        premiA.stayInDCurr = event;
        await axios
            .put(uri + "PermissionApp", premiA)
            .then((res) => {
                // storgeingprem(res.data);
            })
            .catch((error) => { });
    };

    const changClick = (prop, ev) => {
        if (prop == "minus") setUiElement({ ...uiElement, [prop]: ev, rate: true });
        else if (prop == "rate")
            setUiElement({ ...uiElement, [prop]: ev, minus: true });
    };

    const changSwitch = (name) => async (event) => {
        setSwitchState({ ...switchState, [name]: event.target.checked });

        if (name == "stayInDCurr") { updatePrem(event.target.checked); }
        else if (name == "cashORnetworksw") {
            await chashVSnetwork(event.target.checked);
        }
    };


    const handleCloseCuD = () => {
        setCurrUnit([]);
        setOpenCuD(false);
        setSubInfo(insh.InfoSub);
    };

    const handleCloseCuDWithSWState = () => {
        switchState.stayInDCurr ? setOpenCuD(true) : setOpenCuD(false);
        setSubInfo(insh.InfoSub);
    };

    const changChckedPM = (network, agel, bank, emp, onlyCheked) => {
        onlyCheked === ""
            ? setChecked({
                ...checked,
                network_partck: network,
                agel_partck: agel,
                bank_partck: bank,
                emp_partck: emp,
            })
            : setUiElement({ ...uiElement, [onlyCheked]: false });
    };

    const changAutosPM = (bank, bank2, emp, onlyCheked) => {
        if (onlyCheked === "") {
            if (bank === false) setValueBankPMD(insh.AutoBank);
            if (bank2 === false) setValueBankTransPMD(insh.AutoBank);
            if (emp === false) setValueEmployePMD(insh.Auto);
            setUiElement({
                ...uiElement,
                bankPM: !bank,
                bankPM2: !bank2,
                empPM: !bank,
            });
        } else {
            if (onlyCheked === "bankPM") setValueBankPMD(insh.AutoBank);
            else if (onlyCheked === "bankPM2") setValueBankTransPMD(insh.AutoBank);
            else if (onlyCheked === "empPM") setValueEmployePMD(insh.Auto);
            setUiElement({ ...uiElement, [onlyCheked]: true });
        }
    };

    const restPM = (from) => {
        let ck = { network: true, agel: true, bank: true, emp: true };
        if (from === "rest") {
            if (idata.network_part === "") ck.network = false;
            if (idata.agel_part === "") ck.agel = false;
            if (idata.bank_part === "") ck.bank = false;
            if (idata.emp_part === "") ck.emp = false;
        } else {
            ck.network = false;
            ck.agel = false;
            ck.bank = false;
            ck.emp = false;
        }
        changChckedPM(ck.network, ck.agel, ck.bank, ck.emp, "");
        changAutosPM(ck.network, ck.bank, ck.emp, "");
    };
    const [or, setOr] = useState(insh.Or);
    const [ished, setIshed] = useState(insh.ished);

    const [permiCuCo, setPrmiCuCo] = useState({});

    const getPrmetions = (resDataElm, permiCuCo) => {
        // getAutoPricePays(permiCuCo.TSP);
        getAutoPricePays(permistionInv?.TYPEPRICE ?? 0);
        if (permistionInv.USP) {
            nevEve = "never";
        }
        setPrmiCuCo(permiCuCo);
    };

    const [uiElement, setUiElement] = useState({});
    const [permistionInv, setPermistionInv] = useState(AutoOptions.permsInvs);
    // >>>>> datas
    // const [currencies, setCurrencies] = useState([]);
    const [invsShow, setInvsShow] = useState([]);
    const [exsub, setExSub] = useState(0);
    const [infoInv, setInfoInv] = useState({ id: "", InvId_Return: "" });
    const [isdata, setIsData] = useState([]); //is data in ta
    const [expenseList, setExpenseList] = React.useState([]);
    const [rowUpdate, setRowUpdate] = useState({}); //is data in ta
    const [lastItem, setLastLtem] = useState(false); //is data in ta
    const location = useLocation();
    const [stor, setStor] = useState({}); //is data in ta
    const [storS, setStorS] = useState({}); //is data in ta
    const [favGroups, setFavGroups] = useState([]);
    const [groups, setGroups] = useState([]);
    const [groupsSub, setGroupsSub] = useState([]);
    // Auto
    // const [auto, setAuto] = useState(insh.auto);
    const [valueType, setValueType] = useState(insh.Auto);
    const [valueIsharLevel, setValueIsharLevel] = useState({ id: 0, name: "حسب الفاتورة" });
    //TypeInvs
    const [valueTypeFltr, setValueTypeFltr] = useState(insh.Auto);
    //Safes
    const [valueSafes, setValueSafes] = useState(AutoOptions.Safes[0]);
    //Customers
    const [optionsCustomers, setOptionsCustomers] = useState(AutoOptions.Customers);
    const [searchText, setSearchText] = useState("");
    const [searchCustText, setSearchCustText] = useState("");

    const [valueCustomers, setValueCustomers] = useState(AutoOptions.Customers[0]);
    //Salesmen
    const [valueSalesmen, setValueSalesmen] = useState(AutoOptions?.salesuser);
    //Employee
    const [valueEmployePMD, setValueEmployePMD] = useState(insh.Auto);
    //Costcenter
    const [valueCostcenter, setValueCostcenter] = useState(AutoOptions?.centerUser);
    //Stock
    const [valueStock, setValueStock] = useState(AutoOptions.Stocks[0]);
    const [omlaValue, setOmlaValue] = useState(insh.Auto);
    // network
    const [valueBank, setValueBank] = useState(insh.AutoBank);
    // network PMD
    const [valueBankPMD, setValueBankPMD] = useState(insh.AutoBank);
    const [valueBanksPaid, setValueBanksPaid] = useState(insh.AutoBank);

    //Bank Trans PMD
    const [valueBankTransPMD, setValueBankTransPMD] = useState(insh.AutoBank);
    //Units

    const [countCurrBySafe, setCountCurrBySafe] = useState([]);
    // const [currenciesToInv, setCurrenciesToInv] = useState([]);
    const [currUnit, setCurrUnit] = useState([]);
    const [currUnitsAll, setCurrUnitsAll] = useState([]);
    // const [optionsCurrUnits, setOptionsCurrUnits] = useState(insh.AutoOp);
    const [optionsCurrUnits, setOptionsCurrUnits] = useState(insh.AutoOp);
    // const [optionsCurrUnitsTable, setOptionsCurrUnitsTable] = useState(insh.AutoOp);
    // const [valueCurrUnits, setValueCurrUnits] = useState(insh.Auto);
    const [valueItemUnits, setValueItemsUnits] = useState(insh.AutoUits);

    const [indexUnit, setIndexUnit] = useState(0);
    //PricePay
    const [optionsPricePay, setOptionsPricePay] = useState(insh.AutoOp);
    const [valuePricePay, setValuePricePay] = useState(insh.Auto);

    // edrees changes
    const [itemId, setItemId] = useState("1");
    // const [barcodes_eds, setBarcodes_eds] = useState();
    const handleFocus = (e) => e.target.select();
    const getAutoPricePays = (i) => {
        setOptionsPricePay(insh.optionPricePay);
        setValuePricePay(insh.optionPricePay[i]);
    };

    const afterInvExpenses = (rate) => {
        if (rate === "") rate = 0;
        for (let m = 0; m < isdata.length; m++) {
            let percRate = Number(rate);
            isdata[m].expense = ((isdata[m].totJust * percRate) / 100).toFixed(4);
        }
    };

    const addChangds = () => {

        idata.date =
            moment(idata.date).format("YYYY-MM-DD") +
            moment(new Date()).format(" h:mm A");
        idata.InvId_Return = infoInv.InvId_Return;

        if (idata.cust_id == null || idata.cust_id === "") {
            idata.cust_id = valueCustomers.id;
            idata.customer_name = valueCustomers.name;
        }
        if (idata.Due_date != null && idata.Due_date != "") {
            idata.Due_date =
                moment(idata?.Due_date).format("YYYY-MM-DD") +
                moment(new Date()).format(" h:mm A");
        }

        if (expenseList?.length > 0) {
            let sum_tot = expenseList
                ?.reduce((a, v) => (a = a + parseFloat(v?.Expense_value_Bill)), 0)
                .toFixed(2);
            let desc_perc = (
                (sum_tot * 100) /
                parseFloat(idata.tot_purch)
            );
            afterInvExpenses(desc_perc);
        }
    };


    //--------car options-----------------
    const carOptonsValue = {
        CarModel: '',
        CarYear: '',
        CarType: '',
        CarStructure: '',
        CarVactor: '',
        CarColor: '',
        CarPlatNum: '',
        curr: { currency_from: -1, symbol: "الكل" },
    };
    const [carOptions, setCarOptions] = useState(carOptonsValue);
    const [showCarOptions, setShowCarOptions] = useState(false);

    const onChangeCarData = (propName) => (event) => {
        setCarOptions({
            ...carOptions, [propName]: event.target.value
        });
        setIData({ ...idata, [propName]: event.target.value });
    }
    //--------car options-----------------
    const fltringCurrencieToinv = async (res, pricePayId, changtaxperc) => {
        console.log("the response data is", res);
        if (setting.PrTy_InPr == "22") res.tax = 0;
        let sORp = 0;
        if (setting.cusType == 1) sORp = res.sale;
        else if (setting.cusType == 2) sORp = res.purch;
        if (changtaxperc == false) {
            res.tax = subInfo.taxperc;
            res.val1 = subInfo.val1;
        }
        if (pricePayId == 2) sORp = res.dPrice;
        else if (pricePayId == 3) sORp = res.jPrice;

        if (checked.autoOrStaticck === false) {
            setSubInfo({
                ...subInfo,
                hdshw: true,
                val1: res.val1,
                is_tab3_curr: res?.is_tab3_curr,
                id: res.id,
                minPrice: res.mPrice,
                Price: sORp,
        /*PricePu:res.purch,*/ barcode: res.barcode,
                symbol: res.symbol,
                type: res.type,
                perc: res.perc,
                taxperc: res.tax,
                totJust: (sORp * res.val1).toFixed(2),
                discount: "",
                DiscPers: "",
                taxval: ((sORp * res.tax) / 100).toFixed(2),
            });
        } else {
            subInfo.hdshw = true;
            subInfo.val1 = res.val1;
            subInfo.id = res.id;
            subInfo.Price = sORp;
            subInfo.minPrice = res.mPrice;
            subInfo.barcode = res.barcode;
            subInfo.symbol = res.symbol;
            subInfo.perc = res.perc;
            subInfo.taxperc = res.tax;
            subInfo.totJust = (sORp * res.val1).toFixed(2);
            subInfo.discount = "";
            subInfo.DiscPers = "";
            subInfo.type = res.type;
            subInfo.taxval = ((sORp * res.tax) / 100).toFixed(2);
            subInfo.is_tab3_curr = res.is_tab3_curr;
        }
    };

    const reLoadLastInv = async () => {
        const tb = {
            other: true,
            parms: {
                sProcTypeInvProc: setting.PrTy_InPr,
                branch: sto.branchi,
                tname: "invs",
                post: post,
            },
            autos: {},
        };
        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setInfoInv({ id: res.data.other.lastid, InvId_Return: "" });
            })
            .catch((error) => { });
    };

    const loadSto = async (cusType) => {
        const locSto = getLS("sto", {});
        setGets(locSto);
        // console.log("the log sto is", locSto);
        loadIdata(AutoOptions?.Customers[0], AutoOptions.types, AutoOptions?.Banks);
        setPermistionInv(AutoOptions?.permsInvs);
        setValueSafes(AutoOptions.Safes[0]);
        setValueStock(AutoOptions.Stocks[0]);
        const defOmla = getDefaultOmla(locSto.omlats);
        setOmlaValue(defOmla);
        setOptionsCustomers(AutoOptions.Customers);
        setValueCustomers(AutoOptions.Customers[0]);
        setValueTypeFltr(locSto.typesFltr[0]);
        let defaultPrice = GetItemFromOptions(AutoOptions?.permsInvs?.TYPEPRICE ?? 0, insh.optionPricePay);
        setValuePricePay(defaultPrice);
        await getCustInvType(AutoOptions.Customers[0]);
    };

    const loadGet = async (branch, pTpI, empid, formid, invType) => {
        setInfoInv({ ...infoInv, id: AutoOptions.other?.lastid });
        getPrmetions(AutoOptions?.permisElm, AutoOptions.permiCuCo);
        setShowSc(AutoOptions.wait?.state);
    };
    const reLoadCust = async (newCustData) => {
        if (newCustData != null) {
            let newCust = {
                id: newCustData.id,
                name: newCustData.name,
                Cust_inv_type: newCustData.Cust_inv_type,
                acc_no: newCustData.acc_no,
                salesmen: newCustData.salesmen,
                CustandSup: newCustData.CustandSup,
                maxdepit: newCustData.maxdepit,
                discount: newCustData?.cust_DiscValue ?? 0,
                disc_perc: newCustData?.cust_PresValue ?? 0,
                stop_trans: newCustData?.stop_trans ?? 0,
                WithoutTax: newCustData?.WithoutTax ?? 0,
            };
            setOptionsCustomers([newCust, ...optionsCustomers]);
            setValueCustomers(newCust);
            changAutoCustomers(newCust);
        }
    };
    // const reUpdateCust =async (updateData) => {
    //   await  reUpdateCustData(updateData);
    // };
    const reUpdateCust = async (updateData) => {
        if (updateData != null) {
            var otherOptions = optionsCustomers.filter((obj) => obj.id != updateData.id);
            let newCust = {
                id: updateData.id,
                name: updateData.name,
                Cust_inv_type: updateData.Cust_inv_type,
                acc_no: updateData.acc_no,
                salesmen: updateData.salesmen,
                CustandSup: updateData.CustandSup,
                maxdepit: updateData.maxdepit,
                discount: updateData?.cust_DiscValue ?? 0,
                disc_perc: updateData?.cust_PresValue ?? 0,
                stop_trans: updateData?.stop_trans ?? 0,
                WithoutTax: updateData?.WithoutTax ?? 0,
            };
            setOptionsCustomers([newCust, ...otherOptions]);
            setValueCustomers(newCust);
            await changAutoCustomers(newCust);
        }
        console.log("the oldCurr is ", updateData);
    };

    const [setting, setSetting] = useState({});
    const [style, setStyle] = useState({});

    const loadInsh = async () => {
        setSetting(location.state.setting);
        setStor(location.state.stor);
        loadGet(
            location.state.idata.branch,
            location.state.setting.PrTy_InPr,
            location.state.idata.create_user,
            location.state.setting.iformid,
            location.state.stor.invsType
        );
        loadSto(location.state.setting.cusType);
        setStorS(location.state.setting.stors);

        setStyle(location.state.style);

    };
    const loadInshDialog = async () => {
        setSetting(props.settingInv);
        setStor(props.invStor);
        loadGet(
            props.invData.branch,
            props.invData.ProcType_InvProc,
            props.invData.create_user,
            props.formid,
            props.invsType,
        );
        let defaultPrice = GetItemFromOptions(AutoOptions?.permsInvs?.TYPEPRICE ?? 0, insh.optionPricePay);
        setValuePricePay(defaultPrice);
        // loadSto(props.cusType);
        setStyle(props.invStyle);
        setStorS(props.settingInv.stors);
        const locSto = getLS("sto", {});
        setGets(locSto);
        // setOptionsItemsSearch(AutoOptions?.InvItems);
    };

    let setupReload = function () {
        // for update date in midnight
        const timeUntilMidnight = moment()
            .endOf("day")
            .add(10, "ms")
            .diff(moment(), "ms");
        return setTimeout(function () {
            setIData({ ...idata, trans_no: AutoOptions.maxShift?.id, date: moment(new Date()).format("YYYY-MM-DD") });

            setupReload();
        }, timeUntilMidnight);
    };

    /* =============================== */
    useEffect(() => {
        if (props.isDialog == false) {
            loadInsh();
            setupReload();
        } else {
            loadInshDialog();
        }
    }, []);

    /* =============================== */

    const toDoIdata = (prop, value) => {
        setIData({ ...idata, [prop]: value });
    };
    const reInshAuto = (id, name) => {
        if (id == null && name == "") return insh.Auto;
        else return { id: id, name: name };
    };

    const loadIdata = (valCust, locStoTypes, Banks) => {
        let locR = getLS("DataRem", {});
        const inveTypeIndex = getInveTypeIndex(valCust.Cust_inv_type);

        setIData({
            ...location.state.idata,
            branch: locR.branchi,
            sales_emp: locR.empi,
            create_user: locR.idi,
            customer_name: valCust.name,
            cust_id: valCust.id,
            inv_type: AutoOptions.types[0].id,
            trans_no: AutoOptions.maxShift.id,
            date: moment(new Date()).format("YYYY-MM-DD"),
        });
        // eds change
    };

    const getCustInvType = (valCust) => {
        setUiElement(insh.UiElement);
        let locR = getLS("DataRem", {});
        if (AutoOptions.Customers[0].Cust_inv_type != null) {
            if (AutoOptions.Customers[0].Cust_inv_type == 0 || AutoOptions.Customers[0].Cust_inv_type == 2 ||
                AutoOptions.Customers[0].Cust_inv_type == 7
            ) {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: false,
                    bank: true,
                });
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);

                setPayment({ ...payment, paidup: 0, stay: 0 });

                setValueStock(AutoOptions.Stocks[0]);
                setSwitchState({ ...switchState, cashORnetworksw: false });
                setLbl({ ...lbl, chashNetwork: transForm("cash") });
                setIData({
                    ...location.state.idata,
                    inv_type: 2,
                    pay_type: 1,
                    bank: 0,
                    cust_id: valCust.id,
                    stock: AutoOptions.Stocks[0].id,
                    customer_name: valCust.name,
                    branch: sto.branchi,
                    sales_emp: sto.empi,
                    create_user: sto.idi,
                    date: moment(new Date()).format("YYYY-MM-DD")
                });
                //setOptionsBank(insh.AutoBankOp);
                setValueType(AutoOptions.types[1]);
            } else if (AutoOptions.Customers[0].Cust_inv_type === 1 || AutoOptions.Customers[0].Cust_inv_type == 6) {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: true,
                    bank: true,
                });
                const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
                setValueStock(reetS);
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);
                setIData({
                    ...location.state.idata,
                    inv_type: 1, pay_type: -1, bank: -1,
                    cust_id: valCust.id,
                    customer_name: valCust.name,
                    branch: sto.branchi,
                    sales_emp: sto.empi,
                    create_user: sto.idi,
                    date: moment(new Date()).format("YYYY-MM-DD")
                });
                setValueType(AutoOptions.types[0]);

            }
            else if (AutoOptions.Customers[0].Cust_inv_type === 3 || AutoOptions.Customers[0].Cust_inv_type === 4 ||
                AutoOptions.Customers[0].Cust_inv_type == 8
            ) {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: false,
                    bank: false,
                });
                setValueStock(AutoOptions.Stocks[0]);
                setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
                setValueBankPMD(AutoOptions.Banks[0]);
                setPayment({ ...payment, paidup: 0, stay: 0 });
                setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: 0 });
                setSwitchState({ ...switchState, cashORnetworksw: true });
                const text = transForm("network").toString();
                setLbl({ ...lbl, chashNetwork: text });


                setIData({
                    ...location.state.idata,
                    inv_type: 2,
                    pay_type: 2,
                    branch: sto.branchi,
                    sales_emp: sto.empi,
                    create_user: sto.idi,
                    bank: AutoOptions.Banks[0].id,
                    cust_id: AutoOptions.Customers[0].id,
                    customer_name: valCust.name, date: moment(new Date()).format("YYYY-MM-DD")
                });
                setValueType(AutoOptions.types[1]); //getAutobanks(0);
            }
        } else {
            setValueStock(AutoOptions.Stocks[0]); //setOptionsBank(insh.AutoBankOp);
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
            setUiElement({
                ...uiElement,
                stock: false,
                payMethod: false,
                bank: true,
            });
            setSwitchState({ ...switchState, cashORnetworksw: false });
            setIData({
                ...location.state.idata, inv_type: 2,
                branch: locR.branchi,
                stock: AutoOptions.Stocks[0].id,
                sales_emp: sto.empi,
                create_user: locR.idi,
                pay_type: 1, bank: 0, cust_id: valCust.id,
                customer_name: valCust.name, date: moment(new Date()).format("YYYY-MM-DD")
            });

            setValueType(AutoOptions.types[1]);

        }
    }
    const changAutoType = (newValue) => {

        console.log(newValue);
        setSwitchState({ ...switchState, cashORnetworksw: false });
        setLbl({ ...lbl, chashNetwork: transForm("cash") });
        setValueType(newValue);

        let invT = newValue.id;
        if (newValue.id === 2) {
            if (switchState.cashORnetworksw === false) {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: false,
                    bank: true,
                });

                setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });

                const reet = reInshAuto(0, "");
                setValueBank(reet);
                setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
                setSwitchState({ ...switchState, cashORnetworksw: false });
                setLbl({ ...lbl, chashNetwork: transForm("cash") });

                setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id, cust_id: valueCustomers.id, customer_name: valueCustomers.name, inv_type: invT });
            }
            else if (switchState.cashORnetworksw == true) {
                setUiElement({ ...uiElement, bank: false });
                setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: idata.netAmount });

                setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
                setSwitchState({ ...switchState, cashORnetworksw: true });
                setLbl({ ...lbl, chashNetwork: transForm("network") });
                setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
                setIData({
                    ...idata,
                    pay_type: 2,
                    bank: AutoOptions.Banks[0].id,
                    cust_id: valueCustomers.id, customer_name: valueCustomers.name,
                    inv_type: invT,
                });
            } else {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: false,
                    bank: true,
                });

                setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });

                const reet = reInshAuto(0, "");
                setValueBank(reet);
                setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
                setSwitchState({ ...switchState, cashORnetworksw: false });
                setLbl({ ...lbl, chashNetwork: transForm("cash") });

                setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id, cust_id: valueCustomers.id, customer_name: valueCustomers.name, inv_type: invT });
            }
        }
        else if (newValue.id === 1) {
            if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) > 0) {
                if (switchState.cashORnetworksw === false) {
                    setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: -1,
                        stock: AutoOptions.Stocks[0].id,
                        cash_part: payment.paidup,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: 0,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        cust_id: valueCustomers.id, customer_name: valueCustomers.name
                    });
                }
                else if (switchState.cashORnetworksw === true) {
                    remains.cashPart = 0;
                    remains.agelPart = payment.stay;
                    remains.networkPart = payment.paidup;
                    remains.bankPart = 0;
                    setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });
                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: valueBank.id,
                        cash_part: 0,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: payment.paidup,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        inv_type: invT,
                        cust_id: valueCustomers.id, customer_name: valueCustomers.name
                    });

                } else {
                    setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: -1,
                        stock: AutoOptions.Stocks[0].id,
                        cash_part: payment.paidup,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: 0,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        cust_id: valueCustomers.id, customer_name: valueCustomers.name
                    });
                }

            } else if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) === 0) {
                setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
                setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

                setRemains({ ...remains, cashPart: 0, agelPart: idata.netAmount, bankPart: 0, networkPart: 0 });


                const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
                setValueStock(reetS);
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);
                setIData({
                    ...idata,
                    pay_type: -1,
                    bank: -1,
                    Remaining: idata.netAmount,
                    Pay_mouny: 0,
                    agel_part: idata.netAmount,
                    inv_type: invT,
                });
            }
            else {
                setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
                setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

                setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
                const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
                setValueStock(reetS);
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);
                setIData({
                    ...idata, pay_type: -1, bank: -1, inv_type: invT
                    , agel_part: payment.stay, Remaining: payment.stay,
                    cash_part: payment.paidup
                });

            }
        }
        console.log(" the inv_type is", invT);
    };

    const changAutoCustomers = async (newValue) => {
        await changCustomers(newValue);
    };
    const changCustomers = async (newValue) => {
        setSwitchState({ ...switchState, cashORnetworksw: false });
        setLbl({ ...lbl, chashNetwork: transForm("cash") });

        let invT = null;
        let checkDesc = null;
        setValueCustomers(newValue);
        newValue.Cust_inv_type == 1 || newValue.Cust_inv_type == 6
            ? setValueType(AutoOptions.types[0])
            : setValueType(AutoOptions.types[1]);
        newValue.Cust_inv_type == 1 || newValue.Cust_inv_type == 6
            ? (invT = AutoOptions.types[0].id)
            : (invT = AutoOptions.types[1].id);

        if (invT === 2) {

            if (newValue.Cust_inv_type != null) {
                if (newValue.Cust_inv_type == 0 || newValue.Cust_inv_type == 2 || newValue.Cust_inv_type == 5 || newValue.Cust_inv_type == 7) {
                    setUiElement({
                        ...uiElement,
                        stock: false,
                        payMethod: false,
                        bank: true,
                    });
                    remains.cashPart = idata.netAmount;
                    remains.agelPart = 0;
                    remains.networkPart = 0;
                    remains.bankPart = 0;

                    payment.paidup = idata.netAmount;
                    payment.stay = 0;

                    idata.pay_type = 1;
                    idata.bank = 0;
                    idata.inv_type = invT;
                    idata.customer_name = newValue.name;
                    idata.cust_id = newValue.id;
                    idata.cash_part = idata.netAmount;
                    idata.agel_part = 0;
                    idata.bank_part = 0;
                    idata.network_part = 0;
                    idata.Remaining = 0;
                    idata.Pay_mouny = idata.netAmount;
                    setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                    setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });


                    const reet = reInshAuto(0, "");
                    setValueBank(reet);
                    setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
                    setSwitchState({ ...switchState, cashORnetworksw: false });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });
                    setIData({
                        ...idata,
                        pay_type: 1,
                        bank: 0,
                        inv_type: invT,
                        customer_name: newValue.name,
                        cust_id: newValue.id,
                    });
                    checkDesc = 1;
                }
                else if (newValue.Cust_inv_type == 3 || newValue.Cust_inv_type == 4 || newValue.Cust_inv_type == 8) {

                    const text = transForm("network").toString();
                    setLbl({ ...lbl, chashNetwork: text });
                    setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
                    setValueBankPMD(AutoOptions.Banks[0]);
                    setUiElement({ ...uiElement, bank: false });
                    setSwitchState({ ...switchState, cashORnetworksw: true });
                    setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: idata.netAmount });
                    setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                    setIData({
                        ...idata,
                        pay_type: 2,
                        bank: AutoOptions.Banks[0].id,
                        inv_type: invT,
                        customer_name: newValue.name,
                        cust_id: newValue.id,
                    });
                    remains.cashPart = 0;
                    remains.agelPart = 0;
                    remains.networkPart = idata.netAmount;
                    remains.bankPart = 0;

                    payment.paidup = idata.netAmount;
                    payment.stay = 0;

                    idata.bank = AutoOptions.Banks[0].id;
                    idata.pay_type = 2;
                    idata.bank = 0;
                    idata.inv_type = invT;
                    idata.customer_name = newValue.name;
                    idata.cust_id = newValue.id;
                    idata.agel_part = 0;
                    idata.bank_part = 0;
                    idata.network_part = 0;
                    idata.Remaining = 0;
                    idata.Pay_mouny = idata.netAmount;
                    idata.cash_part = 0;
                    idata.network_part = idata.netAmount;
                    checkDesc = 1;
                }
            }
            else {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: false,
                    bank: true,
                });
                remains.cashPart = idata.netAmount;
                remains.agelPart = 0;
                remains.networkPart = 0;
                remains.bankPart = 0;

                payment.paidup = idata.netAmount;
                payment.stay = 0;

                idata.bank = AutoOptions.Banks[0].id;
                idata.pay_type = 2;
                idata.bank = 0;
                idata.inv_type = invT;
                idata.customer_name = newValue.name;
                idata.cust_id = newValue.id;
                idata.agel_part = 0;
                idata.bank_part = 0;
                idata.network_part = 0;
                idata.Remaining = 0;
                idata.Pay_mouny = idata.netAmount;
                idata.cash_part = idata.netAmount;
                idata.network_part = 0;
                setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });

                const reet = reInshAuto(0, "");
                setValueBank(reet);
                setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
                setSwitchState({ ...switchState, cashORnetworksw: false });
                setLbl({ ...lbl, chashNetwork: transForm("cash") });

                setIData({
                    ...idata,
                    pay_type: 1,
                    bank: 0,
                    inv_type: invT,
                    customer_name: newValue.name,
                    cust_id: newValue.id,
                });
                checkDesc = 1;

            }
        }
        else if (invT === 1) {

            if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) > 0) {
                if (switchState.cashORnetworksw === false) {
                    payment.paidup = payment.paidup;
                    payment.stay = payment.stay;

                    remains.cashPart = payment.paidup;
                    remains.agelPart = payment.stay;
                    remains.networkPart = 0;
                    remains.bankPart = 0;

                    idata.pay_type = -1;
                    idata.bank = -1;
                    idata.stock = valueStock.id;
                    idata.cash_part = payment.paidup;
                    idata.Pay_mouny = payment.paidup;
                    idata.Remaining = payment.stay;
                    idata.bank_part = 0;
                    idata.network_part = 0;
                    idata.agel_part = payment.stay;
                    idata.emp_part = 0;
                    idata.inv_type = invT;
                    idata.customer_name = newValue.name;
                    idata.cust_id = newValue.id;
                    setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: -1,
                        stock: valueStock.id,
                        cash_part: payment.paidup,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: 0,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        customer_name: newValue.name, cust_id: newValue.id, inv_type: invT,
                    });
                }
                else if (switchState.cashORnetworksw === true) {
                    // setValueBankPMD(AutoOptions.Banks[0]);

                    payment.paidup = payment.paidup;
                    payment.stay = payment.stay;

                    remains.cashPart = 0;
                    remains.agelPart = payment.stay;
                    remains.networkPart = payment.paidup;
                    remains.bankPart = 0;

                    idata.pay_type = -1;
                    idata.bank = valueBank.id;
                    idata.stock = valueStock.id;
                    idata.cash_part = 0;
                    idata.Pay_mouny = payment.paidup;
                    idata.Remaining = payment.stay;
                    idata.bank_part = 0;
                    idata.network_part = payment.paidup;
                    idata.agel_part = payment.stay;
                    idata.emp_part = 0;
                    idata.inv_type = invT;
                    idata.customer_name = newValue.name;
                    idata.cust_id = newValue.id;
                    setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });

                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: valueBank.id,
                        cash_part: 0,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: payment.paidup,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        customer_name: newValue.name, cust_id: newValue.id, inv_type: invT,
                    });
                    checkDesc = 1;

                }
                else {

                    payment.paidup = payment.paidup;
                    payment.stay = payment.stay;

                    remains.cashPart = payment.paidup;
                    remains.agelPart = payment.stay;
                    remains.networkPart = 0;
                    remains.bankPart = 0;


                    idata.pay_type = -1;
                    idata.bank = -1
                    idata.stock = valueStock.id;
                    idata.cash_part = payment.paidup;
                    idata.Pay_mouny = payment.paidup;
                    idata.Remaining = payment.stay;
                    idata.bank_part = 0;
                    idata.network_part = 0;
                    idata.agel_part = payment.stay;
                    idata.emp_part = 0;
                    idata.inv_type = invT;
                    idata.customer_name = newValue.name;
                    idata.cust_id = newValue.id;
                    setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: -1,
                        stock: valueStock.id,
                        cash_part: payment.paidup,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: 0,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        customer_name: newValue.name, cust_id: newValue.id, inv_type: invT,
                    });
                    idata.pay_type = -1;
                    idata.bank = -1
                    idata.stock = valueStock.id;
                    idata.cash_part = payment.paidup;
                    idata.Pay_mouny = payment.paidup;
                    idata.Remaining = payment.stay;
                    idata.bank_part = 0;
                    idata.network_part = 0;
                    idata.agel_part = payment.stay;
                    idata.emp_part = 0;
                    idata.inv_type = invT;
                    idata.customer_name = newValue.name;
                    idata.cust_id = newValue.id;
                    checkDesc = 1;

                }

            }
            else if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) === 0) {
                setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
                setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

                setRemains({ ...remains, cashPart: 0, agelPart: idata.netAmount, bankPart: 0, networkPart: 0 });


                const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
                setValueStock(reetS);
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);


                remains.cashPart = 0;
                remains.agelPart = idata.netAmount;
                remains.networkPart = 0;
                remains.bankPart = 0;

                payment.paidup = 0;
                payment.stay = idata.netAmount;

                idata.pay_type = -1;
                idata.bank = -1;
                idata.stock = valueStock.id;
                idata.Pay_mouny = 0;
                idata.Remaining = idata.netAmount;
                idata.cash_part = 0;
                idata.network_part = 0;
                idata.agel_part = idata.netAmount;
                idata.emp_part = 0;
                idata.bank_part = 0;
                idata.inv_type = invT;
                idata.customer_name = newValue.name;
                idata.cust_id = newValue.id;
                setIData({
                    ...idata,
                    pay_type: -1,
                    bank: -1,
                    Remaining: idata.netAmount,
                    Pay_mouny: 0,
                    agel_part: idata.netAmount,
                    inv_type: invT,
                    customer_name: newValue.name,
                    cust_id: newValue.id,
                });
                checkDesc = 1;
            }
            else {
                setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
                setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

                setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
                const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
                setValueStock(reetS);
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);
                payment.paidup = payment.paidup;
                payment.stay = payment.stay;

                remains.cashPart = payment.paidup;
                remains.agelPart = payment.stay;
                remains.networkPart = 0;
                remains.bankPart = 0;

                idata.pay_type = -1;
                idata.bank = -1;
                idata.stock = valueStock.id;
                idata.Pay_mouny = 0;
                idata.Remaining = payment.stay;
                idata.cash_part = payment.paidup;
                idata.agel_part = payment.stay;
                idata.network_part = 0;
                idata.emp_part = 0;
                idata.bank_part = 0;
                idata.inv_type = invT;
                idata.customer_name = newValue.name;
                idata.cust_id = newValue.id;
                setIData({
                    ...idata,
                    pay_type: -1,
                    bank: -1,
                    inv_type: invT,
                    customer_name: newValue.name,
                    cust_id: newValue.id,
                    agel_part: payment.stay,
                    Remaining: payment.stay,
                    cash_part: payment.paidup
                });
                checkDesc = 1;

            }
        }
        else {
            setIData({
                ...idata,
                customer_name: newValue.name,
                cust_id: newValue.id,
            });
            idata.inv_type = invT;
            idata.customer_name = newValue.name;
            idata.cust_id = newValue.id;
            checkDesc = 1;

        }
        await clickChangeCusomers(newValue);
        //}
        if (AutoOptions?.salesuser?.id == -1 || AutoOptions?.salesuser?.id == 0) {
            if (newValue?.salesmen === 0 || newValue?.salesmen === -1) {
                setValueSalesmen({ ...valueSalesmen, id: -1, name: "بدون" });
                toDoIdata("salesman", -1);
            } else {
                let res_salesman = gets.salesmen.find((obj) => obj.id === newValue?.salesmen);
                if (res_salesman) {
                    setValueSalesmen(res_salesman ?? { ...valueSalesmen, id: -1, name: "بدون" });
                    toDoIdata("salesman", res_salesman?.id ?? -1);
                }
            }
        }
        setSearchCustText("");

        // console.log(" the inv_type is", invT);
    };
    const changAutoSalesMen = (newValue) => {
        setValueSalesmen(newValue);
        toDoIdata("salesman", newValue.id);
    };
    const changAutoEmployee = (newValue) => {
        setValueEmployePMD(newValue);
        toDoIdata("emp", newValue.id);
    };
    const changAutoSafes = (newValue) => {
        setValueSafes(newValue);
        toDoIdata("safe", newValue.id);
    };
    const changAutoStock = (newValue) => {
        setValueStock(newValue);
        toDoIdata("stock", newValue.id);
    };
    const changAutoOmla = (newValue) => {
        setOmlaValue(newValue);
        toDoIdata("omla", newValue.id);
    };
    const changAutoIsharLevel = (newValue) => {
        setValueIsharLevel(newValue);
        toDoIdata("Ishar_level", newValue.id);
    };
    const changAutoCostcenter = (newValue) => {
        setValueCostcenter(newValue);
        toDoIdata("center", newValue.id);
    };
    const changAutoBank = (newValue) => {
        setValueBank(newValue);
        setValueBankPMD(newValue);
        toDoIdata("bank", newValue.id); /*setValueBankPMD(newValue);*/
    };
    const changAutoBankPMD = (newValue) => {
        setValueBankPMD(newValue);
        setRemains({ ...remains, networkId: newValue.id });
        toDoIdata("bank", newValue.id);
    };
    const valueAutoBankPaid = (newValue) => {
        setValueBanksPaid(newValue);
        setRemains({ ...remains, bankId: newValue.id });
        toDoIdata("bank2", newValue.id);
    };

    const changAutoPricePay = (newValue) => {

        setValuePricePay(newValue);
        setValueItemsUnits(optionsCurrUnits[0]);
        setSubInfo({
            ...subInfo,
            perc: 1,
        });
        getTypePrice(newValue);

    };
    const getTypePrice = (newVal) => {
        let newPrice = parseFloat(subInfo.Price);
        let prc = setting.cusType == 1 ? subInfo.salePrice : subInfo.PricePu;

        if (newVal.id === 0) { newPrice = parseFloat(prc); }
        else if (newVal.id === 1) { newPrice = parseFloat(subInfo.dPrice); }
        else if (newVal.id === 2) { newPrice = parseFloat(subInfo.jPrice); }
        else { newPrice = parseFloat(prc); }

        let totbef = (parseFloat(newPrice) * parseFloat(subInfo.val1));
        let tot = (parseFloat(totbef) - parseFloat(subInfo.discount));

        let restaxvalA = maths(
            parseFloat(tot),
            parseFloat(subInfo.taxperc),
            "taxval"
        );
        setSubInfo({
            ...subInfo,
            Price: newPrice,
            totJust: tot,
            taxval: restaxvalA,
            perc: 1,
        });
    };

    const changAutoCurrUnits = (op, newValue) => {
        setIndexUnit(op.nativeEvent.target.dataset.optionIndex);
        setValueItemsUnits(newValue);
        // setValueCurrUnits(newValue);
        LetvalueCurrUnits = newValue;
        insh.stateChang.taxperc = false;

        setValuePricePay(insh.optionPricePay[0]);
        let prc = setting.cusType == 1 ? newValue.sale : newValue.purch;
        let totbef = (parseFloat(prc) * parseFloat(subInfo.val1));
        let tot = (parseFloat(totbef) - parseFloat(subInfo.discount));

        let restaxvalA = maths(
            parseFloat(tot),
            parseFloat(subInfo.taxperc),
            "taxval"
        );
        setSubInfo({
            ...subInfo,
            barcode: newValue.barcode ?? subInfo.barcode,
            Price: setting.cusType == 1 ? newValue.sale : newValue.purch,
            perc: newValue.perc,
            totJust: tot,
            taxval: restaxvalA,
            PricePu: newValue.purch,
            salePrice: newValue.sale,
        });
    };
    const [cuRows, setcuRows] = useState([]);

    const [searchedInvShow, setSearchedInvShow] = useState("");
    const changFavSlides = (val) => {
        // const res = gets.CurrenciesFav.filter((x) => x.favorite === val);
        // setFavGroups(res);
        // setFavGroups(AutoOptions.Items);
    };

    const changSlides = (e, t) => {

    };
    const [checked, setChecked] = useState(insh.Checked);
    const RestAfterGetCurrMathRate = () => {
        setInvDisc(insh.InvDisc);
        afterGetCurrMathRate("");
    };
    const changChcked = (event) => {
        if (
            event.target.name === "discMinusck" ||
            event.target.name === "discRateck"
        ) {
            RestAfterGetCurrMathRate();

            if (event.target.name === "discMinusck") {
                setChecked({
                    ...checked,
                    discMinusck: event.target.checked,
                    discRateck: false,
                });
                setUiElement({ ...uiElement, rate: true, minus: false });
            } else if (event.target.name === "discRateck") {
                setChecked({
                    ...checked,
                    discMinusck: false,
                    discRateck: event.target.checked,
                });
                setUiElement({ ...uiElement, rate: false, minus: true });
            }
        }

        if (event.target.name === "networkck" || event.target.name === "cashck") {
            setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setValueBankPMD(insh.AutoBank); //setOptionsBankPMD(insh.AutoBankOp);

            if (event.target.name === "networkck") {
                setChecked({ ...checked, networkck: true, cashck: false });
                setUiElement({ ...uiElement, bank: false });
                setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
                setValueBankPMD(AutoOptions.Banks[0]); //getAutobanksPMD(0);
            } else if (event.target.name === "cashck") {
                setChecked({ ...checked, networkck: false, cashck: true });
                setUiElement({ ...uiElement, bank: true });
                // setI_Data({...idata, pay_type:1 });
            }
        }

        /* ======== for payment Diloag ======== */
        if (event.target.name == "paymentDiloagck") {
            setChecked({ ...checked, paymentDiloagck: event.target.checked });
        } else if (event.target.name == "network_partck") {
            setChecked({
                ...checked,
                network_partck: event.target.checked,
                cash_partck: true,
            });
            if (event.target.checked === true) {
                setValueBankPMD(AutoOptions.Banks[0]);
        /*getAutobanksPMD(0);*/ changChckedPM("", "", "", "", "bankPM");
                chashVSnetwork(true);
                setUiElement({ ...uiElement, bankPM: false });
            } else if (event.target.checked === false) {
                MathChckedIdata("network_part", idata.network_part);
                changAutosPM("", "", "", "bankPM");
                chashVSnetwork(false);
                setUiElement({ ...uiElement, bankPM: true });
            }
        } else if (event.target.name === "agel_partck") {
            setChecked({
                ...checked,
                agel_partck: event.target.checked,
                cash_partck: true,
            });
            if (event.target.checked === false) {
                MathChckedIdata("agel_part", idata.agel_part);
            }
        } else if (event.target.name === "bank_partck") {
            setChecked({ ...checked, bank_partck: event.target.checked });
            if (event.target.checked === true) {
                setValueBankTransPMD(AutoOptions.Banks[0]);
        /*getAutobanks2PMD(0);*/ changChckedPM("", "", "", "", "bankPM2");
            } else if (event.target.checked === false) {
                MathChckedIdata("bank_part", idata.bank_part);
                changAutosPM("", "", "", "bankPM2");
            }
        } else if (event.target.name === "emp_partck") {
            setChecked({ ...checked, emp_partck: event.target.checked });
            if (event.target.checked === true) {
                setValueEmployePMD(gets.Employees[0]);
        /*getAutoEmployePMD(0);*/ changChckedPM("", "", "", "", "empPM");
            } else if (event.target.checked === false) {
                MathChckedIdata("emp_part", idata.emp_part);
                changAutosPM("", "", "", "empPM");
            }
        } else if (event.target.name === "autoOrStaticck") {
            setChecked({ ...checked, autoOrStaticck: event.target.checked });
        }
    }; // end checked

    const fltringAutoCurrUnits = (chitem) => {
        setIndexUnit(0);
        const res = [];
        setCurrUnitsAll(chitem);
        if (checked.autoOrStaticck == false) {
            setOptionsCurrUnits(chitem);
            // setValueCurrUnits(chitem[0]);
            LetvalueCurrUnits = chitem[0];
        } else LetvalueCurrUnits = chitem[0];
    };

    const handCOpenCu = (Transition) => {
        setBarcodes("");
        if (cuRows?.length == 0) {
            viewHandleSearchInv(-1, false, setFildSearch, null, stor, rptParams,
                setFetching, null, setcuRows, setting, valueSafes, 30);
        }
        setTransition(() => Transition);
        setOpenCuD(true);
    };

    const onRowClicks = (rowData) => {
        setValuePricePay(insh.optionPricePay[permistionInv?.TYPEPRICE ?? 0]);
        if (rowData?.units?.length > 0 && (permistionInv.SIM || ["22", "01", "12", "03", "04"].includes(setting.PrTy_InPr))) {
            const unitF = rowData.units.find((x) => x.unit === rowData.unit);
            let isAuto = checked.autoOrStaticck;
            if (checked.autoOrStaticck === false) {
                setCounts({ curr: 0 });
                setCurrUnit(unitF);
                setValueItemsUnits(unitF);
                setOptionsCurrUnits(rowData.units);
            }
            getDataItemsNoApi(rowData, unitF, setting, permistionInv, valueCustomers, subInfo, setSubInfo,
                invDisc, idata, checked, isdata, setIsData, handSums, isAuto, setItemId, permiCuCo.CWVat);
            setItemId(rowData.id);
        } else {
            const newItem = localCashe.find((obj) => obj.item.barcode.toString() === rowData.barcode.toString());
            if (newItem) {
                if (checked.autoOrStaticck == true) {
                    let oldVal = 0;
                    let totValbef = 0.0;
                    if (permistionInv.SIM == false) {
                        for (let m = 0; m < isdata.length; m++) {
                            if (newItem?.item?.curr == isdata[m].currency_from)
                                totValbef += (isdata[m].val1 * isdata[m].val);
                        };
                        let oldVal = Number(newItem.val) - totValbef;
                    }
                    if (checkValueQ(setting, permistionInv, newItem?.item?.ctype, oldVal) == 0) {
                        getAlertValQ(valueSafes, newItem.val, newItem?.item?.curr, newItem?.item?.perc);
                    } else {
                        addnewItems({ ...newItem?.item }, { ...newItem?.unit }, newItem.units, newItem.val, true);
                    }
                } else {
                    addnewItems({ ...newItem?.item }, { ...newItem?.unit }, newItem.units, newItem.val, false);
                }
            } else {
                if (checked.autoOrStaticck == true) {
                    getBarcodeMulti(rowData?.barcode, false, true);
                } else {
                    getBarcodeMulti(rowData?.barcode, false, false);
                }
            }
        }
        setRptParams({ ...rptParams, barcode: '', barcodeS: '', curr: {}, barcodeNormal: "" });
    };
    const changeCountCurr = (bc) => {
        try {
            const resCurr = [];
            countCurrBySafe.map((x) => {
                if (x.barcode == bc && x.safe == valueSafes.id) resCurr.push(x);
            });
            if (checked.autoOrStaticck === false) {
                resCurr.length != 0
                    ? setCounts({ curr: resCurr[0].Qtys })
                    : setCounts({ curr: 0 });
            } else {
                resCurr.length != 0
                    ? (counts.curr = resCurr[0].Qtys)
                    : (counts.curr = 0);
            }
        } catch (error) {
            alert("هناك خطاء في الصنف قم برماجعة الدعم الفني");
        }
    };

    const retPrmiSDPandSDV = (val, prmPandV, f) => {
        if (val > prmPandV && f === "DiscP") {
            alert(`
قيمة الخصم المدخله أكبر من قيمة الخصم المسموح
قيمة الخصم الممنوحه: ${prmPandV}
سيتم تصفير قيمة الخصم .. قم بإدخال القيمة المسموح بها مره أخرى والتي أعلى قيمه لها : ${prmPandV}
      `);
            return "";
        } else if (val > prmPandV && f === "DiscC") {
            alert(`
قيمة الخصم المدخله أكبر من قيمة الخصم المسموح
قيمة الخصم الممنوحه: ${prmPandV}
سيتم تصفير قيمة الخصم .. قم بإدخال القيمة المسموح بها مره أخرى والتي أعلى قيمه لها : ${prmPandV}
      `);
            return "";
        }
    };


    const changInfo = (prop) => (event) => {
        if (prop === "discount") {
            subInfo.DiscPers = (
                (event.target.value * 100) /
                parseFloat(subInfo.val1 * subInfo.Price)
            ).toFixed(2);
            let ret = null;
            if (permistionInv.SDV !== 0)
                ret = retPrmiSDPandSDV(
                    parseFloat(event.target.value),
                    permistionInv.SDV,
                    "DiscC"
                );
            else ret = retPrmiSDPandSDV(subInfo.DiscPers, permistionInv.SDP, "DiscP");
            if (ret === "") {
                event.target.value = "";
                subInfo.DiscPers = "";
            }
        } else if (prop === "DiscPers") {
            subInfo.discount = (
                parseFloat(subInfo.val1 * subInfo.Price) *
                (event.target.value / 100)
            ).toFixed(2);
            let ret = null;
            if (permistionInv.SDP !== 0)
                ret = retPrmiSDPandSDV(
                    parseFloat(event.target.value),
                    permistionInv.SDP,
                    "DiscP"
                );
            else ret = retPrmiSDPandSDV(subInfo.discount, permistionInv.SDV, "DiscC");
            if (ret === "") {
                event.target.value = "";
                subInfo.discount = "";
            }
        } else if (prop === "Price") {
            subInfo.discount = (
                parseFloat(subInfo.val1 * event.target.value) *
                (subInfo.DiscPers / 100)
            ).toFixed(2);
            subInfo.totJust = parseFloat(subInfo.val1 * event.target.value).toFixed(2);
            subInfo.taxval = parseFloat(
                (subInfo.totJust * subInfo.taxperc) / 100
            ).toFixed(2);
        } else if (prop === "totJust") {
            let prce = parseFloat(event.target.value / subInfo.val1).toFixed(2);
            subInfo.Price = prce;
            subInfo.discount = (
                parseFloat(subInfo.val1 * prce) *
                (subInfo.DiscPers / 100)
            ).toFixed(2);
            subInfo.taxval = parseFloat(
                (subInfo.totJust * subInfo.taxperc) / 100
            ).toFixed(2);
        } else if (prop === "val1") {
            subInfo.discount = (
                parseFloat(event.target.value * subInfo.Price) *
                (subInfo.DiscPers / 100)
            ).toFixed(2);
            subInfo.totJust = parseFloat(event.target.value * subInfo.Price).toFixed(
                2
            );
            subInfo.taxval = parseFloat(
                (subInfo.totJust * subInfo.taxperc) / 100
            ).toFixed(2);
        } else if (prop === "taxperc") {
            subInfo.taxval = parseFloat(
                (subInfo.totJust * event.target.value) / 100
            ).toFixed(2);
        }

        setSubInfo({ ...subInfo, [prop]: event.target.value });
    };

    const changInvs = (prop) => (event) => {
        setInfoInv({ ...infoInv, [prop]: event.target.value });
        setIData({ ...idata, InvId_Return: event.target.value });
    };

    const handClickInvs = async () => {
        if (infoInv.InvId_Return === "") {
            handOSnack({
                vertical: "top",
                horizontal: "right",
                severit: "warning",
                text: "أدخل رقم المرتجع",
                time: 2000,
            });
        } else {
            let IsSalesman = AutoOptions?.salesuser?.id == -1 || AutoOptions?.salesuser?.id == 0 ? false : true,

                EmpSales = false,

                isExsist = false,

                // pipt = setting.PrTy_InPr == "12" ? "02" : "01",
                // piptName = setting.PrTy_InPr == "12" ? "مبيعات" : "مشتريات";
                pipt = ["12", "149", "150"].includes(setting.PrTy_InPr) ? "02" : "01",
                piptName = ["12", "149", "150"].includes(setting.PrTy_InPr) ? "مبيعات" : "مشتريات";
            await axios
                .get(
                    uri + `InvRet?PcIdIvPc=${setting.PrTy_InPr}&&branch=${sto.branchi}`
                )
                .then((res) => {
                    console.log("res.data");
                    console.log(res.data);

                    for (let i = 0; i < res.data.length; i++) {
                        if (
                            parseInt(res.data[i].InvId_Return) ==
                            parseInt(infoInv.InvId_Return)
                        )
                            isExsist = true;


                    }
                })
                .catch((error) => { });
            if (isExsist == true) {
                handOSnack({
                    vertical: "top",
                    horizontal: "right",
                    severit: "warning",
                    text: `فاتورة ${piptName} المدخلة تم إرجاعها مسبقا`,
                    time: 4000,
                });
            }
            else {
                await axios
                    .get(
                        uri +
                        `InvRet?id=${infoInv.InvId_Return}&&PcIdIvPc=${pipt}&&branch=${sto.branchi}`
                    )
                    .then((res) => {
                        if (res.data?.sales_emp != sto.empi) {
                            EmpSales = IsSalesman == false ? false : true;
                            if (IsSalesman == true) {
                                handOSnack({
                                    vertical: "top",
                                    horizontal: "center",
                                    severit: "warning",
                                    text: "فاتورة المبيعات المراد ارجاعها تم ادخالها من قبل موظف اخر",
                                    time: 4000,
                                });
                            } else {
                                if (AutoOptions?.StepTwo?.id == 1 && !isUpdateDate && setting.PrTy_InPr === "12") {
                                    showChosedInv(false, res.data.proc_id, true);
                                } else {
                                    if (permistionInv?.SAMEDATE) {
                                        showChosedInv(false, res.data.proc_id, false);
                                    } else {
                                        showChosedInv(false, res.data.proc_id, true);
                                    }
                                }

                                setOr({ ...or, postput: "toPost" });
                            }
                        } else {
                            if (AutoOptions?.StepTwo?.id == 1 && !isUpdateDate && setting.PrTy_InPr === "12") {
                                showChosedInv(false, res.data.proc_id, true);
                            } else {
                                if (permistionInv?.SAMEDATE) {
                                    showChosedInv(false, res.data.proc_id, false);
                                } else {
                                    showChosedInv(false, res.data.proc_id, true);
                                }
                            }

                            setOr({ ...or, postput: "toPost" });

                        }

                    })
                    .catch((error) => {
                        handOSnack({
                            vertical: "top",
                            horizontal: "right",
                            severit: "warning",
                            text: "رقم المرتجع غير موجود",
                            time: 2000,
                        });
                    });
            } // else c
        } // else m

        // eds changes
        if (!stor.hasOwnProperty("comt")) setStor({ ...stor, comt: -1 });
    };
    const beZero = () => {
        setStor({ ...stor, comt: -1 });
        if (subInfo.discount === "") subInfo.discount = 0;
        if (subInfo.DiscPers === "") subInfo.DiscPers = 0;
        if (subInfo.Price === "") subInfo.Price = 0;
        if (subInfo.val1 === "") subInfo.val1 = 0;
        if (subInfo.perc === "") subInfo.perc = 0;
        if (subInfo.taxperc === "") subInfo.taxperc = 0;
        if (subInfo.taxval === "") subInfo.taxval = 0;
        if (subInfo.totJust === "") subInfo.totJust = 0;
    };

    const getrowDataCurrencie = async (props) => {
        beZero();
        or.cros = "newRow";
        or.PrAC = 0;
        let maxQty = parseFloat(permistionInv?.MAXQTY ?? 100000);
        let maxPrice = parseFloat(permistionInv?.MAXPRICE ?? 100000);
        if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03") {
            if (subInfo.barcode != "") {
                if (parseFloat(subInfo.val1) != 0) {
                    let val1InSub = 0,
                        countsCurr = 0,
                        minCurrPrice = 0,
                        subInfoVal1_perc = subInfo.val1 * subInfo.perc;
                    minCurrPrice = (parseFloat(subInfo.minPrice) * parseFloat(subInfo.perc)).toFixed(2);
                    for (let m = 0; m < isdata.length; m++) {
                        if (subInfo.barcode == isdata[m].barcode)
                            val1InSub = isdata[m].val1;
                    }
                    countsCurr = Number(subInfo.Qtys) - parseInt(val1InSub);

                    if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12") {

                        if (permistionInv.SNOP === true
                            && subInfo != null && parseFloat(subInfo.Price) < parseFloat(subInfo.PricePu)) {
                            alert(
                                permiCuCo.HPP ? `لا يمكن البيع اقل من سعر الشراء للصنف ` :
                                    `لا يمكن البيع اقل من سعر الشراء للصنف سعر الشراء المسجل للصنف هو : ${subInfo.PricePu}`
                            );
                        }
                        else if (parseFloat(subInfo.val1) > parseFloat(maxQty)) {
                            alert(
                                `لقد تجاوزت حد الكمية المسموح فيها... برجاء الذهاب لاعدادات النظام لزيادة الحد: ${maxQty}`
                            );
                        }
                        else if (parseFloat(subInfo.Price) > parseFloat(maxPrice)) {
                            alert(
                                `لقد تجاوزت حد السعر المسموح فيه... برجاء الذهاب لاعدادات النظام لزيادة الحد:  ${maxPrice}`
                            );
                        }
                        else if (permistionInv.SNOMIN === 1 && parseFloat(subInfo.Price) < parseFloat(minCurrPrice)) {
                            alert(
                                `لا يمكن البيع اقل من السعر الادنى للصنف السعر الادنى المسجل للصنف هو : ${minCurrPrice}`
                            );
                        } else if (permistionInv.ASPZ === false && subInfo.Price <= 0) {
                            alert(
                                `لا يوجد لديك صلاحية البيع بسعر صفر `
                            );
                        }
                        else if (permistionInv.SIM == false &&
                            countsCurr < subInfoVal1_perc && subInfo.type != 4 &&
                            (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
                            alert(
                                `
              الكمية المدخلة للصنف أكبر من رصيد المخزن
              الكمية الاجمالية المدخلة : ${parseFloat(subInfo.val1) * parseFloat(subInfo.perc)
                                }
              رصيد المخزن : ${valueSafes.name} = ${parseInt(counts.curr) - parseInt(val1InSub)
                                }
              `
                            );
                        }
                        else if (permistionInv.APDC === 1 && permistionInv.DSOI == 1 && parseFloat(subInfo.DiscPers) > parseFloat(permistionInv.SDP)) {
                            alert(
                                `
              لقد تجاوزت نسبة الخصم المسموح بها
              نسبة الخصم المسموح بها : ${parseFloat(permistionInv.SDP)
                                }
              `
                            );
                        }
                        else if (permistionInv.APDC === 2 && permistionInv.DSOI == 1 && parseFloat(subInfo.discount) > parseFloat(permistionInv.SDV)) {
                            alert(
                                `
              لقد تجاوزت مبلغ الخصم المسموح بها
              مبلغ الخصم المسموح بة : ${parseFloat(permistionInv.SDV)
                                }
              `
                            );
                        }
                        else if (permistionInv.APDC === 3 && permistionInv.DSOI == 1 &&
                            ((parseFloat(permistionInv.SDV) != 0 && subInfo.discount > permistionInv.SDV) ||
                                (parseFloat(permistionInv.SDP) != 0 && parseFloat(subInfo.DiscPers) > parseFloat(permistionInv.SDP)))) {
                            alert(
                                `
              لقد تجاوزت حد الخصم المسموح بها
                }
              `
                            );
                        } else if (parseFloat(subInfo.val1) < 0 || parseFloat(subInfo.val1) == 0) {
                            alert(
                                `
            لا يمكن تنزيل الصنف بكمية سالبة او صفرية
                }
              `
                            );
                        } else if (parseFloat(subInfo.Price) < 0) {
                            alert(
                                `
              لا يمكن البيع بقيمة سالبة
                }
              `
                            );
                        }
                        else {
                            for (let m = 0; m < isdata.length; m++) {
                                if (
                                    parseInt(subInfo.Price) ==
                                    parseInt(isdata[m].new_exchange_price) &&
                                    subInfo.barcode == isdata[m].barcode
                                ) {
                                    or.cros = "rnewRow";
                                    or.i = m;
                                    break;
                                } else {
                                    or.cros = "newRow";
                                }
                            }
                            await handRowAdd(or);
                            if (props === "dialog") { await handleCloseCuDWithSWState(); }
                            await handleClDia("fav", false);
                            await setSubInfo(insh.InfoSub);
                            if (props === "main") {
                                await setRptParams({ ...rptParams, barcodeNormal: '', barcodeS: '', curr: {} });
                            }
                            setCurrUnit([]);
                            setOptionsCurrUnits([]);
                        }
                    } else if (setting.PrTy_InPr === "03") {
                        if (permistionInv.SNOP === true
                            && subInfo != null && parseFloat(subInfo.Price) < parseFloat(subInfo.PricePu)) {
                            alert(
                                `لا يمكن البيع اقل من سعر الشراء للصنف سعر الشراء المسجل للصنف هو : ${subInfo.PricePu}`
                            );
                        } else {
                            for (let m = 0; m < isdata.length; m++) {
                                if (
                                    parseInt(subInfo.Price) ==
                                    parseInt(isdata[m].new_exchange_price) &&
                                    subInfo.barcode == isdata[m].barcode
                                ) {
                                    or.cros = "rnewRow";
                                    or.i = m;
                                    break;
                                } else {
                                    or.cros = "newRow";
                                }
                            }
                            await handRowAdd(or);
                            if (props === "dialog") { await handleCloseCuDWithSWState(); }
                            await handleClDia("fav", false);
                            await setSubInfo(insh.InfoSub);
                            if (props === "main") {
                                await setRptParams({ ...rptParams, barcodeNormal: '', barcodeS: '', curr: {} });
                            }
                            setCurrUnit([]);
                            setOptionsCurrUnits([]);
                        }
                    }
                    else {
                        for (let m = 0; m < isdata.length; m++) {
                            if (
                                parseInt(subInfo.Price) ==
                                parseInt(isdata[m].new_exchange_price) &&
                                subInfo.barcode == isdata[m].barcode
                            ) {
                                or.cros = "rnewRow";
                                or.i = m;
                                break;
                            } else {
                                or.cros = "newRow";
                            }
                        }

                        await handRowAdd(or);
                        if (props === "dialog") { await handleCloseCuDWithSWState(); }
                        await handleClDia("fav", false);
                        await setSubInfo(insh.InfoSub);
                        if (props === "main") {
                            setRptParams({ ...rptParams, barcodeNormal: '', barcodeS: '', curr: {} });
                        }
                        setCurrUnit([]);
                        setOptionsCurrUnits([]);
                        // setAllowKeyboard(false);
                    }
                } /* end Val1 */ else {
                    alert("لا يمكنك التنزيل الكمية 0");
                }
            } /* end barcode */ else {
                alert("لا يوجد باركود للصنف تحقق من البيانات");
            }
        } else {
            if (subInfo.barcode !== "") {
                if (parseFloat(subInfo.val1) !== 0) {
                    let val1InSub = 0;
                    for (let m = 0; m < isdata.length; m++) {
                        if (subInfo.barcode == isdata[m].barcode)
                            val1InSub = isdata[m].val1;
                    }

                    if (permistionInv.ASPZ === 1 || subInfo.Price > 0) {
                        for (let m = 0; m < isdata.length; m++) {
                            if (
                                parseInt(subInfo.Price) ==
                                parseInt(isdata[m].new_exchange_price) &&
                                subInfo.barcode == isdata[m].barcode
                            ) {
                                or.cros = "rnewRow";
                                or.i = m;
                                break;
                            } else {
                                or.cros = "newRow";
                            }
                        }

                        await handRowAdd(or);
                        if (props === "dialog") { await handleCloseCuDWithSWState(); }
                        await setSubInfo(insh.InfoSub);
                        if (props === "main") {
                            await setRptParams({ ...rptParams, barcodeNormal: '', barcodeS: '', curr: {} });
                        }
                        setCurrUnit([]);
                        setOptionsCurrUnits([]);
                        // setAllowKeyboard(false);
                    } /* price > 0 */ else alert("السعر اقل من صفر");
                } /* end Val1 */ else {
                    alert("لا يمكنك التنزيل الكمية 0");
                }
            } /* end barcode */ else {
                alert("لا يوجد باركود للصنف تحقق من البيانات");
            }
        }
    };

    // const noGetThings = () => { return null;}
    const noGetThings = () => { };
    const [procIdSearch, setProcIdSearch] = useState(0);
    const [openButtonsSearch, setOpenButtonsSearch] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [value, setValue] = React.useState(0);
    const [valueE, setValueE] = React.useState(0);

    const AutoItem = permistionInv?.AUTI === null ? true : permistionInv?.AUTI;
    const [autoNormal, setAutoNormal] = useState(AutoItem);
    const downItemsType = () => (event) => {
        if (!autoNormal === true) {
            setAutoNormal(!autoNormal);
        } else {
            setAutoNormal(!autoNormal);
        }
    };

    const isMobileDevice = () => {
        return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
    };
    const keepFocus = () => {
        if (autoNormal && inputRef.current) {
            inputRef.current.focus();
        } else if (!autoNormal && !isMobileDevice) {
            document.getElementById("barcodenormal").focus();
        }
    };
    const handNewInv = () => {
        setIsLoading(false);
        isSavingRef.current = false;
        if (isDialog == true) {
            props.onClose();
            return;
        }
        // setPrmiCuCo(AutoOptions.permiCuCo);
        setFiles([]);
        setOpenPrint({ open: false, localInv: {}, invType: 1, invKind: 1 });
        setValue(0);
        setExpenseList([]);
        setIsUpdateDate(false);
        setProcIdSearch(0);
        if(!permistionInv.SIM){
            setLocalCashe([]);
            setCacheItems([]);
        }
        setOpenButtonsSearch(false);
        setIshedden(false);
        setIsOpenUpdate(false);
        setPdfToggle(null);
        reLoadLastInv();
        setIsData([]);
        setValueCustomers(AutoOptions.Customers[0]); //getAutoCustomers(0);
        setValueSalesmen(AutoOptions?.salesuser);
        setValueCostcenter(AutoOptions?.centerUser);
        setValueStock(AutoOptions.Stocks[0]); //getAutoStocks(0);
        setOmlaValue(getDefaultOmla(gets.omlats));
        let custTypePay = Number(AutoOptions.Customers[0].Cust_inv_type);
        const defStock = AutoOptions.Stocks[0];
        const defCust = AutoOptions.Customers[0];
        const defBank = AutoOptions.Banks[0];

        if (custTypePay != null) {
            if (custTypePay == 0 || custTypePay == 2 || custTypePay == 7) {
                setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
                setUiElement({ ...uiElement, bank: true });
                setSwitchState({ ...switchState, cashORnetworksw: false });
                setLbl({ ...lbl, chashNetwork: transForm("cash") });
                setUiElement({ ...uiElement, bank: true });
                setIData({
                    ...location.state.idata,
                    inv_type: 2, pay_type: 1, bank: 0, cust_id: defCust.id,
                    customer_name: defCust.name,
                    date: keepDate && setting.PrTy_InPr === "01" ? dateKeep.Date : moment(new Date()).format("YYYY-MM-DD")
                    , trans_no: AutoOptions.maxShift.id, stock: defStock.id,
                });
                // setValueStock(AutoOptions.Stocks[0]); //setOptionsBank(insh.AutoBankOp);
                setValueType(AutoOptions.types[1]);
            } else if (custTypePay === 1 || custTypePay === 6) {
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);
                setValueBankPMD(reetB); //getAutobanks(0);
                setIData({
                    ...location.state.idata, inv_type: 1, pay_type: -1, bank: -1, cust_id: defCust.id,
                    customer_name: defCust.name,
                    date: keepDate && setting.PrTy_InPr === "01" ? dateKeep.Date : moment(new Date()).format("YYYY-MM-DD"),
                    trans_no: AutoOptions.maxShift.id, stock: defStock.id,
                });
                setValueType(AutoOptions.types[0]);
            } else if (custTypePay == 3 || custTypePay == 4 || custTypePay == 8) {
                const text = transForm("network").toString();
                setLbl({ ...lbl, chashNetwork: text });
                setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
                setValueBankPMD(AutoOptions.Banks[0]); //getAutobanks(0);
                setUiElement({ ...uiElement, bank: false });
                setSwitchState({ ...switchState, cashORnetworksw: true });
                setValueType(AutoOptions.types[1]); //getAutobanks(0);
                setIData({
                    ...location.state.idata, inv_type: 2, pay_type: 2, bank: defBank.id, cust_id: defCust.id,
                    customer_name: defCust.name, stock: defStock.id,
                    date: keepDate && setting.PrTy_InPr === "01" ? dateKeep.Date : moment(new Date()).format("YYYY-MM-DD"),
                    trans_no: AutoOptions.maxShift.id,
                });
            }
        } else {
            setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setValueBankPMD(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
            setUiElement({ ...uiElement, bank: true });
            setSwitchState({ ...switchState, cashORnetworksw: false });
            setIData({
                ...location.state.idata, inv_type: 2, pay_type: 1, bank: 0, cust_id: defCust.id,
                customer_name: defCust.name, stock: defStock.id,
                date: keepDate && setting.PrTy_InPr === "01" ? dateKeep.Date : moment(new Date()).format("YYYY-MM-DD"),
                trans_no: AutoOptions.maxShift.id,
            });
            // setValueStock(AutoOptions.Stocks[0]); //setOptionsBank(insh.AutoBankOp);
            setValueType(AutoOptions.types[1]);
            setRemains(insh.Remains);
        }
        setValueSafes(AutoOptions.Safes[0]);
        setSums(insh.Sums);
        setStor({ ...stor, comt: -1 });
        setExSub(0);
        setPayment(insh.Payment);
        setIsClick(insh.ished);
        setRemains(insh.Remains);
        setChecked({
            ...checked,
            costWithVat: true,
            discMinusck: false,
            discRateck: false,
            networkck: false,
            cashck: true,
            network_partck: false,
            cash_partck: false,
            agel_partck: false,
            bank_partck: false,
            emp_partck: false,
        });
        setOr(insh.Or);
        setIshed(insh.ished);
        setOptionsItemsSearch(AutoOptions?.InvItems);
        setInvDisc(insh.InvDisc);
        keepFocus();
    };

    const goAlert = () => {
        handOSnack({
            vertical: "top",
            horizontal: "center",
            severit: "warning",
            // background: isPurches ? "#008080" : isStock ? "#3f51b5" : colors.green[500],
            text: `
      لقد تجاوزت نسبة الخصم المسموح بها
      نسبة الخصم المسموح بها : ${parseFloat(permistionInv.SDP)
                }`,
            time: 2000,
        });
        return 0;
    };
    const goAlertV = () => {
        alert(`
    لقد تجاوزت مبلغ الخصم المسموح به
    مبلغ الخصم المسموح بها : ${parseFloat(permistionInv.SDV)
            }`
        );

        return 0;
    };
    const goAlertVal = () => {

        return 1;
    };

    let templatePrintFile = '';
    const [editRow, setEditRow] = useState(null);
    const changAutoCurrUnits2 = (row, newValue) => {

        let prc = setting.cusType == 1 ? newValue.sale : newValue.purch;
        let tot = (parseFloat(prc) * parseFloat(row.val1));
        let desc_mount = (
            parseFloat(tot) *
            (row.DiscPers / 100)
        );
        let totbef = (parseFloat(tot) - parseFloat(desc_mount));

        let taxMount = maths(
            parseFloat(totbef),
            parseFloat(row.taxperc),
            "taxval"
        );
        let betTax = maths(
            parseFloat(totbef),
            parseFloat(row.taxperc),
            "before_vat"
        );

        let resNetA = maths(
            parseFloat(totbef),
            parseFloat(row.taxperc),
            "Net"
        );
        let tot_before_vat_with_tab3val = 0;
        if (parseFloat(row?.tab3val_sub) > 0 && parseFloat(row.taxperc) > 0 && permistionInv?.USETOBACO) {
            let tot_before_new = maths(
                parseFloat(prc),
                parseFloat(row.taxperc),
                "before_vat"
            );
            tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                (parseFloat(25) * row.val1) : parseFloat(betTax).toFixed(2);

            let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

            taxMount = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(row.taxperc),
                "taxval"
            );

            resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                + parseFloat(taxMount)).toFixed(2);
        }
        let val1 = row.val1 == 0 ? 1 : row.val1;
        let itemType = Number(row?.type);

        let subInfoVal1_perc = row.val1 * newValue.perc;
        let countsCurr = parseInt(row?.Qtys ?? 0) - parseInt(val1);
        if (permistionInv.SIM == false &&
            countsCurr < subInfoVal1_perc && itemType != 4 &&
            (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
            const index = row?.no;
            setEditRow(null);
            handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text: "الكمية المدخلة للصنف أكبر من رصيد المخزن",
                time: 2000,
            });
        } else {
            const index = row?.no;
            const dataUpdate = [...isdata];
            dataUpdate[index] = {
                ...row,
                totJust: tot,
                totAfterDisc: betTax,
                taxval: taxMount,
                netAmountSub: resNetA,
                new_exchange_price: setting.cusType == 1 ? newValue.sale : newValue.purch,
                perc: newValue.perc,
                PricePu: newValue.purch,
                unitame: newValue.unitName,
                unit: newValue.unit,
                val: newValue.perc,
                defUnit: newValue,
                discount: desc_mount,
                tab3val_sub: tot_before_vat_with_tab3val,
                tab3Val: tot_before_vat_with_tab3val,
                editAbleUnit: false,
            };
            setIsData([...dataUpdate]);
            handSums(dataUpdate);
            setEditRow(null);
        }
    };
    var columnsInvSub = [
        { title: "المعرف", field: "id", hidden: true, rowStyle: stElemnt.SubR },
        {
            title: transForm("item_number"),
            field: "currency_from",
            hidden: true,
            rowStyle: stElemnt.SubR,
        },
        {
            title: transForm("barcode_number"),
            field: "barcode",
            editable: "never",
            rowStyle: stElemnt.SubR,
        },
        {
            title: transForm("item"),
            field: "symbol",
            editable: "never",
            rowStyle: stElemnt.SubMu,
        },
        {
            title: transForm("unit"),
            field: "unitame",
            editable: "never",
            rowStyle: stElemnt.SubR,
            render: (rowData) => {
                const isEdit = editRow === rowData.tableData.id;

                if (isEdit && rowData?.UnitsTable?.length > 1) {
                    return (
                        <Autocomplete
                            autoHighlight
                            openOnFocus
                            classes={clasAo}
                            value={isdata.find(x => x.no === rowData.no || null)}
                            onChange={(event, newValue) => {
                                changAutoCurrUnits2(rowData, newValue);
                            }}
                            id="combo-box-demo"
                            options={rowData?.UnitsTable}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.unitName
                            }
                            onBlur={(e) => setEditRow(null)}
                            disableClearable
                            style={{ backgroundColor: colors.green[50] }}
                            fullWidth
                            variant="outlined"
                            size="small"
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={"الوحدة"}
                                    variant="outlined"
                                />
                            )}

                        />
                    )
                }

                return (
                    <div
                        onDoubleClick={(event) => setEditRow(rowData.tableData.id)}
                    // style={stElemnt.SubR}
                    >
                        {rowData.unitame}
                    </div>
                )
            }
        },
        {
            title: transForm("quanity"),
            field: "val1",
            editComponent: (props) => (
                <TextField
                    variant="outlined"
                    size="small"
                    className={[clasTF.rootmt, clasTF.mtTval1]}
                    InputProps={{ className: clasTF.input }}
                    value={props.value}
                    onChange={(e) => props.onChange(e.target.value)}
                />
            ),
            rowStyle: stElemnt.SubR,
        },
        {
            title: transForm("packaging"),
            field: "val",
            editable: "never",
            rowStyle: stElemnt.SubR,
        },
        {
            title: transForm("price"),
            field: "new_exchange_price",
            type: "numeric",
            editable: "always",
            editComponent: (props) => (
                <TextField
                    disabled={!permistionInv.USP}
                    variant="outlined"
                    size="small"
                    className={[clasTF.rootmt, clasTF.mtTpric]}
                    InputProps={{ className: clasTF.input }}
                    value={props.value}
                    onChange={(e) => props.onChange(e.target.value)}
                />
            ),
            rowStyle: stElemnt.SubR,
        },
        {
            title: transForm("total"),
            field: "totJust",
            editable: "never",
            rowStyle: stElemnt.SubR,
        },

        {
            title: transForm("discount_mount"),
            field: "discount",
            type: "numeric",
            editable: "always",
            editComponent: (props) => (
                <TextField
                    id="discount"
                    name="discount"
                    disabled={
                        (permistionInv.APDC === 2 || permistionInv.APDC === 3) && permistionInv.DSOI == 1
                            ? false
                            : true
                    }
                    variant="outlined"
                    size="small"
                    className={clasTF.rootmt}
                    InputProps={{ className: clasTF.input }}
                    value={props.value}
                    onChange={(e) =>
                        props.onChange(
                            e.target.value > permistionInv.SDV ? goAlertV() : e.target.value === "" ? goAlertVal() : e.target.value
                        )
                    }
                />
            ),
            rowStyle: stElemnt.SubR,
        },
        {
            title: transForm("discount_perc"),
            field: "DiscPers",
            type: "numeric",
            //editable:nevEve,
            editable: "always",
            editComponent: (props) => (
                <TextField
                    disabled={
                        (permistionInv.APDC === 1 || permistionInv.APDC === 3) && permistionInv.DSOI == 1
                            ? false
                            : true
                    }
                    variant="outlined"
                    size="small"
                    className={[clasTF.rootmt, clasTF.mtTdisc]}
                    InputProps={{ className: clasTF.input }}
                    value={props.value}
                    onChange={(e) =>
                        props.onChange(
                            e.target.value > permistionInv.SDP ? goAlert() : e.target.value === "" ? goAlertVal() : e.target.value
                        )
                    }
                />
            ),
            rowStyle: stElemnt.SubR,
        },
        {
            title: transForm("total_after_discount"),
            field: "totAfterDisc",
            editable: "never",
            rowStyle: stElemnt.SubR,
        },
        {
            title: transForm("tobacco_tax"),
            field: "tab3Val",
            editable: "never",
            rowStyle: stElemnt.SubR,
        },
        {
            title: transForm("vat_perc"),
            field: "taxperc",
            editable: "never",
            rowStyle: stElemnt.SubR,
        },
        {
            title: transForm("vat_total"),
            // title: "إجمالي القيمة المضافة",
            field: "taxval",
            editable: "never",
            rowStyle: stElemnt.SubR,
        },
        {
            title: transForm("net"),
            field: "netAmountSub",
            editable: "never",
            rowStyle: stElemnt.SubR,
        },
        {
            title: "ملاحظات",
            field: "",
            hidden: true,
            editComponent: (props) => (
                <TextField
                    variant="outlined"
                    size="small"
                    className={clasTF.rootmt}
                    InputProps={{ className: clasTF.input }}
                    value={props.value}
                    onChange={(e) => props.onChange(e.target.value)}
                />
            ),
            hidden: true,
            rowStyle: stElemnt.SubR,
        },
        {
            title: transForm("note"),
            field: "notes",
            editComponent: (props) => (
                <TextField
                    variant="outlined"
                    size="small"
                    className={[clasTF.rootmt, clasTF.mtTnote]}
                    InputProps={{ className: clasTF.input }}
                    value={props.value}
                    onChange={(e) => props.onChange(e.target.value)}
                />
            ),
            rowStyle: stElemnt.SubR,
        },

        {
            title: setting.priceNM,
            field: "sale_price",
            hidden: true,
            editComponent: (props) => (
                <TextField
                    variant="outlined"
                    size="small"
                    className={[clasTF.rootmt, clasTF.mtTpric]}
                    InputProps={{ className: clasTF.input }}
                    value={props.value}
                    onChange={(e) => props.onChange(e.target.value)}
                />
            ),
            rowStyle: stElemnt.SubR,
        },
    ];

    const befPushTos = async () => {
        addChangds();
    };

    let his = useHistory();
    const [base64String, setBase64String] = useState();
    const [generating, setGenerating] = useState(false);

    const isWindows = navigator.userAgent.includes("Windows");
    const toPrint = async (type, e, hist) => {
        if (hist === 1 && permistionInv?.AUTOPRINT && isWindows) {
            or.PrAC = 3;
        } else if (!isWindows && permistionInv?.AUTOPRINT && hist === 3) {
            or.PrAC = 1;
        }
        else {
            or.PrAC = hist;
        }
        if (isdata.length == 0) {
            handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text: transForm("most_download_item"),
                time: 2000,
            });
        } else {
            await toWhere(type, e);
        }
    };

    const toPrintCashOrNetwork = async (type, e, hist, valChecked) => {
        let isSave = 0;
        if (valChecked == true && valueType.id !== 1) {
            const text = transForm("network").toString();
            setLbl({ ...lbl, chashNetwork: text });
            setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
            setValueBankPMD(AutoOptions.Banks[0]); //getAutobanks(0);
            setUiElement({ ...uiElement, bank: false });
            setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });

            setIData({ ...idata, pay_type: 2, bank: AutoOptions.Banks[0].id });
            isSave = 1;

            setValueType(AutoOptions.types[1]);

            remains.networkPart = idata.netAmount;
            remains.agelPart = 0;
            remains.bankPart = 0;
            remains.cashPart = 0;
            idata.bank = AutoOptions.Banks[0].id
            idata.pay_type = 2;
            idata.inv_type = 2;
            idata.cash_part = 0;
            idata.agel_part = 0;
            idata.bank_part = 0;
            idata.network_part = idata.netAmount;

            setChecked({
                ...checked,
                cash_partck: false,
                network_partck: true,
                agel_partck: false,
            });
            isSave = 1;

        } else if (valChecked == false && valueType.id !== 1) {
            setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
            setUiElement({ ...uiElement, bank: true, stock: false });
            setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id });
            setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

            setValueType(AutoOptions.types[1]);
            remains.cashPart = idata.netAmount;
            remains.agelPart = 0;
            remains.bankPart = 0;
            remains.networkPart = 0;
            idata.pay_type = 1;
            idata.inv_type = 2;
            idata.cash_part = idata.netAmount;
            idata.agel_part = 0;
            idata.bank_part = 0;
            idata.network_part = 0;

            setChecked({
                ...checked,
                cash_partck: true,
                network_partck: false,
                agel_partck: false,
            });
            isSave = 1;


        } else if (parseFloat(payment.paidup) > 0 && valChecked === true && valueType.id === 1) {
            const text = transForm("network").toString();
            setLbl({ ...lbl, chashNetwork: text });
            setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
            setValueBankPMD(AutoOptions.Banks[0]); //getAutobanks(0);
            setUiElement({ ...uiElement, bank: false });
            setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });
            setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });
            setValueType(AutoOptions.types[0]);
            remains.networkPart = payment.paidup;
            remains.agelPart = payment.stay;
            remains.bankPart = 0;
            remains.cashPart = 0;
            idata.bank = AutoOptions.Banks[0].id
            idata.pay_type = -1;
            idata.inv_type = 1;
            idata.cash_part = payment.stay;
            idata.agel_part = 0;
            idata.bank_part = 0;
            idata.network_part = payment.paidup;

            setChecked({
                ...checked,
                cash_partck: false,
                network_partck: true,
                agel_partck: false,
            });
            isSave = 1;

        }
        else if (parseFloat(payment.paidup) > 0 && valChecked == false && valueType.id == 1) {
            setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
            setUiElement({ ...uiElement, bank: true });
            setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
            setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, stock: AutoOptions.Stocks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });
            isSave = 1;


            setValueType(AutoOptions.types[0]);
            remains.cashPart = payment.paidup;
            remains.agelPart = payment.stay;
            remains.bankPart = 0;
            remains.networkPart = 0;
            idata.pay_type = -1;
            idata.inv_type = 1;
            idata.cash_part = payment.paidup;
            idata.agel_part = payment.stay;
            idata.bank_part = 0;
            idata.network_part = 0;

            setChecked({
                ...checked,
                cash_partck: true,
                network_partck: false,
                agel_partck: false,
            });
            isSave = 1;
        }
        if (isSave === 1) { await toPrint(type, e, hist); }
    };

    const handPrint = async (procid) => {
        // console.log("the valueSalesmen?.name is", valueSalesmen?.name);
        const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
        if ((or.PrAC === 2 || or.PrAC === 1)) {
            const localInvoive = {
                proc_id: procid,
                invN: setting.titleHed,
                invNEn: setting.titleHedEn,
                salesman: valueSalesmen.name,
                backInv: "InvSO",
                branch: props.isDialog == false ? sto.branchi : props.invData.branch,
                ProcTypeInvProc: setting.PrTy_InPr,
                Delivery: permistionInv?.PRNTOUT,
                Step_inv2: AutoOptions?.StepTwo?.id === 1 ? true : false,
                Direct: i18next.language == "ar" ? true : false,
                NRound: permistionInv?.ROUND == null ? 4 : permistionInv?.ROUND,
                UseBefore: permistionInv?.USEBEFORE == null ? 1 : permistionInv?.USEBEFORE,
                branchInv: props.isDialog == false ? sto.branchi : props.invData.branch,
                salesmanName: valueSalesmen?.id != -1 ? valueSalesmen?.name : "",
                desc_perc: invDisc.rate ?? 0,
            }
            let invType = 1;
            if (or.PrAC === 2) {
                const num = Number(premiApp.billTemplate);
                if ([4, 8, 18, 23, 28, 29].includes(num)) {
                    invType = 4;
                } else if ([5, 9, 21, 22, 24, 25, 26, 27, 30, 32, 33].includes(num)) {
                    invType = 2;
                } else if ([6, 16, 19].includes(num)) {
                    invType = 3;
                } else if ([7, 2].includes(num)) {
                    invType = 5;
                } else if (num === 10) {
                    invType = 6;
                } else {
                    invType = 1;
                }
                setOpenPrint({ open: true, localInv: localInvoive, invType: invType, invKind: 2 });
            } else {
                const num = Number(premiApp.cashirTemplate);
                if ([2, 6].includes(num)) {
                    invType = 3;
                } else if ([4, 5, 7].includes(num)) {
                    invType = 2;
                } else { invType = 1; }
                setOpenPrint({ open: true, localInv: localInvoive, invType: invType, invKind: 1 });
            }
        }
        else {
            const serializedinv = JSON.stringify({
                proc_id: procid,
                invN: setting.titleHed,
                invNEn: setting.titleHedEn,
                salesman: valueSalesmen.name,
                backInv: "InvSO",
                branch: props.isDialog == false ? sto.branchi : props.invData.branch,
                ProcTypeInvProc: setting.PrTy_InPr,
                Delivery: permistionInv?.PRNTOUT,
                Step_inv2: AutoOptions?.StepTwo?.id === 1 ? true : false,
                Direct: i18next.language == "ar" ? true : false,
                NRound: permistionInv?.ROUND == null ? 4 : permistionInv?.ROUND,
                UseBefore: permistionInv?.USEBEFORE == null ? 1 : permistionInv?.USEBEFORE,
                branchInv: props.isDialog == false ? sto.branchi : props.invData.branch,
            });
            await localStorage.setItem("datainv", serializedinv);
            if (or.PrAC === 1) {
                if (premiApp?.cashirTemplate == 3) {
                    his.push({ pathname: "/RestCasher" });
                }
            } else if (or.PrAC === 2 && premiApp?.billTemplate == 3) {
                his.push({ pathname: "/gold-bill" });
            }
            else if (or.PrAC === 3) {
                setGenerating(true);
                await handleDirectPrintCasair(
                    JSON.parse(serializedinv),
                    handNewInv,
                    premiApp,
                );
                setGenerating(false);
            } else if (or.PrAC === 4) {
                handNewInv();
                setGenerating(true);
                await PrintInvoiceDirectly(JSON.parse(serializedinv), true, handNewInv);
                setGenerating(false);
            } else if (or.PrAC === 5) {
                await PrintInvoiceDirectly(
                    JSON.parse(serializedinv),
                    true,
                    handNewInv
                );
            } else if (or.PrAC === 6) {
                setGenerating(true);
                const invoiceDataTemp = { proc_id: procid, branchId: sto.branchi, procTypeInvProc: setting.PrTy_InPr };
                await generateDocument(setBase64String, templatePrintFile, invoiceDataTemp);
                await handNewInv();
                setGenerating(false);
            }
        }
    };
    useEffect(() => {
        if (base64String) { PrintPdf(); console.log(" i'm in form pdf printpdf") }
    }, [base64String]);
    const PrintPdf = () => printJS({ printable: base64String, type: "pdf", base64: true });

    const PushTos = async (t) => {
        setIsLoading(true);
        befPushTos();
        dateKeep.Date = moment(idata.date).format('YYYY-MM-DD');
        let Sa_or_Pa_rest_id = null;
        console.log("the data is", remains);
        const formData = new FormData();
        // if (file) {
        //     formData.append("file", file);
        // }
        await ButtonLoading(t);
        const model = {
            inv: {
                ...idata,
                Pay_mouny: payment.paidup ? payment.paidup : 0,
                Remaining: payment.stay,
                agel_part: remains.agelPart,
                cash_part: remains.cashPart,
                network_part: remains.networkPart,
                bank_part: remains.bankPart,
                emp_part: remains.empPart,
                trans_no: maxShifts,
                center: valueCostcenter?.id ?? -1,
                cust_id: valueCustomers?.id,
                customer_name: permistionInv?.REGNOCUST ? idata?.customer_name : valueCustomers.name,
                vat_type: or.postput === "toPut" ? idata.vat_type : permiCuCo.CWVat ? 1 : 0,
                post: post,
                ProcType_InvProc: setting.PrTy_InPr,
            },
            //stor: stor,
            stor: {
                ...stor,
                Step_inv2: AutoOptions?.StepTwo?.id === 1 ? true : false,
                isOrder: false,
                orderId: 0
            },

            parms: {
                omlaId: omlaValue?.id,
                tobaccoFees: premiA.tobaccoFees,
                omlaExchange: omlaValue?.exchange,
                iuserid: idata.create_user,
                iformidCuCo: dataF[3].id,
                proc_type: setting.routIS == "Inv_Sub_ToS/" ? 2 : 1,
                yashml: permiCuCo.yashml == "W",
                isAgel: remains?.isAgel,
                isCash: remains?.isCash,
                isNetwork: remains?.isNetwork,
                isBank: remains?.isBank,
                isEmp: remains?.isEmp,
                isWindow: remains?.isWindow,
                empId: remains?.empId,
                // bankId: remains?.bankId,
                bankId: valueBanksPaid?.id ?? 0,
                bankAcc: valueBanksPaid?.i,
                networkId: valueBankPMD?.id,
                networkAcc: valueBankPMD?.i ?? 0,
                stockAcc: valueStock?.acc ?? 0,
                acc_no: valueCustomers?.acc_no,
                updatePrice: permistionInv?.UPDATEPRICE ?? false,
                re_disc: permistionInv?.RE_DISC && ["02", "12"].includes(setting.PrTy_InPr) && parseFloat(invDisc.minus) > 0,
                re_disc_agel: permistionInv?.RE_DISC_AGEL && ["02", "12"].includes(setting.PrTy_InPr) && parseFloat(invDisc.minus) > 0,
                // file,
            },
            State: "Post",
            _Data: isdata,
            expenses: expenseList,
            file: formData
        };

        if (or.postput == "toPost") {
            await axios
                .post(uri + "_HInv", model)
                .then((resI) => {
                    console.log(" the  data is", model);
                    if (or.PrAC !== 0) handPrint(resI.data.proc_id);
                    ButtonSuccess(t, true);
                    if (files?.length > 0 && permistionInv?.ARCHIVE === true) {
                        addArchaive(resI.data, setting.PrTy_InPr);
                    }
                    toast.success("تمت عملية الحفظ بنجاح");
                })
                .catch((resI) => {
                    handOSnack({
                        vertical: "top",
                        horizontal: "right",
                        severit: "warning",
                        text:
                            "لم يتم اضافة الفاتورة" + "بسبب " + resI.response?.data?.Message,
                        time: 2000,
                    });
                    ButtonSuccess(t, false);
                });
        } else if (or.postput == "toPut") {
            await ButtonLoading(t);
            // I_Pu
            console.log(" the  data is", model);
            // if (permistionInv.IPU) {
            if (permistionInv.Up && isOpenUpdate) {

                await axios
                    .put(uri + "_HInv", model)
                    .then((resI) => {
                        if (resI?.data?.id == null) {
                            handOSnack({
                                vertical: "top",
                                horizontal: "center",
                                severit: "warning",
                                text:
                                    resI?.data,
                                time: 2000,
                            });
                            if (or.PrAC !== 0) handPrint(model.inv.proc_id);
                            ButtonSuccess(t, true);
                            // if (isDialog == true) { props.onClose(); } else { ButtonSuccess(t, true); }

                        } else {
                            console.log(" the  data is", model);
                            if (or.PrAC !== 0) handPrint(resI.data.proc_id);
                            ButtonSuccess(t, true);
                            toast.success("تمت عملية التعديل بنجاح");
                            // if (isDialog == true) { props.onClose(); } else { ButtonSuccess(t, true); }
                        }
                        if (files?.length > 0 && permistionInv?.ARCHIVE === true) {
                            addArchaive(resI.data, setting.PrTy_InPr);
                        }
                        /*console.log('done I_po');*/
                    })
                    .catch((resI) => {
                        handOSnack({
                            vertical: "top",
                            horizontal: "center",
                            severit: "warning",
                            text:
                                "لم يتم تعديل الفاتورة" +
                                "  " +
                                "بسبب " +
                                resI.response?.data?.Message,
                            time: 2000,
                        });
                        ButtonSuccess(t, false);
                    });
            } else {
                const tb = { inv: idata, stor: stor };
                await axios
                    .put(uri + "Inv_R_RS_", tb)
                    .then((resI_Pu) => {
                        /*console.log('done I_Pu');*/
                        if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")
                            Sa_or_Pa_rest_id = resI_Pu.data.sale_rest_id;
                        else Sa_or_Pa_rest_id = resI_Pu.data.purch_rest_id;

                        if (or.PrAC !== 0) handPrint(resI_Pu.data.proc_id);
                        ButtonSuccess(t, true);
                        // if (isDialog == true) { props.onClose(); } else { ButtonSuccess(t, true); }

                    })
                    .catch((resI_Pu) => {
                        // if(isDialog==true){props.onClose();}else{  ButtonSuccess(t, true);}
                        ButtonSuccess(t, false);
                        /*console.log('no I_Pu');*/
                    });
            }
        }
    };
    const addArchaive = async (data, type) => {
        let nameType = type === "02" ? "Sale" : type === "01" ? "Puraches" : type === "11" ? "ReturnPurchase" ?
            type === "12" ? "ReturnSale" : "" : "" : "";
        let fileName = nameType + data.proc_id + "_" + data.id + "_" + data.branch;
        // addArchaiveFile(file, fileName);
        addMultiArchaiveFile(files, fileName);
    };
    const handleDownload = async () => {
        try {
            let nameType = setting.PrTy_InPr === "02" ? "Sale" : setting.PrTy_InPr === "01" ? "Puraches" :
                setting.PrTy_InPr === "11" ? "ReturnPurchase" ?
                    setting.PrTy_InPr === "12" ? "ReturnSale" : "" : "" : "";
            let fileName = nameType + idata.proc_id + "_" + idata.id + "_" + idata.branch;
            await handleMultiDownloadFiles(fileName);
        } catch (error) {
        }
    };
    const PushTost = async (t) => {
        befPushTos();
        let Sa_or_Pa_rest_id = null;
        if (or.postput == "toPost") {
            await ButtonLoading(t);
            const tb = {
                invtemp: idata,
                stor: stor,
                parms: {
                    iuserid: idata.create_user,
                    iformidCuCo: dataF[3].id,
                },
            };

            await axios
                .post(uri + "Inv_R_RS__", tb)
                .then((resI) => {
                    /*console.log('done I_po');*/
                    axios
                        .post(
                            uri +
                            setting.routIS +
                            permiCuCo.yashml +
                            "?pcid=" +
                            resI.data.proc_id +
                            "&&State=Postt",
                            isdata
                        )
                        .then((resS) => {
                            /*console.log('done IS_po');*/
                            if (or.PrAC !== 0) handPrint(resI.data.proc_id);
                            ButtonSuccess(t, true);
                        })
                        .catch((resS) => {
                            /*console.log('no IS_po');*/
                        });
                })
                .catch((resI) => {
                    ButtonSuccess(t, false);
                });
        }
        if (or.postput == "toPut") {
            await ButtonLoading("t");
            // I_Pu
            const tb = { inv: idata, stor: stor };

            await axios
                .put(uri + "Inv_R_RS", tb)
                .then((resI_Pu) => {
                    /*console.log('done I_Pu');*/

                    if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")
                        Sa_or_Pa_rest_id = resI_Pu.data.sale_rest_id;
                    else Sa_or_Pa_rest_id = resI_Pu.data.purch_rest_id;

                    // R_Pu
                    axios
                        .put(uri + "Restrictions" + "?pcid=" + resI_Pu.data.proc_id)
                        .then((retR_Pu) => {
                            /*console.log('done R_Pu');*/
                        })
                        .catch((retR_Pu) => {
                            /*console.log('no R_Pu');*/
                        });

                    // IS_De&Po
                    axios
                        .post(
                            uri +
                            setting.routIS +
                            permiCuCo.yashml +
                            "?pcid=" +
                            resI_Pu.data.proc_id +
                            "&&State=rePost",
                            isdata
                        )
                        .then((resIS_Po) => {
                            /*console.log('done resIS_Po');*/
                        })
                        .catch((resIS_Po) => {
                            /*console.log('no resIS_Po');*/
                        });

                    // RS_De&Po
                    axios
                        .post(uri + "Restrictions_Sub" + "?idR=" + Sa_or_Pa_rest_id, idata)
                        .then((resRS_Po) => {
                            /*console.log('done RS_Po');*/
                        })
                        .catch((resRS_Po) => {
                            /*console.log('no RS_Po');*/
                        });

                    /* E inner */
                    if (or.PrAC !== 0) handPrint(resI_Pu.data.proc_id);
                    ButtonSuccess("t", true);
                })
                .catch((resI_Pu) => {
                    ButtonSuccess(t, false); /*console.log('no I_Pu');*/
                });
        }
    };
    const deleteTos = async (e) => {
        await e.preventDefault();
        setConfirmDialog({ ...confirmDialog, isOpen: false });
        ButtonLoading("delete");

        await axios.delete(uri + `_HInv?id=${idata.proc_id}`).then(res => {
            toast.success("invoice has deleted");
            ButtonSuccess("delete", true);

        }).catch(err => {
            console.log("eror", err)
            ButtonSuccess("delete", false);
            toast.error("not delete ")
        })
    };

    const loadePayMents = () => {
        //  alert(idata.netAmount)
        setPayment({
            ...payment,
            paidupPMDcn: payment.paidup,
            stayPMDcn: payment.stay,
        });

        if (switchState.cashORnetworksw == false && valueType.id == 2) {
            setChecked({
                ...checked,
                cash_partck: true,
                network_partck: false,
                agel_partck: false,
            });
            setIData({
                ...idata,
                cash_part: idata.netAmount,
                network_part: "",
                agel_part: "",
                emp_part: "",
                bank_part: "",
                check_refno: "",
                netAmountPMDcn: idata.netAmount,
            });
        } else if (switchState.cashORnetworksw == true && valueType.id == 2) {
            setChecked({
                ...checked,
                cash_partck: false,
                network_partck: true,
                agel_partck: false,
            });
            setIData({
                ...idata,
                cash_part: "",
                network_part: idata.netAmount,
                agel_part: "",
                emp_part: "",
                bank_part: "",
                check_refno: "",
                netAmountPMDcn: idata.netAmount,
            });


            setValueBankPMD(valueBank); //setOptionsBankPMD(optionsBank);
        }
        // else if (valueType.id === 1) {
        //   setChecked({
        //     ...checked,
        //     network_partck: false,
        //     cash_partck: false,
        //     agel_partck: true,
        //   });
        //   setIData({
        //     ...idata,
        //     cash_part: "",
        //     network_part: "",
        //     agel_part: idata.netAmount,
        //     emp_part: "",
        //     bank_part: "",
        //     check_refno: "",
        //     netAmountPMDcn: idata.netAmount,
        //   });
        // }
        else if (valueType.id === 1) {

            if (payment.paidup > 0) {

                alert(payment.paidup)
                if (switchState.cashORnetworksw == false) {
                    // setChecked({
                    //   ...checked,
                    //   cash_partck: false,
                    //   network_partck: false,
                    //   agel_partck: true,
                    // });
                    setIData({
                        ...idata,
                        cash_part: payment.paidup,
                        network_part: "",
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                    });
                } else if (switchState.cashORnetworksw == true) {
                    setChecked({
                        ...checked,
                        cash_partck: false,
                        network_partck: true,
                        agel_partck: true,
                    });
                    setIData({
                        ...idata,
                        cash_part: "",
                        network_part: payment.paidup,
                        agel_part: payment.stay,
                        emp_part: "",
                        bank_part: "",
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                    });
                    setValueBankPMD(valueBank); //setOptionsBankPMD(optionsBank);

                }
            } else {
                setChecked({
                    ...checked,
                    cash_partck: false,
                    network_partck: false,
                    agel_partck: true,
                });
                setIData({
                    ...idata,
                    cash_part: payment.paidup,
                    network_part: "",
                    agel_part: payment.stay,
                    emp_part: "",
                    bank_part: "",
                    check_refno: "",
                    netAmountPMDcn: idata.netAmount,
                });
            }


        }


    };

    const usedPayedWindow = (v) => {
        if (v === 0) idata.used_payed_window = v;
        else idata.used_payed_window = v;
    };

    // ============================================ btn load
    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const timer = React.useRef();

    const buttonClassnameSave = clsx({
        [clasCAB.buttonSuccessCAB]: success.save,
    });
    const buttonClassnameSavetmp = clsx({
        [clasCAB.buttonSuccessCAB]: success.savetmp,
    });

    const buttonClassnameSavePMD = clsx({
        [clasCAB.buttonSuccessCAB]: success.savePMD,
    });

    const buttonClassnameDelete = clsx({
        [clasCAB.buttonSuccessCAB]: success.delete,
    });

    const buttonClassnamePrint = clsx({
        [clasCAB.buttonSuccessCAB]: success.print,
    });
    useEffect(() => {
        return () => {
            clearTimeout(timer.current);
        };
    }, []);

    const ButtonLoading = (prop) => {
        setLoading({ ...loading, [prop]: true });
    };
    const ButtonSuccessOld = (prop, state) => {
        timer.current = window.setTimeout(() => {
            setLoading({ ...loading, [prop]: false });
            setSuccess({ ...success, [prop]: true });
            isSavingRef.current = false;
            if (
                prop == "delete" ||
                prop == "save" ||
                prop == "savetmp" ||
                prop == "savePMD"
            ) {
                if (state) handNewInv();
            }
            if (prop == "savePMD") {
                handClosePMD("done");
            }
            setIsLoading(false);
            isSavingRef.current = false;
            timer.current = window.setTimeout(() => {
                setSuccess({ ...success, [prop]: false });
            }, 500);
        }, 600);
    };
    const ButtonSuccess = async (prop, state) => {
        buttonsFinsh(prop);
        if (
            prop == "delete" ||
            prop == "save" ||
            prop == "savetmp" ||
            prop == "savePMD"
        ) {
            try { await keepFocus(); } catch { }
            if (state) {
                await handNewInv();
            }
        }
        if (prop == "savePMD") {
            await handClosePMD("done");
        }
        await ButtonLastFinsh(prop);
    };
    const buttonsFinsh = (prop) => {
        setLoading({ ...loading, [prop]: false });
        setSuccess({ ...success, [prop]: true });
    };
    const ButtonLastFinsh = (prop) => {
        isSavingRef.current = false;
        setIsLoading(false);
        setSuccess({ ...success, [prop]: false });
    };
    // ========================================== btn load
    const toDB = async (type, e) => {
        if (showPaid === true && type !== "savetmp" && setting.PrTy_InPr !== "03" && setting.PrTy_InPr !== "04") {
            if ((or.postput == "toPut" && isOpenUpdate) || or.postput == "toPost") {
                if (parseFloat(idata.netAmount) !== parseFloat(remains.allpart)) {
                    alert("المبلغ غير متساوي");
                } else if (isdata.length == 0) {
                    alert(" لا يوجد اصناف في الجدول ");
                } else if (parseFloat(idata.netAmount) == 0) {
                    alert(" لا يمكن حفظ الفاتورة باجمالي صفر    ");
                }
                else {
                    handClosePMD("cancle");
                    if (isSavingRef.current) return;
                    isSavingRef.current = true;
                    setIsLoading(true);
                    await PushTos(type);
                }
            } else {

                usedPayedWindow(0);

                if (type == "savetmp") {
                    await PushTost(type);
                } else {
                    if (isSavingRef.current) return;
                    isSavingRef.current = true;
                    setIsLoading(true);
                    await PushTos(type);
                }
            }
        } else {
            usedPayedWindow(0);
            if (type == "savetmp") {
                await PushTost(type);
            } else {
                setIsLoading(true);
                if (isSavingRef.current) return;
                isSavingRef.current = true;
                await PushTos(type);
            }
        }
    };

    const paidFun = (type) => {
        if (or.postput === "toPut" && parseFloat(remains?.allpart ?? 0) === parseFloat(idata?.netAmount)) {
            // setRemains({ ...remains, });
            remains.isBank = parseFloat(remains?.bankPart) > 0 ? true : false;
            remains.isNetwork = parseFloat(remains?.networkPart) > 0 ? true : false;
            remains.isEmp = parseFloat(remains?.empPart) > 0 ? true : false;
            remains.isCash = parseFloat(remains?.cashPart) > 0 ? true : false;
            remains.isAgel = parseFloat(remains?.agelPart) > 0 ? true : false;
            setValueBankPMD(remains?.isNetwork ? valueBankPMD : AutoOptions.Banks[0]);
            setValueBanksPaid(remains?.isBank ? valueBanksPaid : AutoOptions.Banks[0]);
            setValueEmployePMD(remains?.isEmp ? valueBanksPaid : gets.Employees[0]);
            setPayment({ ...payment, paidupPMDcn: payment.paidup, stayPMDcn: payment?.stay });
        }
        else {
            if (valueType.id == 2) {
                setRemains({
                    ...remains,
                    cashPart: switchState.cashORnetworksw == false ? idata.netAmount : 0,
                    agelPart: 0,
                    bankPart: 0,
                    networkPart: switchState.cashORnetworksw == true ? idata.netAmount : 0,
                    empPart: 0,
                    isCash: switchState.cashORnetworksw == false,
                    isWindow: true,
                    isNetwork: switchState.cashORnetworksw == true,
                    isAgel: false,
                    isEmp: false,
                    allpart: idata.netAmount,
                    typePress: type,
                });
                // setValueBank(gets.Banks[0]); //getAutobanks(0);

            } else if (valueType.id == 1 && parseFloat(payment.paidup) > 0) {
                setRemains({
                    ...remains,
                    cashPart: switchState.cashORnetworksw == false ? payment.paidup : 0,
                    agelPart: payment.stay,
                    bankPart: 0,
                    networkPart: switchState.cashORnetworksw == true ? payment.paidup : 0,
                    empPart: 0,
                    isCash: switchState.cashORnetworksw == false,
                    isWindow: true,
                    isAgel: true,
                    isEmp: false,
                    isNetwork: switchState.cashORnetworksw == true,
                    allpart: idata.netAmount,
                    typePress: type,
                });

            } else {
                setRemains({
                    ...remains,
                    cashPart: 0,
                    agelPart: idata.netAmount,
                    bankPart: 0,
                    networkPart: 0,
                    empPart: 0,
                    isCash: false,
                    isWindow: true,
                    isAgel: true,
                    isEmp: false,
                    isNetwork: false,
                    allpart: idata.netAmount,
                    typePress: type,
                });
            }
            setValueBankPMD(switchState.cashORnetworksw ? valueBank : AutoOptions.Banks[0]);
            setValueBanksPaid(AutoOptions.Banks[0]);
            setValueEmployePMD(gets.Employees[0]);
            setPayment({ ...payment, paidupPMDcn: payment.paidup, stayPMDcn: payment?.stay });
        }

    }

    const sendToZatca = async (t) => {

        console.log("the data is", idata);
        const model = {
            ...idata,
            Pay_mouny: payment.paidup ? payment.paidup : 0,
            Remaining: payment.stay,
            agel_part: remains.agelPart,
            cash_part: remains.cashPart,
            network_part: remains.networkPart,
            bank_part: remains.bankPart,
            emp_part: remains.empPart,
        };
        if (or.postput == "toPut") {
            setLoading(true);
            await ButtonLoading(t);
            // I_Pu
            console.log(" the  data is", model);

            const URL = uri + "Zatca/SignInvAndSendToZatca";
            await axios
                .post(URL, model)
                .then((resI) => {
                    ButtonSuccess(t, true);
                })
                .catch((resI) => {
                    handOSnack({
                        vertical: "top",
                        horizontal: "right",
                        severit: "warning",
                        text:
                            "لم يتم submite الفاتورة" +
                            "  " +
                            "بسبب " +
                            resI.response?.data?.Message,
                        time: 2000,
                    });
                    ButtonSuccess(t, false);
                });
        }
    };
    const toPrintTemplate = async (fileName) => {
        // setTemplatePrintFile(fileName);
        templatePrintFile = fileName;
        console.log("theFilename ", templatePrintFile);
        or.PrAC = 6;
        if (isdata.length > 0) await toWhere("print", "e");
        else
            handOSnack({
                vertical: "top",
                horizontal: "right",
                severit: "warning",
                text: "يجب تنزيل اصناف",
                time: 2000,
            });
    };

    // const toWhere = async (type, e) => {


    // };

    const toWhere = (type, e) => {
        if (type === "save") or.PrAC = 0;
        if (valueCustomers.id === null || valueCustomers.id === "") {
            handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text: "تاكد من اختيار العميل",
                time: 2000,
            });
        } else if ((or.postput == "toPut" && isOpenUpdate) && setting.PrTy_InPr !== "03" && setting.PrTy_InPr === "04" && idata.vat_type != permiCuCo.CWVat) {
            handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text: "you cant save ",
                time: 2000,
            });
        }
        else if (setting.PrTy_InPr === "02" && valueCustomers?.stop_trans == 1 && type !== "savetmp" && or.postput == "toPost") {
            handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text: "لا يمكنك حفظ الفاتورة ... تم إيقاف التعامل مع هذا العميل",
                time: 2000,
            });
        } else if (permistionInv?.FORCECOST === true && valueCostcenter?.id < 1) {
            alert("you have to choose cost center");
        } else if (["149", "150"].includes(setting.PrTy_InPr) && parseFloat(idata.Ishar_amout_Net ?? 0) <= 0) {
            alert("لا يمكن حفظ الاشعار بقيمة صفر ");
        }
        else {
            if (isdata.length === 0) {
                // alert(" لا يوجد اصناف في الجدول ");
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: "لا يوجد اصناف في الجدول ... برجاء تنزيل الاصناف",
                    time: 2000,
                });
            } else {
                if (AutoOptions?.StepTwo?.id == 1 && type !== "savetmp" && or.postput == "toPost" && (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12")
                ) {
                    const tb = {
                        CustStepTwo: true,
                        parms: {
                            cust_id: valueCustomers?.id,
                        },
                    };
                    axios
                        .post(uri + "GetD", tb)
                        .then((res) => {
                            if (res.data?.StepTwoNotes?.notes === "Good") {
                                toWhereSave(type, e);
                            } else {
                                handOSnack({
                                    vertical: "top",
                                    horizontal: "center",
                                    severit: "warning",
                                    text: res.data?.StepTwoNotes?.notes,
                                    time: 2000,
                                });
                            }
                        })
                        .catch((error) => {
                            toWhereSave(type, e);
                        });
                } else {
                    toWhereSave(type, e);
                }
            }

        }



    };

    const toWhereSave = (type, e) => {
        if (parseFloat(payment.paidup) > parseFloat(idata.netAmount)) {
            if ((setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12") && or.postput === "toPost" && valueType.id == 1) {
                if (switchState.cashORnetworksw == true) {
                    setValueType(AutoOptions.types[1]);

                    remains.networkPart = idata.netAmount;
                    remains.agelPart = 0;
                    remains.bankPart = 0;
                    remains.cashPart = 0;


                    idata.pay_type = 2;
                    idata.inv_type = 2;
                    idata.cash_part = 0;
                    idata.agel_part = 0;
                    idata.bank_part = 0;
                    idata.network_part = idata.netAmount;
                    idata.cust_id = valueCustomers.id;
                    setChecked({
                        ...checked,
                        cash_partck: false,
                        network_partck: true,
                        agel_partck: false,
                    });
                    blurPaid2(payment.paidup);

                }
                else {
                    setValueType(AutoOptions.types[1]);
                    remains.cashPart = idata.netAmount;
                    remains.agelPart = 0;
                    remains.bankPart = 0;
                    remains.networkPart = 0;


                    idata.pay_type = 1;
                    idata.inv_type = 2;
                    idata.cash_part = idata.netAmount;
                    idata.agel_part = 0;
                    idata.bank_part = 0;
                    idata.network_part = 0;
                    idata.cust_id = valueCustomers.id;
                    setChecked({
                        ...checked,
                        cash_partck: true,
                        network_partck: false,
                        agel_partck: false,
                    });
                    blurPaid2(payment.paidup);

                }
            } else {

                if (switchState.cashORnetworksw == true) {
                    setValueType(AutoOptions.types[1]);
                    remains.networkPart = idata.netAmount;
                    remains.agelPart = 0;
                    remains.bankPart = 0;
                    remains.cashPart = 0;
                    remains.empPart = 0;
                    payment.paidup = idata.netAmount;
                    payment.stay = 0;

                    idata.pay_type = 2;
                    idata.inv_type = 2;
                    idata.cash_part = 0;
                    idata.agel_part = 0;
                    idata.bank_part = 0;
                    idata.network_part = idata.netAmount;

                    setChecked({
                        ...checked,
                        cash_partck: false,
                        network_partck: true,
                        agel_partck: false,
                    });
                    if (isdata.length > 0) {
                        if (showPaid === true && type !== "savetmp" && setting.PrTy_InPr !== "03" && setting.PrTy_InPr !== "04"
                            && setting.PrTy_InPr !== "22"
                        ) {
                            if ((or.postput == "toPut" && isOpenUpdate) || or.postput == "toPost") {
                                paidFun(type);
                                handleClickOpenPaid(type);
                            } else {
                                toDB(type, e);
                            }
                        } else {
                            toDB(type, e);
                        }
                    }
                    else {
                        // handOSnack({ vertical: 'top', horizontal: 'center' });
                        handOSnack({
                            vertical: "top",
                            horizontal: "right",
                            severit: "warning",
                            text: transForm("most_download_item"),
                            time: 2000,
                        });
                    }


                }
                else {
                    setValueType(AutoOptions.types[1]);
                    remains.cashPart = idata.netAmount;
                    remains.agelPart = 0;
                    remains.bankPart = 0;
                    remains.networkPart = 0;


                    payment.paidup = idata.netAmount;
                    payment.stay = 0;
                    idata.pay_type = 1;
                    idata.inv_type = 2;
                    idata.cash_part = idata.netAmount;
                    idata.agel_part = 0;
                    idata.bank_part = 0;
                    idata.network_part = 0;

                    setChecked({
                        ...checked,
                        cash_partck: true,
                        network_partck: false,
                        agel_partck: false,
                    });
                    if (isdata.length > 0) {
                        if (checked.paymentDiloagck === true) {
                            loadePayMents();
                            handleClickOpenPMD(TransitionRight);
                        } else

                            toDB(type, e);
                    }
                    else {
                        // handOSnack({ vertical: 'top', horizontal: 'center' });
                        handOSnack({
                            vertical: "top",
                            horizontal: "right",
                            severit: "warning",
                            text: transForm("most_download_item"),
                            time: 2000,
                        });
                    }


                }
            }
        }
        else {
            if (isdata.length > 0 && parseFloat(idata.netAmount) > 0) {
                if (showPaid === true && type !== "savetmp" && setting.PrTy_InPr !== "03" && setting.PrTy_InPr !== "04") {
                    if ((or.postput == "toPut" && isOpenUpdate) || or.postput == "toPost") {
                        paidFun(type);
                        handleClickOpenPaid(type);
                    } else {
                        toDB(type, e);
                    }
                } else { toDB(type, e); }
            } else if (isdata.length === 0) {
                // alert(" لا يوجد اصناف في الجدول ");
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: transForm("no_item_in_table"),
                    time: 2000,
                });
            } else if (parseFloat(idata.netAmount) === 0) {
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: transForm("cant_save_zero_invoice"),
                    time: 2000,
                });
            }
            else {
                // handOSnack({ vertical: 'top', horizontal: 'center' });
                handOSnack({
                    vertical: "top",
                    horizontal: "right",
                    severit: "warning",
                    text: transForm("most_download_item"),
                    time: 2000,
                });
            }
        }
    };

    const toWhereSaveOld = (type, e) => {
        if (parseFloat(payment.paidup) > parseFloat(idata.netAmount)) {
            if ((setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12") && or.postput === "toPost") {
                if (switchState.cashORnetworksw == true) {
                    setValueType(AutoOptions.types[1]);

                    remains.networkPart = idata.netAmount;
                    remains.agelPart = 0;
                    remains.bankPart = 0;
                    remains.cashPart = 0;


                    idata.pay_type = 2;
                    idata.inv_type = 2;
                    idata.cash_part = 0;
                    idata.agel_part = 0;
                    idata.bank_part = 0;
                    idata.network_part = idata.netAmount;
                    idata.cust_id = valueCustomers.id;
                    setChecked({
                        ...checked,
                        cash_partck: false,
                        network_partck: true,
                        agel_partck: false,
                    });
                    blurPaid2(payment.paidup);

                }
                else {
                    setValueType(AutoOptions.types[1]);
                    remains.cashPart = idata.netAmount;
                    remains.agelPart = 0;
                    remains.bankPart = 0;
                    remains.networkPart = 0;


                    idata.pay_type = 1;
                    idata.inv_type = 2;
                    idata.cash_part = idata.netAmount;
                    idata.agel_part = 0;
                    idata.bank_part = 0;
                    idata.network_part = 0;
                    idata.cust_id = valueCustomers.id;
                    setChecked({
                        ...checked,
                        cash_partck: true,
                        network_partck: false,
                        agel_partck: false,
                    });
                    blurPaid2(payment.paidup);

                }
            }
            else {
                if (switchState.cashORnetworksw == true) {
                    setValueType(AutoOptions.types[1]);
                    remains.networkPart = idata.netAmount;
                    remains.agelPart = 0;
                    remains.bankPart = 0;
                    remains.cashPart = 0;
                    remains.empPart = 0;
                    payment.paidup = idata.netAmount;
                    payment.stay = 0;

                    idata.pay_type = 2;
                    idata.inv_type = 2;
                    idata.cash_part = 0;
                    idata.agel_part = 0;
                    idata.bank_part = 0;
                    idata.network_part = idata.netAmount;

                    setChecked({
                        ...checked,
                        cash_partck: false,
                        network_partck: true,
                        agel_partck: false,
                    });
                    if (isdata.length > 0) {
                        if (showPaid === true && type !== "savetmp" && setting.PrTy_InPr !== "03" && setting.PrTy_InPr !== "04"
                            && setting.PrTy_InPr !== "22"
                        ) {
                            if ((or.postput == "toPut" && isOpenUpdate) || or.postput == "toPost") {
                                paidFun(type);
                                handleClickOpenPaid(type);
                            } else {
                                toDB(type, e);
                            }
                        } else {
                            toDB(type, e);
                        }
                    }
                    else {
                        // handOSnack({ vertical: 'top', horizontal: 'center' });
                        handOSnack({
                            vertical: "top",
                            horizontal: "right",
                            severit: "warning",
                            text: transForm("most_download_item"),
                            time: 2000,
                        });
                    }


                }
                else {
                    setValueType(AutoOptions.types[1]);
                    remains.cashPart = idata.netAmount;
                    remains.agelPart = 0;
                    remains.bankPart = 0;
                    remains.networkPart = 0;


                    payment.paidup = idata.netAmount;
                    payment.stay = 0;
                    idata.pay_type = 1;
                    idata.inv_type = 2;
                    idata.cash_part = idata.netAmount;
                    idata.agel_part = 0;
                    idata.bank_part = 0;
                    idata.network_part = 0;

                    setChecked({
                        ...checked,
                        cash_partck: true,
                        network_partck: false,
                        agel_partck: false,
                    });
                    if (isdata.length > 0) {
                        if (checked.paymentDiloagck === true) {
                            loadePayMents();
                            handleClickOpenPMD(TransitionRight);
                        } else

                            toDB(type, e);
                    }
                    else {
                        // handOSnack({ vertical: 'top', horizontal: 'center' });
                        handOSnack({
                            vertical: "top",
                            horizontal: "right",
                            severit: "warning",
                            text: transForm("most_download_item"),
                            time: 2000,
                        });
                    }


                }
            }
        }
        else {
            if (isdata.length > 0 && parseFloat(idata.netAmount) > 0) {
                if (showPaid === true && type !== "savetmp" && setting.PrTy_InPr !== "03" && setting.PrTy_InPr !== "04") {
                    if ((or.postput == "toPut" && isOpenUpdate) || or.postput == "toPost") {
                        paidFun(type);
                        handleClickOpenPaid(type);
                    } else {
                        toDB(type, e);
                    }
                } else

                    toDB(type, e);
            } else if (isdata.length === 0) {
                // alert(" لا يوجد اصناف في الجدول ");
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: transForm("no_item_in_table"),
                    time: 2000,
                });
            } else if (parseFloat(idata.netAmount) === 0) {
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: transForm("cant_save_zero_invoice"),
                    time: 2000,
                });
            }
            else {
                // handOSnack({ vertical: 'top', horizontal: 'center' });
                handOSnack({
                    vertical: "top",
                    horizontal: "right",
                    severit: "warning",
                    text: transForm("most_download_item"),
                    time: 2000,
                });
            }
        }
    };


    const hRowrAdd = (newData, resolve) => {
        let restaxvalrA = 0,
            resDiscPerA = 0,
            restotJustSumrA = 0,
            restotJustAfterDiscSumrA = 0,
            resDisCountrA = 0,
            resVal1SumrA = 0,
            resNetrA = 0,
            tot_before_new = 0,
            tot_before_vat_with_tab3val = 0,
            tot_befor_vat_after_disc = 0;

        let updateItem = {};
        updateItem = isdata.find((obj) => obj.barcode.toString() === subInfo.barcode.toString() &&
            parseFloat(obj.new_exchange_price) === parseFloat(subInfo.Price) &&
            parseFloat(obj.DiscPers) === parseFloat(subInfo.DiscPers));

        resVal1SumrA = updateItem ? (parseFloat(subInfo.val1) + parseFloat(updateItem.val1)) : parseFloat(subInfo.val1);

        restotJustSumrA =
            parseFloat(subInfo.Price) * resVal1SumrA;
        resDisCountrA = (
            restotJustSumrA * parseFloat(subInfo.DiscPers / 100)
        ).toFixed(2);
        restotJustAfterDiscSumrA =
            parseFloat(restotJustSumrA) - parseFloat(resDisCountrA);

        restaxvalrA = maths(
            parseFloat(restotJustAfterDiscSumrA),
            parseFloat(subInfo.taxperc),
            "taxval"
        );
        resNetrA = maths(
            parseFloat(restotJustAfterDiscSumrA),
            parseFloat(subInfo.taxperc),
            "Net"
        );
        tot_befor_vat_after_disc = maths(
            parseFloat(restotJustAfterDiscSumrA),
            parseFloat(subInfo.taxperc),
            "before_vat"
        );


        tot_before_new = maths(
            parseFloat(subInfo.Price),
            parseFloat(subInfo.taxperc),
            "before_vat"
        );
        if (subInfo?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
            // if (parseFloat(isdata[or.i].tab3Val)>0) {
            tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                (parseFloat(25) * parseFloat(resVal1SumrA)) : parseFloat(tot_befor_vat_after_disc).toFixed(2);
            let tot_before = (parseFloat(tot_befor_vat_after_disc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

            restaxvalrA = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(subInfo.taxperc),
                "taxval"
            );

            resNetrA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_befor_vat_after_disc)
                + parseFloat(restaxvalrA)).toFixed(2);
        };


        newData = {
            /* to show */
            minPrice: subInfo.minPrice,
            PricePu: subInfo.PricePu,
            unitame: valueItemUnits.unitName /*  - الـوحدة name */,
            symbol: subInfo.symbol /*  - إسم الصنف  */,

            /* to maaths */
            /* int - الإجمالي */
            totJust: restotJustSumrA,
            /* int - إجمالي الخصم بعد الخصم */
            totAfterDisc: tot_befor_vat_after_disc,

            tot_before_vat_after_d: tot_befor_vat_after_disc,
            /* to go */
            currency_from: parseInt(itemId) /* float - id الصنف */,
            unit: parseInt(valueItemUnits.unit) /* int - الـوحدة id */,
            /* float - الكمية */
            val1: resVal1SumrA,
            /* float - العبوة */
            val: parseFloat(subInfo.perc),
            sale_price: parseFloat(valueItemUnits?.sale),

            /* float - الـسعر */
            new_exchange_price: parseFloat(subInfo.Price),
            /* float - الخصم  مبلغ*/
            discount: resDisCountrA,
            /* float - %  خصم نسبة */

            DiscPers: subInfo.DiscPers,
            /* float -  ضريبة القيمة المضافة نسبة */
            taxperc: parseFloat(subInfo.taxperc),

            taxval: restaxvalrA,
            tab3val_sub: tot_before_vat_with_tab3val,
            tab3Val: tot_before_vat_with_tab3val,

            /* float - الصافي */
            netAmountSub: resNetrA,
            barcode: subInfo.barcode /*  - الباركود */,
            sub_center: 0 /* int -  */,
            sub_branch: sto.branchi /* int - الفرع */,
            editAbleVal: false,
            editAblePrice: false,
            editAbleUnit: false,
            editAbleTax: false,
            editAbleDescM: false,
            editAbleDescP: false,
            editAbleDescNote: false,
            UnitsTable: subInfo.UnitsTable,
            defUnit: subInfo.defUnit,
            no: isdata?.length,
            Qtys: subInfo.Qtys,
            type: subInfo.ctype,

        };

        // const updateItem = isdata.find((obj) => obj.barcode.toString() === newData.barcode.toString() &&
        //     obj.new_exchange_price === newData.new_exchange_price && obj.discount==newData.discount);

        if (updateItem) {
            let multiplier = (parseFloat(resVal1SumrA)).toFixed(2);
            if (!isNaN(multiplier)) {

                let tot = parseFloat(multiplier * updateItem.new_exchange_price);

                let desc_mount = (
                    parseFloat(tot) *
                    (updateItem.DiscPers / 100)
                );
                let totBe = parseFloat((multiplier * updateItem.new_exchange_price) - desc_mount);

                let taxMount = maths(
                    parseFloat(totBe),
                    parseFloat(updateItem.taxperc),
                    "taxval"
                );
                let betTax = maths(
                    parseFloat(totBe),
                    parseFloat(updateItem.taxperc),
                    "before_vat"
                );

                let resNetA = maths(
                    parseFloat(totBe),
                    parseFloat(updateItem.taxperc),
                    "Net"
                );
                if (subInfo?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
                    let tot_before_new = maths(
                        parseFloat(isdata[or.i].new_exchange_price),
                        parseFloat(updateItem.taxperc),
                        "before_vat"
                    );
                    tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                        (parseFloat(25) * multiplier) : parseFloat(betTax).toFixed(2);

                    let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

                    taxMount = mathsTab3val(
                        parseFloat(tot_before),
                        parseFloat(updateItem.taxperc),
                        "taxval"
                    );

                    resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                        + parseFloat(taxMount)).toFixed(2);
                }
                const newData = {
                    ...updateItem,
                    val1: multiplier,
                    totJust: tot,
                    totAfterDisc: betTax,
                    taxval: taxMount,
                    netAmountSub: resNetA,
                    discount: desc_mount,
                    tab3val_sub: tot_before_vat_with_tab3val,
                    tab3Val: tot_before_vat_with_tab3val,
                };

                const index = updateItem?.no;
                const dataUpdate = [...isdata];
                dataUpdate[index] = { ...newData };
                setIsData([...dataUpdate]);
                handSums(dataUpdate);
            }
        } else {
            let dataToAdd = [...isdata];
            dataToAdd.push(newData);
            setIsData(dataToAdd);
            handSums(dataToAdd);
            setExSub(dataToAdd.length);

            // let newDatas=[...isdata,newData]
            // setIsData(newDatas);
            // handSums(newDatas);
            // setExSub(newDatas.length);
        }
    };

    const mathsEshar = (rTotAfterDic, taxperc, ty) => {
        if (ty === "taxval") return ((rTotAfterDic * taxperc) / 100).toFixed(2);
        if (ty === "Net")
            return (rTotAfterDic + (rTotAfterDic * taxperc) / 100).toFixed(2);
        if (ty === "before_vat") return rTotAfterDic.toFixed(2);
    };
    const maths = (rTotAfterDic, taxperc, ty) => {

        if (permiCuCo.CWVat == 0 && taxperc != 0) {
            if (ty === "taxval") return ((rTotAfterDic * taxperc) / 100).toFixed(2);
            if (ty === "Net")
                return (rTotAfterDic + (rTotAfterDic * taxperc) / 100).toFixed(2);
            if (ty === "before_vat") return rTotAfterDic.toFixed(2);
        } else if (permiCuCo.CWVat == 1 && taxperc != 0) {
            if (ty === "taxval")
                return (
                    parseFloat(rTotAfterDic) -
                    rTotAfterDic / (1 + taxperc / 100)
                ).toFixed(2);
            if (ty === "Net") return rTotAfterDic.toFixed(2);

            if (ty === "before_vat") return (rTotAfterDic - (rTotAfterDic / ((100 + taxperc) / taxperc))).toFixed(2);

        } else if (taxperc == 0) {
            if (ty === "taxval") return (0).toFixed(2);
            if (ty === "Net")
                return (rTotAfterDic).toFixed(2);
            if (ty === "before_vat") return rTotAfterDic.toFixed(2);
        }
    };
    const mathsTab3val = (rTotAfterDic, taxperc, ty) => {
        if (taxperc == 0) {
            return (0).toFixed(2);
        } else {
            return ((rTotAfterDic * taxperc) / 100).toFixed(2);
        }
    };


    const hRowAdd = (newData, resolve) => {
        setRowUpdate({});
        setLastLtem(true);
        let errorList = [];
        let restaxvalA = 0,
            resNetA = 0,
            restotJustSumA = 0,
            restotJustAfterDiscSumA = 0,
            resDiscPerA = 0,
            resDisCountA = 0,
            check_tot_before = 0,
            tot_before_vat_with_tab3val = 0,
            tot_befor_vat_after_disc = 0;
        restotJustSumA = parseFloat(subInfo.totJust);
        restotJustAfterDiscSumA =
            parseFloat(subInfo.totJust) - parseFloat(subInfo.discount);

        if (checked.discRateck === true) {
            //  alert('in if')
            resDiscPerA = parseFloat(invDisc.rate);
            resDisCountA = (
                parseFloat(invDisc.rate / 100) * parseFloat(subInfo.totJust)
            ).toFixed(2);

            restotJustAfterDiscSumA =
                parseFloat(subInfo.totJust) - parseFloat(resDisCountA);
        } else if (checked.discMinusck === true) {
            if (subInfo.totJust == 0) {
                resDiscPerA = (
                    (parseFloat(idata.minus) / 1) * 100).toFixed(2);
                resDisCountA = (
                    parseFloat(resDiscPerA / 100) * 1
                ).toFixed(2);
            } else {
                resDiscPerA = (
                    (parseFloat(idata.minus) / parseFloat(subInfo.totJust)) * 100).toFixed(2);
                resDisCountA = (
                    parseFloat(resDiscPerA / 100) * parseFloat(subInfo.totJust)
                ).toFixed(2);
            }

        }
        // disc sub level
        else {
            // alert('in else')
            resDiscPerA = parseFloat(subInfo.DiscPers);
            resDisCountA = (
                parseFloat(subInfo.DiscPers / 100) * parseFloat(subInfo.totJust)
            ).toFixed(2);
        }

        restaxvalA = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(subInfo.taxperc),
            "taxval"
        );

        tot_befor_vat_after_disc = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(subInfo.taxperc),
            "before_vat"
        );
        resNetA = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(subInfo.taxperc),
            "Net"
        );
        check_tot_before = maths(
            parseFloat(subInfo.Price),
            parseFloat(subInfo.taxperc),
            "before_vat"
        );
        if (subInfo?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
            tot_before_vat_with_tab3val = (parseFloat(check_tot_before) <= parseFloat(25)) ?
                (parseFloat(25) * parseFloat(subInfo.val1)).toFixed(2) : parseFloat(tot_befor_vat_after_disc).toFixed(2);

            let tot_before = (parseFloat(tot_befor_vat_after_disc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

            restaxvalA = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(subInfo.taxperc),
                "taxval"
            );

            resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_befor_vat_after_disc) + parseFloat(restaxvalA)).toFixed(2);
        };
        newData = {
            /* to show */
            minPrice: subInfo.minPrice,
            PricePu: subInfo.PricePu,
            unitame: valueItemUnits.unitName /*  - الـوحدة name */,
            symbol: subInfo.symbol /*  - إسم الصنف  */,
            /* to maaths */
            /* int -  الإجمالي */
            totJust: restotJustSumA,
            /* int - إجمالي الخصم بعد الخصم */
            totAfterDisc: tot_befor_vat_after_disc,

            tot_before_vat_after_d: tot_befor_vat_after_disc,

            tab3val_sub: tot_before_vat_with_tab3val,
            tab3Val: tot_before_vat_with_tab3val,
            /* to go */
            // currency_from: parseInt(subInfo.id), /* float - id الصنف */
            // currency_from: parseInt(subInfo.id) /* float - id الصنف */,
            currency_from: parseInt(itemId) /* float - id الصنف */,
            unit: parseInt(valueItemUnits.unit) /* int - الـوحدة id */,
            sale_price: parseFloat(valueItemUnits?.sale),
            /* float - الكمية */
            val1: parseFloat(subInfo.val1),
            // new _val1:parseFloat(subInfo.new _val1),
            /* float - العبوة */
            val: parseFloat(subInfo.perc),
            // new _val:parseFloat(subInfo.perc),
            /* float - الـسعر */
            new_exchange_price: parseFloat(subInfo.Price),
            // all_new_exchange_price: parseFloat(subInfo.Price),
            /* float - الخصم  مبلغ*/
            discount: resDisCountA,
            // new _discount: parseFloat(subInfo.discount),
            /* float - %  خصم نسبة */
            DiscPers: resDiscPerA,
            // new _DiscPers: parseFloat(subInfo.DiscPers),
            /* float -  ضريبة القيمة المضافة نسبة */
            taxperc: parseFloat(subInfo.taxperc),
            // new _taxperc: parseFloat(subInfo.taxperc),
            /* float - إجمالي قيمة المضافة  */
            // taxval: subInfo?.is_tab3_curr == 1 ? 2 * restaxvalA : restaxvalA,
            taxval: restaxvalA,
            /* float - الصافي */
            // netAmountSub: resNetA,
            netAmountSub: resNetA,
            // netAmo untSub: parseFloat(subInfo.totJust-subInfo.discount) + parseFloat((subInfo.totJust-subInfo.discount)*subInfo.taxperc/100),
            barcode: subInfo.barcode /*  - الباركود */,
            sub_center: 0 /* int -  */,
            sub_branch: sto.branchi /* int - الفرع */,
            editAbleVal: false,
            editAblePrice: false,
            editAbleUnit: false,
            editAbleTax: false,
            editAbleDescM: false,
            editAbleDescP: false,
            editAbleDescNote: false,
            UnitsTable: subInfo.UnitsTable,
            defUnit: subInfo.defUnit,
            no: isdata?.length,
            Qtys: subInfo.Qtys,
            notes: subInfo?.notes,
            type: subInfo.ctype,
        };
        if (errorList.length < 1) {
            //no error
            let dataToAdd = [...isdata];
            dataToAdd.push(newData);
            setIsData(dataToAdd);
            handSums(dataToAdd);
            setExSub(dataToAdd.length);
        } else {
            resolve();
        }
    };

    const [sums, setSums] = useState(insh.Sums);

    // الدفع المبقي
    const [payment, setPayment] = useState(insh.Payment);
    const [remains, setRemains] = useState(insh.Remains);
    const [isHedden, setIshedden] = useState(false);
    const [isUpdateDate, setIsUpdateDate] = useState(false);
    const [keepDate, setKeepDate] = useState(false);
    // const [keepDate, setKeepDate] =useLocalStorage("keep-purch-date", false);

    const [dateKeep, setDateKeep] = useState({ Date: moment(new Date()).format('YYYY-MM-DD') });


    const [isOpenUpdate, setIsOpenUpdate] = useState(false);
    const [isUpdate, setUpdate] = useState(false);

    const [isHeddenReturn, setIsheddenReturn] = useState(false);

    const [isClick, setIsClick] = useState(insh.ished);


    const handSums = (data) => {
        let val1s = 0,
            tot_sale_or_purch = 0,
      /*tot_sales=0,tot_purchs=0,*/ amountOfVats = 0,
            netAmounts = 0,
            amountAfterDiscs = 0,
            amount_after_disc_before_vat = 0,
            discounts = 0,
            amountWithVats = 0,
            invTab3Val = 0,
            tab3Val = 0,
            taxpercs;

        for (var m = 0; m < data.length; m++) {
            val1s += parseFloat(data[m].val1);
            tot_sale_or_purch += parseFloat(data[m].totJust);
            taxpercs = data[m].taxperc;
            /* جمالي القيمة المضافة */
            amountOfVats += parseFloat(data[m].taxval);
            netAmounts += parseFloat(data[m].netAmountSub);
            /* إجمالي قبل الضريبة */
            amountAfterDiscs += parseFloat(data[m].totAfterDisc);
            discounts += parseFloat(data[m].discount);

            // tobacco tax
            invTab3Val += parseFloat(data[m].tab3Val);
            amount_after_disc_before_vat += parseFloat(data[m].totAfterDisc);
        }

        /* في الحالتين */
        /* إجمالي بعد الخصم */
        amountWithVats = (
            parseFloat(tot_sale_or_purch) - parseFloat(discounts)
        ).toFixed(2);
        /* يشمل */
        tab3Val = parseFloat(invTab3Val).toFixed(2);

        if (permiCuCo.CWVat == 1) {
            if (tab3Val > 0) {
                amountAfterDiscs = (
                    parseFloat(amount_after_disc_before_vat)
                ).toFixed(2);
                amountOfVats = (
                    parseFloat(amountOfVats)
                ).toFixed(2);
                netAmounts = (
                    parseFloat(amount_after_disc_before_vat) + parseFloat(amountOfVats) + parseFloat(tab3Val)
                ).toFixed(2);
                amountWithVats = (
                    parseFloat(netAmounts)
                ).toFixed(2);

            } else {
                amountAfterDiscs = (
                    parseFloat(amount_after_disc_before_vat)
                ).toFixed(2);
                amountOfVats = (
                    parseFloat(amountWithVats) - parseFloat(amountAfterDiscs)
                ).toFixed(2);
                netAmounts = (
                    parseFloat(amountWithVats)
                ).toFixed(2);
            }
        } else {
            /*لا يشمل */
            amountAfterDiscs = (
                parseFloat(amount_after_disc_before_vat)
            ).toFixed(2);

            netAmounts = (
                parseFloat(amountAfterDiscs) + parseFloat(amountOfVats) + parseFloat(tab3Val)
            ).toFixed(2);

            amountWithVats = (
                parseFloat(amountAfterDiscs) + parseFloat(amountOfVats) + parseFloat(tab3Val)
            ).toFixed(2);


        }



        setSums({ val1: val1s });
        setIData({
            ...idata,
            amountAfterDisc: amountAfterDiscs,
            amountWithVat: amountWithVats,
            tot_sale: tot_sale_or_purch,
            tot_purch: tot_sale_or_purch,
            netAmount: netAmounts,
            amountBefordisc: tot_sale_or_purch,
            amountOfVat: amountOfVats,
            minus: discounts,
            tab3Val: invTab3Val,
        });



        fcHandSumsToPayment(netAmounts);

        fcHandSumsToinvDisc(tot_sale_or_purch, discounts);
    };

    const fcHandSumsToPayment = (newExPrice) => {
        // screan payment
        if (idata.inv_type == 1) {
            setPayment({ ...payment, stay: newExPrice, paidup: 0 });
            setRemains({ ...remains, cashPart: 0, agelPart: newExPrice, bankPart: 0, networkPart: 0 });
        }
        else {
            setPayment({ ...payment, paidup: newExPrice, stay: 0 });
            if (switchState.cashORnetworksw == false) {
                setRemains({ ...remains, cashPart: newExPrice, agelPart: 0, bankPart: 0, networkPart: 0 });
            } else if (switchState.cashORnetworksw == true) {
                setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: newExPrice });
            }
        }
    };

    const fcHandSumsToinvDisc = (totj, discs) => {
        // قيمة الخصم  مبلغ
        if (totj == 0 || totj == "") totj = 1;
        setInvDisc({
            minus: discs,
            rate: (parseFloat(parseFloat(discs) / totj) * 100).toFixed(2),
        });

    };

    const handRowAdd = (or) => {
        if (or.cros === "newRow") {
            hRowAdd();
        } else if (or.cros === "rnewRow") {
            if (permistionInv?.NOREP === true) {
                hRowAdd();
            } else {
                hRowrAdd();
            }

        }
        // }
    };
    const hRowUpdate = (newData, oldData, resolve) => {

        if (newData.new_exchange_price === "") newData.new_exchange_price = 1;
        if (newData.discount === "") newData.discount = 0;
        if (newData.val1 === "") newData.val1 = 1;
        if (newData.DiscPers === "") newData.DiscPers = 0;

        if (newData.new_exchange_price === "") { newData.new_exchange_price = 0; setInvDisc({ ...invDisc, minus: 0, rate: 0 }); };
        if (newData.discount === "") { newData.discount = 0; setInvDisc({ ...invDisc, minus: 0, rate: 0 }); };
        if (newData.val1 === "") { newData.val1 = 0; setInvDisc({ ...invDisc, minus: 0, rate: 0 }); };

        if (newData.DiscPers === "") { newData.DiscPers = 0; setInvDisc({ ...invDisc, minus: 0, rate: 0 }); };
        if (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12" || setting.PrTy_InPr === "01" || setting.PrTy_InPr === "11") {

            let val1 = newData.val1 == 0 ? 1 : newData.val1;
            let subInfoVal1_perc = val1 * newData.val;
            //   let countsCurr = parseInt(rowItem?.balance) - parseInt(rowItem?.val1);
            let totValbef = 0.0;
            for (let m = 0; m < isdata.length; m++) {
                if (oldData.currency_from == isdata[m].currency_from && oldData.no != isdata[m]?.no)
                    totValbef += (isdata[m].val1 * isdata[m].val);
            };

            let countsCurr = Number(oldData?.Qtys) - totValbef;
            let maxPrice = parseFloat(permistionInv?.MAXPRICE ?? 100000);
            let maxQty = parseFloat(permistionInv?.MAXQTY ?? 100000);

            if (permistionInv.SIM == false &&
                countsCurr < subInfoVal1_perc &&
                (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
                alert(
                    `
          الكمية المدخلة للصنف أكبر من رصيد المخزن
          الكمية الاجمالية المدخلة : ${Number(totValbef) + (parseFloat(newData?.val1) * parseFloat(newData?.val))
                    }
          رصيد المخزن : ${valueSafes.name} = ${parseInt(newData?.Qtys)
                    }
          `
                );
                const dataUpdate = [...oldData];
                const index = oldData.tableData.id;
                dataUpdate[index] = oldData;
                setIsData([...dataUpdate]);
                resolve();
            } else if ((setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12") &&
                parseFloat(newData.val1) > parseFloat(maxQty)) {
                alert(
                    `لقد تجاوزت حد الكمية المسموح فيها... برجاء الذهاب لاعدادات النظام لزيادة الحد:  ${maxQty}`
                );
                const dataUpdate = [...oldData];
                const index = oldData.tableData.id;
                dataUpdate[index] = oldData;
                setIsData([...dataUpdate]);
                resolve();

            }

            else {
                if ((setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12") &&
                    permistionInv.SNOP === true && newData != null &&
                    parseFloat(newData.Price) < parseFloat(newData.PricePu)) {

                    alert(
                        permiCuCo.HPP ? `لا يمكن البيع اقل من سعر الشراء للصنف ` :
                            `لا يمكن البيع اقل من سعر الشراء للصنف سعر الشراء المسجل للصنف هو : ${newData.PricePu}`
                    );
                    const dataUpdate = [...oldData];
                    const index = oldData.tableData.id;
                    dataUpdate[index] = oldData;
                    setIsData([...dataUpdate]);
                    resolve();
                } else if ((setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12") &&
                    parseFloat(newData.new_exchange_price) > parseFloat(maxPrice)) {
                    alert(
                        `لقد تجاوزت حد السعر المسموح فيه... برجاء الذهاب لاعدادات النظام لزيادة الحد:  ${maxPrice}`
                    );
                    const dataUpdate = [...oldData];
                    const index = oldData.tableData.id;
                    dataUpdate[index] = oldData;
                    setIsData([...dataUpdate]);
                    resolve();
                }
                else if ((setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12") && permistionInv.SNOMIN === 1 &&
                    parseFloat(newData.new_exchange_price) < parseFloat(newData.minPrice)) {
                    alert(
                        `لا يمكن البيع اقل من السعر الادنى للصنف السعر الادنى المسجل للصنف هو : ${newData.minPrice}`
                    );
                    const dataUpdate = [...oldData];
                    const index = oldData.tableData.id;
                    dataUpdate[index] = oldData;
                    setIsData([...dataUpdate]);
                    resolve();
                }
                else if ((setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12") &&
                    permistionInv.ASPZ === false && newData.new_exchange_price <= 0) {

                    alert(
                        `لا يوجد لديك صلاحية البيع بسعر صفر `
                    );
                    const dataUpdate = [...oldData];
                    const index = oldData.tableData.id;
                    dataUpdate[index] = oldData;
                    setIsData([...dataUpdate]);
                    resolve();

                }
                else if ((setting.PrTy_InPr === "01" || setting.PrTy_InPr === "11") &&
                    permistionInv.ASPZ === true && newData.new_exchange_price <= 0) {

                    alert(
                        `لا يوجد لديك صلاحية الشراء بسعر صفر `
                    );
                    const dataUpdate = [...oldData];
                    const index = oldData.tableData.id;
                    dataUpdate[index] = oldData;
                    setIsData([...dataUpdate]);
                    resolve();

                }
                else if (permistionInv.APDC === 1 && permistionInv.DSOI == 1 && parseFloat(newData.DiscPers) > parseFloat(permistionInv.SDP)) {
                    alert(
                        `
       لقد تجاوزت نسبة الخصم المسموح بها
       نسبة الخصم المسموح بها : ${parseFloat(permistionInv.SDP)
                        }
       `
                    );
                }
                else if (permistionInv.APDC === 2 && permistionInv.DSOI == 1 && parseFloat(newData.discount) > parseFloat(permistionInv.SDV)) {
                    alert(
                        `
       لقد تجاوزت مبلغ الخصم المسموح بها
       مبلغ الخصم المسموح بة : ${parseFloat(permistionInv.SDV)
                        }
       `
                    );
                }
                else if (permistionInv.APDC === 3 && permistionInv.DSOI === 1 &&
                    ((parseFloat(permistionInv.SDV) != 0 && newData.discount > permistionInv.SDV) ||
                        (parseFloat(permistionInv.SDP) != 0 && parseFloat(newData.DiscPers) > parseFloat(permistionInv.SDP)))) {
                    alert(
                        `
       لقد تجاوزت حد الخصم المسموح بها
         }
       `
                    );
                }
                else {
                    TableRowUpdate(newData, oldData, resolve);

                }
            }

        } else {
            TableRowUpdate(newData, oldData, resolve);

        }
    };

    const TableRowUpdate = (newData, oldData, resolve) => {
        let resDisCountU = 0,
            restotJustSumU = 0,
            restaxvalU = 0,
            resNetU = 0,
            decPerces = 0,
            tot_before_vat_after_desc = 0,
            tot_before_vat_with_tab3val = 0,
            tot_before_only = 0,
            tot_before_new = 0,
            newtotJust;

        // let i = {
        //   newPrice: Number(newData.new_exchange_price),
        //   newDiscount: Number(newData.discount),
        //   newVal: Number(newData.val1),
        //   newDisc: Number(newData.DiscPers),

        // };

        if (newData.new_exchange_price === "") newData.new_exchange_price = 1;
        if (newData.discount === "") newData.discount = 0;
        if (newData.val1 === "") newData.val1 = 1;
        if (newData.DiscPers === "") newData.DiscPers = 0;

        newtotJust = (parseFloat(newData.new_exchange_price) * parseFloat(newData.val1));

        if (parseFloat(newData.DiscPers) == 0 && parseFloat(newData.discount) == 0) {

            resDisCountU = (

                parseFloat(newData.DiscPers / 100) *
                parseFloat(newData.new_exchange_price) *
                parseFloat(newData.val1)
            ).toFixed(2);

        } else if (parseFloat(newData.DiscPers) !== 0 && parseFloat(newData.discount) == 0) {

            resDisCountU = (

                parseFloat(newData.DiscPers / 100) *
                parseFloat(newData.new_exchange_price) *
                parseFloat(newData.val1)
            );

        } else if (parseFloat(newData.DiscPers) !== 0 && parseFloat(newData.discount) !== 0) {

            resDisCountU = (

                parseFloat(newData.DiscPers / 100) *
                parseFloat(newData.new_exchange_price) *
                parseFloat(newData.val1)
            );

        }
        else if (parseFloat(newData.DiscPers) == 0 && parseFloat(newData.discount) !== 0) {

            resDisCountU = parseFloat(newData.discount);
        }
        else {
            resDisCountU = parseFloat(newData.discount);
        }

        restotJustSumU = parseFloat(
            (parseFloat(newData.new_exchange_price) * parseFloat(newData.val1)) - resDisCountU
        );
        decPerces = (
            (parseFloat(newData.totJust) - parseFloat(restotJustSumU)) / (parseFloat(newData.totJust) * 100)

        )
        restaxvalU = maths(
            parseFloat(restotJustSumU),
            parseFloat(newData.taxperc),
            "taxval"
        );
        resNetU = maths(
            parseFloat(restotJustSumU),
            parseFloat(newData.taxperc),
            "Net"
        );

        tot_before_vat_after_desc = maths(
            parseFloat(restotJustSumU),
            parseFloat(newData.taxperc),
            "before_vat"
        );
        if (newData?.tab3val_sub > 0 && permistionInv?.USETOBACO) {
            tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                (parseFloat(25) * newData.val1) : parseFloat(tot_before_vat_after_desc).toFixed(2);

            let tot_before = (parseFloat(tot_before_vat_after_desc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

            restaxvalU = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(newData.taxperc),
                "taxval"
            );

            resNetU = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_before_vat_after_desc)
                + parseFloat(restaxvalU)).toFixed(2);
        }
        console.log("the old data is", oldData);
        console.log("the new data is", newData);
        newData = {
            /* to show */
            // unitame: LetvalueCurrUnits.name, /*  - الـوحدة name */
            unitame: newData.unitame /*  - الـوحدة name */,
            symbol: newData.symbol /*  - إسم الصنف  */,
            /* to maaths */
            /* float - الإجمالي */
            // totJust: newData.new_exchange_price * newData.val1,
            totJust: newtotJust,
            /* float - الإجمالي بعد الخصم */
            totAfterDisc: tot_before_vat_after_desc,

            tot_before_vat_after_d: tot_before_vat_after_desc,

            tab3val_sub: tot_before_vat_with_tab3val,
            tab3Val: tot_before_vat_with_tab3val,
            // totAfterDisc: newData.val1 * newData.new_exchange_price - newData.discount,
            /* to go */

            currency_from: newData.currency_from /* float - id الصنف */,
            unit: newData.unit /* int - الـوحدة id */,
            /* float - الكمية */
            val1: newData.val1,
            // new _val1:newData.new _val1,
            /* float - العبوة */
            val: newData.val,
            // new _val:newData.val,
            /* float - الـسعر */
            new_exchange_price: newData.new_exchange_price,
            // all_new_exchange_price: newData.new_exchange_price,
            /* float - الخصم مبلغ _ قيمة الخصم  مبلغ*/
            discount: resDisCountU,
            DiscPers: newData.DiscPers == "" ? 0 : newData.DiscPers,
            // new _DiscPers: newData.DiscPers,
            /* float -  ضريبة القيمة المضافة نسبة */
            taxperc: newData.taxperc,
            // new _taxperc: newData.taxperc,
            /* float - إجمالي قيمة المضافة  */


            taxval: restaxvalU,
            // new _taxval: (newData.totJust-newData.discount)*newData.taxperc/100,
            /* float - الصافي */

            // netAmountSub: resNetU,
            netAmountSub: resNetU,
            // netAmo untSub: ((restotJustSumU - resDisCountU)+((restotJustSumU-resDisCountU)*newData.taxperc/100)).toFixed(2),
            barcode: newData.barcode /*  - الباركود */,
            sub_center: 0 /* int -  */,
            sub_branch: sto.branchi /* int - الفرع */,
            notes: newData.notes /* string - ملاحضة */,
            sale_price: newData.sale_price /* string - سعر الببيع */,
            tot_before_vat_after_d: tot_before_vat_after_desc,
            UnitsTable: newData.UnitsTable,
            defUnit: newData.defUnit,
            no: newData.no,
            editAbleVal: false,
            editAblePrice: false,
            editAbleUnit: false,
            editAbleTax: false,
            editAbleDescM: false,
            editAbleDescP: false,
            editAbleDescNote: false,
            Qtys: oldData?.Qtys,
            type: 1,

        };
        const dataUpdate = [...isdata];
        const index = oldData.tableData.id;
        dataUpdate[index] = newData;
        setIsData([...dataUpdate]);
        handSums(dataUpdate);
        resolve();
    };


    const hRowDelete = (event, rowData) => {
        let dataDelete = [...isdata];

        rowData.forEach((rd) => {
            dataDelete = dataDelete.filter((t) => t.tableData.id !== rd.tableData.id);
        });

        setIsData([...dataDelete]);
        // 
        // setIsData(dataDelete);
        handSums(dataDelete);

        if (dataDelete.length === 0) {
            setIsData([]);
            setInvDisc(insh.InvDisc);
            toDoIdata("minus", "");
            setIData({
                ...idata, netAmount: 0,
                amountOfVat: 0,
                amountWithVat: 0,
                tot_purch: 0,
                totAfterDisc: 0,
                amountOfVats: 0,
                cash_part: 0,
                agel_part: 0,
                bank_part: 0,
                network_part: 0,
                Pay_mouny: 0,
                tot_sale: 0,
                Remaining: 0,
                tab3Val: 0,
                taxperc: 0,
                netAmount: 0,
                amountAfterDisc: 0,
                minus: 0,
                discounts: 0,
                amountBefordisc: 0,
            });
            setPayment({
                ...payment,
                paidup: 0,
                stay: 0,
            });
            setRemains({
                ...remains,
                cashPart: 0,
                agelPart: 0,
                networkPart: 0,
                bankPart: 0,
                empPart: 0,
            });
            setExSub(0);
        }
        setExSub(dataDelete.length);
    };

    const pinAutosValue = async (Tbl, id) => {
        if (Tbl === "Safe") {
            var res_safe = AutoOptions.Safes.find((obj) => obj.id === id);
            setValueSafes(res_safe);
            // AutoOptions.Safes.map((x) => {
            //     if (x.id == id) setValueSafes(x);
            // });
        }
        else if (Tbl === "Stock") {
            // AutoOptions.Stocks.map((x) => {
            //     if (x.id == id) setValueStock(res_stock);
            // });
            var res_stock = AutoOptions.Stocks.find((obj) => obj.id === id);
            setValueStock(res_stock);
        }
        else if (Tbl === "omla") {
            var res_omla = gets.omlats.find((obj) => obj.id === id);
            setOmlaValue(res_omla);
        }
        else if (Tbl === "Customer") {
            var res_cust = AutoOptions.Customers.find((obj) => obj.id === id);
            if (res_cust) { setValueCustomers(res_cust); }
            else {
                viewHandleCustomers('', setOptionsCustomers, false, setting.cusType, id, AutoOptions.Customers, setValueCustomers)
            }
        } else if (Tbl === "salesmen") {
            var res_sal = gets.salesmen.find((obj) => obj.id === id);
            setValueSalesmen(res_sal);
            // gets.salesmen.map((x) => {
            //     if (x.id == id) setValueSalesmen(x);
            // });
        }
        else if (Tbl === "costcenter") {
            var res_center = gets.costcenters.find((obj) => obj.id === id);
            setValueCostcenter(res_center);
        }
        // gets.costcenters.map((x) => {
        //     if (x.id == id) setValueCostcenter(x);
        // });

        else if (Tbl === "BankNET") {
            var res_bank = AutoOptions.Banks.find((obj) => obj.i === id);
            setValueBank(res_bank);
            setValueBankPMD(res_bank);

        }
        else if (Tbl === "Bank") {
            var res_bank = AutoOptions.Banks.find((obj) => obj.i === id);
            setValueBank(res_bank);
            // AutoOptions.Banks.map((x) => {
            //     if (x.i == id) setValueBank(x);
            // });
        }
        else if (Tbl === "BankPMD") {
            var res_bank2 = AutoOptions.Banks.find((obj) => obj.i === id);
            setValueBankPMD(res_bank2);
        }
        else if (Tbl === "Bank2PMD") {
            var res_bank2 = AutoOptions.Banks.find((obj) => obj.i === id);
            setValueBanksPaid(res_bank2);
        }
        else if (Tbl === "EmployeePMD") {
            // gets.Employees.map((x) => {
            // if (x.id == id) setValueEmployePMD(x);
            // });
            var res_emp = gets.Employees.find((obj) => obj.id === id);
            setValueEmployePMD(res_emp);
        }
        // }).catch(error => { })
    };
    const valueBranch = AutoOptions.Branches.find((obj) => obj.id === sto.branchi);
    const [rptParamsSearch, setRptParamsSearch] = React.useState({
        ...defualtValueSearch,
        user: AutoOptions?.Users[0], branch: valueBranch,
        selectTime: permistionInv?.SHOWCAR ? selectDateOrTimeCar[0] : selectDateOrTime[0],
    });
    // const [numberbarcode, setNumberbarcode] = useState("");
    // const [isBarcode, setIsBarcode] = useState(false);
    const [isApiConnect, setIsApiConnect] = useState(true);

    // useEffect(() => {
    //   if (isBarcode) {
    //     getrowDataCurrencie();
    //     setNumberbarcode("");
    //   }
    // }, [isBarcode]);

    const [barcoding, setBarcoding] = useState(false);

    const [multiCodeList, setMultiCodeList] = useState([]);
    const [code, setCode] = useState([]);

    const onChangeData = (propName) => (event) => {
        if (propName == "barcode" || propName == "barcodeNormal") {
            setRptParams({ ...rptParams, [propName]: event.target.value });
        } else {
            setRptParams({ ...rptParams, [propName]: event.target.value });
        }
    };
    const searchTimeout = useRef(null);

    const localSearch = (newValue) => {
        setSearchText(newValue);
        const search = newValue?.trim().toLowerCase();
        return AutoOptions.InvItems.filter((obj) => obj?.name.toLowerCase().includes(search) ||
            obj?.nameE.toLowerCase().includes(search));
    };
    const handleInputSearchCust = (event, newValue, reason) => {
        handleInputSearchCustomers(newValue, AutoOptions.Customers, searchTimeout, setOptionsCustomers,
            countCustomers, setting.cusType, false, setSearchCustText, reason);
    };
    const handleIconSearch = () => {
        if (countItem && searchText != "") {
            viewHandleSearchInv(null, true, setFildSearch, searchText, stor, rptParams,
                setFetching, setOptionsItemsSearch, setcuRows, setting, valueSafes, 50);
        }
    };
    const handleIconSearchCust = () => {
        if (countCustomers && searchCustText !== "" || searchCustText !== null) {
            viewHandleCustomers(searchCustText, setOptionsCustomers, false, setting.cusType, -1, AutoOptions.Customers);
        }
    };
    const handleInputSearch = (event, newValue, reason) => {
        // allowKeyboard=false;
        if (searchTimeout.current) {
            clearTimeout(searchTimeout.current);
        }
        if (!newValue || newValue.length < 1 || reason !== "input") {
            setOptionsItemsSearch(AutoOptions?.InvItems);
            return;
        }
        searchTimeout.current = setTimeout(async () => {
            const opLocItems = localSearch(newValue);
            if (opLocItems.length > 0) {
                setOptionsItemsSearch(opLocItems ?? []);
                return;
            } else if (countItem) {
                if (fildSearch) { viewItemsHandleInv(null, true, newValue, rptParams, setFetching, setOptionsItemsSearch, setcuRows); }
                else {
                    viewHandleSearchInv(null, true, setFildSearch, newValue, stor, rptParams,
                        setFetching, setOptionsItemsSearch, setcuRows, setting, valueSafes, 50);
                }
            } else {
                setOptionsItemsSearch([]);
            }
        }, 500);
    };

    const onChangeAutoDataSubCurr = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue });
        setSearchText("");
        if (newValue.id === "" || newValue.id == null) {

        } else {
            if (cuRows?.length > 0 || optionsItemsSearch.length > 0) {
                const allItem = [...cuRows, ...optionsItemsSearch];
                const newItem = allItem.find((obj) => obj.barcode.toString() === newValue.barcode.toString());
                if (newItem && newItem?.units?.length > 0 && (permistionInv.SIM || ["22", "01", "12", "03", "04"].includes(setting.PrTy_InPr))) {
                    const unitF = newItem.units.find((x) => x.unit === newItem.unit);
                    getDataItemsNoApi(newItem, unitF, setting, permistionInv, valueCustomers, subInfo, setSubInfo,
                        invDisc, idata, checked, isdata, setIsData, handSums, true, setItemId, permiCuCo.CWVat);

                    setItemId(newValue.id);
                    setRptParams({ ...rptParams, barcode: '', curr: {} });
                } else {
                    changeItemAuto(newValue);
                }
            } else {
                changeItemAuto(newValue);
            }
        }
    };
    const changeItemAuto = (newValue) => {

        const isMezan = permistionInv?.USEMEZAN && (newValue.barcode.length === 13 || newValue.barcode.length === 18) &&
            (newValue.barcode.startsWith("99") || newValue.barcode.startsWith("21") || newValue.barcode.startsWith("27")) ? true : false;
        const newItem = localCashe.find((obj) => obj.item.barcode.toString() === newValue.barcode.toString());
        if (newItem && !isMezan) {
            setRptParams({ ...rptParams, barcode: '', barcodeS: '', curr: {} });
            let oldVal = 0;
            let totValbef = 0.0;
            if (permistionInv.SIM == false) {
                for (let m = 0; m < isdata.length; m++) {
                    if (newItem?.item?.curr == isdata[m].currency_from)
                        totValbef += (isdata[m].val1 * isdata[m].val);
                };
                oldVal = Number(newItem.val) - totValbef;
            }
            if (checkValueQ(setting, permistionInv, newItem?.item?.ctype, oldVal) == 0) {
                getAlertValQ(valueSafes, newItem.val, newItem?.item?.curr, newItem?.item?.perc);
            } else {
                addnewItems({ ...newItem?.item }, { ...newItem?.unit }, newItem.units, newItem.val, true);
            }
        } else {
            if (permistionInv?.SIM && permistionInv?.JRDSH) {
                getBarcodeFast(newValue.barcode, false, true);
            } else {
                getBarcodeMulti(newValue.barcode, false, true);
            }
        }
    }
    const [groupsOptions, setGroupsOptions] = useState(() => {
        return [{ id: -1, name: "الكل", parentId: -1 }, ...AutoOptions.groups];
    });
    const onChangeAutoDataG = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue, groupSe: newValue });
        if (newValue.id == null) {
            setGroupsSubs([]);
        } else {
            var subGroup = AutoOptions.groupsSub.filter((obj) => obj.parentId == newValue.id);
            setGroupsSubs([...subGroup]);
        }
        viewHandle(newValue.id);
    };
    const onChangeAutoDataSub = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue, groupSe: newValue });
        viewHandle(newValue.id);

    };
    const onChangeSearchD = (event) => {
        if (checked.autoOrStaticck == true) {
            event.preventDefault();
            event.stopPropagation();
            getBarcodeMulti(rptParams?.barcodeS, false, true);
        } else {
            event.preventDefault();
            event.stopPropagation();
            GetItemSearch(rptParams?.barcodeS);
        }
    };
    const onChangeDataA = (propName) => (event) => {
        setRptParams({ ...rptParams, [propName]: event.target.value });
    };
    const [fetching, setFetching] = useState(false);

    const viewHandle = (group_id) => {
        // if(fildSearch) { viewItemsHandle(group_id, false, null)}else{ viewHandleSearch(group_id, false, null);}
        if (fildSearch) { viewItemsHandleInv(group_id, false, null, rptParams, setFetching, setOptionsItemsSearch, setcuRows); }
        else {
            viewHandleSearchInv(group_id, false, setFildSearch, null, stor, rptParams,
                setFetching, setOptionsItemsSearch, setcuRows, setting, valueSafes, 40);
        }
    }

    const [groupsSubs, setGroupsSubs] = useState([]);
    const [custData, setCustData] = useState({});
    const [newItemsAdd, setNewItemsAdd] = useState({ id: "", barcode: "" });

    const GetItemSearch = async (itemcode) => {

        let item = null;

        if (itemcode == null) {

        } else {

            await axios
                .get(
                    uri +
                    `RptSales/CurrCodes?currCode=${itemcode}
            &&emp=${sto.empi}`
                )
                .then((res) => {
                    item = res.data?.barcodes[0];
                })
                .catch((err) => {
                    toast.error("لا يوجد صنف لهذا الباركود");
                    console.log(err);
                });
            if (item != null) {
                await getListSearch(item);
            } else {
                toast.error("لا يوجد صنف لهذا الباركود");
            }
        }
    };

    const getListSearch = (dataItem) => {
        // eds-changes
        var nameGroup = AutoOptions.groups.find((x) => x.id === dataItem.group_id);

        setcuRows(
            [
                {
                    ...dataItem,
                    namG: nameGroup,
                    sale_price: dataItem.sale,
                    purch_price: dataItem.purch,
                    img: null,
                }]
        );

    }

    const getBarcodeMezan = async (itemcode) => {
        let item = null;
        let mezan = null;
        let ibance = null;
        let units = null;
        let defaultUnits = null;
        if (itemcode == null) {

        } else {
            await axios
                .get(
                    uri +
                    `RptSales/ItemsCodesMezan?currCode=${itemcode}
            &&emp=${sto.empi}&&safe=${valueSafes.id}`
                )
                .then((res) => {
                    defaultUnits = res.data?.unitsSub.find((x) => x.unit === res.data?.barcodes[0].unit);
                    units = res.data?.unitsSub;
                    item = res.data?.barcodes[0];
                    mezan = res.data?.mezan[0];
                    ibance = res.data?.balance[0].Qtys ?? 0;
                })
                .catch((err) => {
                    console.log(err);
                });
            if (item != null) {
                setRptParams({ ...rptParams, barcode: '', barcodeS: '' });
                let oldVal = 0;
                let totValbef = 0.0;
                if (permistionInv.SIM == false) {
                    for (let m = 0; m < isdata.length; m++) {
                        if (item.curr == isdata[m].currency_from)
                            totValbef += (isdata[m].val1 * isdata[m].val);
                    };
                    oldVal = Number(ibance) - totValbef;
                }
                if (checkValueQ(setting, permistionInv, item?.ctype, oldVal) == 0) {
                    getAlertValQ(valueSafes, ibance, item?.curr, item?.perc);
                } else {
                    await barcodeaddMezan({ ...item }, { ...mezan }, { ...defaultUnits }, units, ibance);
                }
            } else {
                alert(
                    `لا يوجد صنف لهذا الباركود"
    `
                );
                setRptParams({ ...rptParams, barcode: itemcode, barcodeS: itemcode, curr: {} });
            }
        }
    };

    const barcodeaddMezan = (dataCode, mezan, defaultUnits, units, ibance) => {
        setRowUpdate({});
        setLastLtem(true);
        let pricei = 0.0;
        let totJust = 0.0;
        let taxval = 0.0;
        let taxperc = 0.0;
        let diaperc = 0.0;
        let dismount = 0.0;
        let valperc = 0.0;
        let tot_before_vat_with_tab3val = 0.0;

        if (setting.PrTy_InPr === "22") {
            taxperc = 0.0;
            pricei = parseFloat(dataCode?.purch).toFixed(2);
        } else if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03") {
            pricei = mezan.isMizan === true && mezan.usePrice === true ? parseFloat(mezan.price) : parseFloat(dataCode?.sale);
            taxperc = (parseFloat(dataCode.tax)).toFixed(2);
        }
        else {
            pricei = parseFloat(dataCode?.purch);
            taxperc = (parseFloat(dataCode.tax)).toFixed(2);
        };
        if (valueCustomers?.disc_perc > 0 || valueCustomers?.discount > 0) {
            if (valueCustomers?.disc_perc > 0) {
                dataCode.discount = valueCustomers?.disc_perc;
                dataCode.amount_disc = 0;
            } else if (valueCustomers?.discount > 0) {
                dataCode.discount = 0;
                dataCode.amount_disc = valueCustomers?.discount;
            }
        }

        let valQ = (mezan.isMizan === true && mezan.usePrice === false) ? parseFloat(mezan.val1) :
            mezan?.useVal != null && mezan?.useVal == true ? parseFloat(mezan.val1) : parseFloat(1);

        totJust = (parseFloat(pricei) * parseFloat(valQ)).toFixed(2);
        taxval = ((parseFloat(totJust) * parseFloat(dataCode.tax)) / 100).toFixed(2);

        if (setting.PrTy_InPr === "03" || setting.PrTy_InPr === "04" || setting.PrTy_InPr === "22") {
            dataCode.discount = 0;
            dataCode.amount_disc = 0;
        }
        let i = {
            amount_disc: Number(dataCode.amount_disc),
            discount: Number(dataCode.discount),
        };
        diaperc = (parseFloat(i.discount)).toFixed(2);
        dismount = (parseFloat(i.amount_disc)).toFixed(2);

        if (parseFloat(dismount) > parseFloat(pricei)) dismount = 0;
        valperc = (parseFloat(dataCode.perc)).toFixed(2);


        let errorList = [];
        let restaxvalA = 0,
            resNetA = 0,

            restotJustSumA = 0,
            restotJustAfterDiscSumA = 0,
            resDiscPerA = 0,
            resDisCountA = 0,
            tot_befor_vat_after_disc = 0;

        restotJustSumA = parseFloat(totJust);

        if (permistionInv.DSOB == true) {
            if (checked.discRateck === true) {
                //  alert('in if')
                resDiscPerA = parseFloat(invDisc.rate);
                resDisCountA = (
                    parseFloat(invDisc.rate / 100) * parseFloat(totJust)
                ).toFixed(2);

                restotJustAfterDiscSumA =
                    parseFloat(totJust) - parseFloat(resDisCountA);
            } else if (checked.discMinusck === true) {
                resDiscPerA = (
                    (parseFloat(idata.minus) / parseFloat(totJust)) *
                    100
                ).toFixed(2);
                resDisCountA = (
                    parseFloat(resDiscPerA / 100) * parseFloat(totJust)
                ).toFixed(2);
            }

        } else {
            if (diaperc > 0) {
                restotJustAfterDiscSumA =
                    parseFloat(totJust) - parseFloat(dismount);
                resDiscPerA = parseFloat(diaperc);
                resDisCountA = (
                    parseFloat(diaperc / 100) * parseFloat(totJust)
                ).toFixed(2);

            } else if (dismount > 0) {
                restotJustAfterDiscSumA =
                    parseFloat(totJust) - parseFloat(dismount);

                let desc_perc = (
                    (dismount * 100) /
                    parseFloat(totJust)
                );
                resDiscPerA = parseFloat(desc_perc);
                resDisCountA = (
                    parseFloat(resDiscPerA / 100) * parseFloat(totJust)
                ).toFixed(2);

            } else {
                restotJustAfterDiscSumA =
                    parseFloat(totJust) - parseFloat(dismount);
                resDiscPerA = parseFloat(diaperc);
                resDisCountA = (
                    parseFloat(diaperc / 100) * parseFloat(totJust)
                ).toFixed(2);
            }
        }



        restotJustAfterDiscSumA =
            parseFloat(totJust) - parseFloat(resDisCountA);


        restaxvalA = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(taxperc),
            "taxval"
        );

        tot_befor_vat_after_disc = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(taxperc),
            "before_vat"
        );


        resNetA = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(taxperc),
            "Net"
        );

        if (dataCode?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
            tot_before_vat_with_tab3val = (parseFloat(tot_befor_vat_after_disc) < parseFloat(25)) ?
                parseFloat(25) : parseFloat(tot_befor_vat_after_disc).toFixed(2);

            let tot_before = (parseFloat(tot_befor_vat_after_disc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

            restaxvalA = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(taxperc),
                "taxval"
            );

            resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_befor_vat_after_disc) + parseFloat(restaxvalA)).toFixed(2);
        }

        dataCode = {
            /* to show */
            minPrice: dataCode.mPrice,
            PricePu: dataCode.purch,
            unitame: dataCode.unitName /*  - الـوحدة name */,
            symbol: dataCode.symbol /*  - إسم الصنف  */,
            /* to maaths */
            /* int -  الإجمالي */
            totJust: restotJustSumA,
            /* int - إجمالي الخصم بعد الخصم */
            totAfterDisc: tot_befor_vat_after_disc,

            tot_before_vat_after_d: tot_befor_vat_after_disc,
            sale_price: mezan.isMizan === true ? parseFloat(mezan.price) : parseFloat(dataCode?.sale),

            tab3val_sub: tot_before_vat_with_tab3val,
            tab3Val: tot_before_vat_with_tab3val,

            /* to go */
            // currency_from: parseInt(subInfo.id), /* float - id الصنف */
            currency_from: parseInt(dataCode.curr) /* float - id الصنف */,
            unit: parseInt(dataCode.unit) /* int - الـوحدة id */,
            /* float - الكمية */
            val1: parseFloat(valQ),
            // new _val1:parseFloat(subInfo.new _val1),
            /* float - العبوة */
            val: parseFloat(valperc),
            // new _val:parseFloat(subInfo.perc),
            /* float - الـسعر */
            new_exchange_price: parseFloat(pricei),
            // all_new_exchange_price: parseFloat(subInfo.Price),
            /* float - الخصم  مبلغ*/
            discount: resDisCountA,
            /* float - %  خصم نسبة */
            DiscPers: resDiscPerA,
            /* float -  ضريبة القيمة المضافة نسبة */
            taxperc: parseFloat(taxperc),
            /* float - إجمالي قيمة المضافة  */
            taxval: parseFloat(restaxvalA),
            netAmountSub: (parseFloat(restaxvalA) + parseFloat(tot_befor_vat_after_disc)).toFixed(2),
            barcode: mezan.isMizan === true ? parseFloat(mezan.itemBarcode) : dataCode.barcode /*  - الباركود */,
            sub_center: 0 /* int -  */,
            sub_branch: sto.branchi /* int - الفرع */,

            unitame: dataCode.unitName,
            sale_price: parseFloat(dataCode.sale),
            // DiscPers: parseFloat(diaperc),
            // discount: parseFloat(dataCode.amount_disc),
            discount: resDisCountA,
            DiscPers: resDiscPerA,
            taxperc: parseFloat(taxperc),
            UnitsTable: units,
            defUnit: defaultUnits,
            no: isdata?.length,
            editAbleVal: false,
            editAblePrice: false,
            editAbleUnit: false,
            editAbleTax: false,
            editAbleDescM: false,
            editAbleDescP: false,
            editAbleDescNote: false,
            Qtys: ibance,
            type: dataCode.ctype,
        };
        if (errorList.length < 1) {
            //no error
            let add = 0;

            const updateItem = isdata.find((obj) => obj.barcode.toString() === dataCode.barcode.toString()
                && obj.new_exchange_price === dataCode.new_exchange_price);

            if (permistionInv?.NOREP === true) {
                let dataToAdd = [...isdata];
                dataToAdd.push(dataCode);
                setIsData(dataToAdd);
                handSums(dataToAdd);
                setExSub(dataToAdd.length);
                add = 1;

            }
            else {
                if (updateItem?.no != null && mezan.isMizan === false) {
                    let add = 1;
                    let multiplier = (parseFloat(updateItem?.val1) + parseFloat(add)).toFixed(2);
                    if (!isNaN(multiplier)) {

                        let tot = parseFloat(multiplier * updateItem.new_exchange_price);

                        let desc_mount = (
                            parseFloat(tot) *
                            (updateItem.DiscPers / 100)
                        );
                        let totBe = parseFloat((multiplier * updateItem.new_exchange_price) - desc_mount);

                        let taxMount = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "taxval"
                        );
                        let betTax = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "before_vat"
                        );

                        let resNetA = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "Net"
                        );
                        if (parseFloat(updateItem?.tab3val_sub) > 0) {
                            let tot_before_new = maths(
                                parseFloat(pricei),
                                parseFloat(updateItem.taxperc),
                                "before_vat"
                            );
                            tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                                (parseFloat(25) * multiplier) : parseFloat(betTax).toFixed(2);

                            let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

                            taxMount = mathsTab3val(
                                parseFloat(tot_before),
                                parseFloat(updateItem.taxperc),
                                "taxval"
                            );

                            resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                                + parseFloat(taxMount)).toFixed(2);
                        }
                        const newData = {
                            ...updateItem,
                            val1: multiplier,
                            totJust: tot,
                            totAfterDisc: betTax,
                            taxval: taxMount,
                            netAmountSub: resNetA,
                            discount: desc_mount,
                            tab3val_sub: tot_before_vat_with_tab3val,
                            tab3Val: tot_before_vat_with_tab3val,
                        };

                        const index = updateItem?.no;
                        const dataUpdate = [...isdata];
                        dataUpdate[index] = { ...newData };
                        setIsData([...dataUpdate]);
                        handSums(dataUpdate);
                    }
                } else {
                    let dataToAdd = [...isdata];
                    dataToAdd.push(dataCode);
                    setIsData(dataToAdd);
                    handSums(dataToAdd);
                    setExSub(dataToAdd.length);
                    add = 1;

                }

            }
        } else {
            // resolve();
        }
    };
    const [loadingExcel, setLoadingExcel] = useState(false);

    const getFormExcelData = async () => {
        setLoadingExcel(true);
        const dataDown = excelData.map((sub, i) => {
            return {
                barcode: sub.الباركود !== null ? sub?.الباركود : sub?.barcode,
                new_exchange_price: sub?.السعر !== null ? sub?.السعر : sub?.price == null ? 0 : sub?.price,
                val1: sub?.الكمية !== null ? sub?.الكمية : sub?.val == null ? 1 : sub?.val,
                expense: sub.الاعباء !== null ? sub?.الاعباء : sub?.expense == null ? 0 : sub?.expense,
                discount: sub?.الخصم !== null ? sub?.الخصم : sub?.discount == null ? 0 : sub?.discount,
            };
        });

        const tb = {
            wait: true,
            ExcelInv: true,
            parms: {
                safe: valueSafes?.id,
                branch: sto.branchi,
                _Data: dataDown,
                bol1: permiCuCo.CWVat,
                sProTyInvPro: setting.PrTy_InPr,
            },
        };

        axios
            .post(uri + "GetD", tb)
            .then((res) => {
                const dataItems = res.data.excelInv.map((row, i) => {
                    return {
                        ...row,
                        UnitsTable: [],
                        defUnit: {},
                        no: i,
                        editAbleVal: false,
                        editAblePrice: false,
                        editAbleUnit: false,
                        editAbleTax: false,
                        editAbleDescM: false,
                        editAbleDescP: false,
                        editAbleDescNote: false,
                        tab3val_sub: row?.tab3Val ?? 0,
                        tab3Val: row?.tab3Val ?? 0,
                        type: 1,
                    };
                });

                setIsData(dataItems);
                handSums(dataItems);
                setExSub(dataItems.length);
                setValue(0);
                setExcelData([]);
                setLoadingExcel(false);
            })
            .catch((error) => {
                console.log(error);
                setLoadingExcel(false);
            });
    };
    const onChangeAutoCurrNormal = async (propName, newValue) => {
        setSearchText("");
        setRptParams({ ...rptParams, [propName]: newValue, barcode: '', barcodeNormal: newValue.barcode });
        if (newValue.id === "" || newValue.id == null) {
        } else {
            if (cuRows?.length > 0 || optionsItemsSearch.length > 0) {
                const allItem = [...cuRows, ...optionsItemsSearch];
                const newItem = allItem.find((obj) => obj.barcode.toString() === newValue.barcode.toString() &&
                    obj.id === newValue.id);
                if (newItem && newItem?.units?.length > 0 &&
                    (permistionInv.SIM || ["22", "01", "12", "03", "04"].includes(setting.PrTy_InPr))) {
                    const unitF = newItem.units.find((x) => x.unit === newItem.unit);
                    await getDataItemsNoApi(newItem, unitF, setting, permistionInv, valueCustomers, subInfo, setSubInfo,
                        invDisc, idata, checked, isdata, setIsData, handSums, false, setItemId, permiCuCo.CWVat);
                    setCurrUnit(unitF);
                    setValueItemsUnits(unitF);
                    setOptionsCurrUnits(newItem?.units);
                    document.getElementById("val11").focus();
                } else {
                    changeItemNormal(propName, newValue);
                }
            } else {
                changeItemNormal(propName, newValue);
            }
        }

    };
    const changeItemNormal = (propName, newValue) => {
        const isMezan = permistionInv?.USEMEZAN && (newValue.barcode.length === 13 || newValue.barcode.length === 18) &&
            (newValue.barcode.startsWith("99") || newValue.barcode.startsWith("21") || newValue.barcode.startsWith("27")) ? true : false;
        const newItem = localCashe.find((obj) => obj.item.barcode.toString() === newValue.barcode.toString() &&
            obj.item.curr === newValue.id);
        if (newItem && !isMezan && localCashe.length > 0) {
            addnewItems({ ...newItem?.item }, { ...newItem?.unit }, newItem.units, newItem.val, false);
            document.getElementById("val11").focus();
        } else {
            getBarcodeMulti(newValue.barcode, true, false);
        }

    };

    const onChangeSearchNormal = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (rptParams?.barcodeNormal == "") {
            document.getElementById("searchitemNormal").focus();
        } else {
            if (cuRows?.length > 0 || optionsItemsSearch.length > 0) {
                const allItem = [...cuRows, ...optionsItemsSearch];
                const newItem = allItem.find((obj) => obj.barcode.toString() === rptParams?.barcodeNormal.toString());
                if (newItem && newItem?.units?.length > 0 && (permistionInv.SIM || ["22", "01", "12", "03", "04"].includes(setting.PrTy_InPr))) {
                    const unitF = newItem.units.find((x) => x.unit === newItem.unit);
                    getDataItemsNoApi(newItem, unitF, setting, permistionInv, valueCustomers, subInfo, setSubInfo,
                        invDisc, idata, checked, isdata, setIsData, handSums, false, setItemId, permiCuCo.CWVat);
                    setCurrUnit(unitF);
                    setValueItemsUnits(unitF);
                    setOptionsCurrUnits(newItem?.units);
                    const valueItem = { id: newItem?.id, barcode: rptParams?.barcodeNormal, name: newItem?.symbol, nameE: "" }
                    setRptParams({ ...rptParams, barcode: '', curr: valueItem });
                    document.getElementById("val11").focus();
                } else {
                    changeBarcodeNormal();
                }
            } else {
                changeBarcodeNormal();
            }
        }
    };
    const changeBarcodeNormal = () => {
        const newItem = localCashe.find((obj) => obj.item.barcode.toString() === rptParams?.barcodeNormal.toString().trim());
        if (newItem && localCashe.length > 0) {
            const valueItem = { id: newItem?.item?.id, barcode: rptParams?.barcodeNormal, units: [], name: newItem?.item?.symbol, nameE: "" }
            addnewItems({ ...newItem?.item }, { ...newItem?.unit }, newItem.units, newItem.val, false);
            setRptParams({ ...rptParams, barcode: '', curr: valueItem });
            document.getElementById("val11").focus();
        } else {
            getBarcodeMulti(rptParams?.barcodeNormal, true, false);
        }
    };
    const autocompleteref = useRef(null);

    const keepautocompletFocus = () => {
        if (autocompleteref.current) {
            autocompleteref.current.querySelector("input")?.focus();
        }
    };
    ///---------------------------normal download------------------
    const getNewItemData = async (itemcode, status, isAuto) => {
        if (itemcode != null && itemcode != "") {
            const newItems = cacheItems.find((obj) => obj.barcode.toString() === itemcode.toString());
            if (newItems) {
                const valueItem = { id: newItems.currency_from, name: newItems?.symbol, nameE: "" }
                setLastLtem(true);
                setRptParams({ ...rptParams, barcode: '', barcodeS: '', curr: isAuto ? {} : valueItem });
                if (status) document.getElementById("val11").focus();
                await addItemTable({ ...newItems }, isAuto);
            } else {
                let itemsData = null;
                let Urls = null;
                if (AutoOptions?.permType?.id === 6 && isAuto) {
                    Urls = uri + `RptSafes/ItemDataBarcode?currCode=${itemcode}&&emp=${sto.empi}&&safe=${valueSafes.id}&&minus=${permistionInv.SIM}
            &&branch=${sto.branchi}&&bol1=${permiCuCo.CWVat}&&pro_type=${setting.PrTy_InPr}&&useMezan=${permistionInv?.USEMEZAN}
            &&typePrice=${permistionInv?.TYPEPRICE}&&useLevel=${permistionInv?.LEVELPRICES}&&tax=${valueCustomers.WithoutTax}`;
                } else {
                    Urls = uri + `RptSafes/ItemDataClick?currCode=${itemcode}&&emp=${sto.empi}&&safe=${valueSafes.id}&&minus=${permistionInv.SIM}
            &&branch=${sto.branchi}&&bol1=${permiCuCo.CWVat}&&pro_type=${setting.PrTy_InPr}&&useMezan=${permistionInv?.USEMEZAN}
            &&isCust=${permistionInv?.CUSTPRICE}&&cust_id=${valueCustomers.id}&&dicCustPerc=${valueCustomers.disc_perc}
            &&dicCustVal=${valueCustomers.discount}&&typePrice=${permistionInv?.TYPEPRICE}&&useLevel=${permistionInv?.LEVELPRICES}
            &&useTobac=${false}&&useUnit=${true}&&tax=${valueCustomers.WithoutTax}`;
                }
                await axios.get(Urls).then((res) => {
                    itemsData = res?.data;
                }).catch((err) => {
                    console.log(err);
                });

                if (itemsData != null) {
                    if (isAuto) {
                        let oldVal = 0;
                        let totValbef = 0.0;
                        if (permistionInv.SIM == false) {
                            for (let m = 0; m < isdata.length; m++) {
                                if (itemsData.currency_from == isdata[m].currency_from)
                                    totValbef += (isdata[m].val1 * isdata[m].val);
                            }
                            oldVal = Number(itemsData?.Qtys) - totValbef;
                        }
                        if (checkValueQ(setting, permistionInv, itemsData.type, oldVal) == 0) {
                            getAlertValQ(valueSafes, itemsData?.Qtys, itemsData?.currency_from, itemsData?.val)
                        } else {
                            addItemTable({ ...itemsData }, true);
                        }
                    } else {
                        addItemTable({ ...itemsData }, false);
                        const valueItem = { id: itemsData.currency_from, barcode: itemsData.barcode, name: itemsData?.symbol, nameE: "" }
                        // setOptionsItemsSearch([valueItem, ...optionsItemsSearch]);
                        const isNew = AutoOptions.InvItems.find((obj) => obj.barcode.toString() === itemsData.barcode.toString());
                        if (!isNew) { setOptionsItemsSearch([isNew, ...optionsItemsSearch]); }
                        if (status) document.getElementById("val11").focus();
                        setRptParams({ ...rptParams, barcode: '', barcodeS: '', curr: isAuto ? {} : valueItem });
                    }
                    if (!itemsData.isMezan) { setCacheItems([...cacheItems, { ...itemsData, barcode: itemcode.toString() }]); }
                    setLastLtem(true);
                } else {
                    if (status) keepautocompletFocus();
                    alert(`لا يوجد صنف لهذا الباركود"`);
                }
            }
        }
    }

    const addItemTable = (newRow, isAuto) => {
        if (isAuto) {
            if (permistionInv?.NOREP === true || newRow.isMezan) {
                setIsData([...isdata, { ...newRow, no: isdata.length, UnitsTable: newRow.units ?? [] }]);
                handSums([...isdata, newRow]);
                setExSub([...isdata, newRow].length);
            }
            else {
                const updateItem = isdata.find((obj) => obj.barcode.toString() === newRow.barcode.toString()
                    && obj.new_exchange_price === newRow.new_exchange_price);
                if (updateItem?.currency_from > 0) {
                    let multiplier = (parseFloat(updateItem?.val1) + parseFloat(1)).toFixed(2);
                    if (!isNaN(multiplier)) {

                        let tot = parseFloat(multiplier * updateItem.new_exchange_price);
                        let desc_mount = (
                            parseFloat(tot) *
                            (updateItem.DiscPers / 100)
                        );
                        let totBe = parseFloat((multiplier * updateItem.new_exchange_price) - desc_mount);

                        let taxMount = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "taxval"
                        );
                        let betTax = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "before_vat"
                        );
                        let resNetA = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "Net"
                        );

                        const newData = {
                            ...updateItem,
                            val1: multiplier,
                            totJust: tot,
                            totAfterDisc: betTax,
                            taxval: taxMount,
                            netAmountSub: resNetA,
                            discount: desc_mount,
                            tab3val_sub: 0,
                            tab3Val: 0,
                        };

                        const index = updateItem?.no;
                        const dataUpdate = [...isdata];
                        dataUpdate[index] = { ...newData };
                        setIsData([...dataUpdate]);
                        handSums(dataUpdate);
                    }
                } else {
                    // const newData = [...isdata, dataItems];
                    setIsData([...isdata, { ...newRow, no: isdata.length, UnitsTable: newRow.units ?? [] }]);
                    handSums([...isdata, newRow]);
                    setExSub([...isdata, newRow].length);
                }
            }

            // }
        }
        else {
            setSubInfo({
                ...newRow,
                id: newRow.currency_from,
                Price: newRow.new_exchange_price,
                perc: newRow.val,
                unitame: newRow.unitName,
                defUnit: newRow.units.find((x) => x.unit === newRow.unit),
                no: isdata?.length,
            });
            setCurrUnit(newRow.units.find((x) => x.unit === newRow.unit));
            setValueItemsUnits(newRow.units.find((x) => x.unit === newRow.unit));
            setOptionsCurrUnits(newRow.units);
            setItemId(newRow.currency_from);
        }
    }
    const getBarcodeFast = async (itemcode, status, isAuto) => {
        let Urls = null;
        let itemsData = null;
        if (itemcode != null && itemcode != "") {
            Urls = uri + `RptSafes/ReaderBarcodeItems?currCode=${itemcode}&&emp=${sto.empi}&&safe=${valueSafes.id}&&minus=${permistionInv.SIM}
            &&useMezan=${permistionInv.USEMEZAN}&&procType=${setting.PrTy_InPr}&&branch=${sto.branchi}`;
            await axios.get(Urls).then((res) => {
                itemsData = res?.data;
            }).catch((err) => {
            });
            if (itemsData) {
                if (isAuto) {
                    addnewItems(itemsData, itemsData?.units[0], itemsData?.units, 0, isAuto);
                    setLastLtem(true);
                    setRptParams({ ...rptParams, barcode: '', barcodeS: '', curr: {}, barcodeNormal: "" });
                }
                else {
                    addnewItems(itemsData, itemsData?.units[0], itemsData?.units, 0, isAuto);
                    const valueItem = {
                        id: parseInt(itemsData?.curr),
                        barcode: itemsData?.barcode, units: [], name: itemsData?.symbol, nameE: ""
                    }
                    setRptParams({ ...rptParams, barcodeS: '', curr: valueItem, barcodeNormal: itemsData?.barcode });
                    if (status) document.getElementById("val11").focus();
                }
                const newItem = localCashe.find((obj) => obj.item.barcode.toString() === itemcode.toString());
                if (!newItem) {
                    const addNewItem = { item: { ...itemsData, barcode: itemcode }, unit: itemsData?.units[0], val: 0, units: itemsData?.units, }
                    setLocalCashe([...localCashe, addNewItem]);
                };
            } else {
                getBarcodeMulti(itemcode, status, isAuto);
            }
            setAllowKeyboard(true);
        }
    };

    const successSound = useRef(null);
    const errorSound = useRef(null);

    useEffect(() => {
        successSound.current = new Audio("/sounds/barcode-success.wav");
        errorSound.current = new Audio("/sounds/barcode-error.wav");
        successSound.current.preload = "auto";
        errorSound.current.preload = "auto";
    }, []);

    const playSuccess = () => {
        successSound.current.currentTime = 0;
        successSound.current.play().catch(() => { });
    }
    const playError = () => {
        errorSound.current.currentTime = 0;
        errorSound.current.play().catch(() => { });
    }

    const getBarcodeMulti = async (itemcode, status, isAuto) => {
        let Urls = null;
        let itemsData = null;
        if (itemcode != null && itemcode != "") {
            if (stor.invsType === 7) {
                Urls = uri + `RptSales/CurrCodesMake?currCode=${itemcode}&&emp=${sto.empi}&&safe=${valueSafes.id}`;
            } else if (permistionInv?.CUSTPRICE && stor.invsType != 5) {
                Urls = uri + `RptSales/ItemsCodesCust?currCode=${itemcode}&&emp=${sto.empi}&&cust_id=${valueCustomers.id}
            &&invType=${setting.PrTy_InPr}&&safe=${valueSafes.id}`;
            } else if (permistionInv?.LEVELPRICES > 0 && (stor.invsType == 0 || stor.invsType == 1)) {
                Urls = uri + `RptSales/ItemsPriceLevel?currCode=${itemcode} &&emp=${sto.empi}&&branch=${sto.branchi}&&invType=${setting.PrTy_InPr} 
            &&safe=${valueSafes.id}&&cust_id=${valueCustomers.id}&&level=${permistionInv?.LEVELPRICES}`;
            } else {
                Urls = uri + `RptSafes/CurrCodesUnitsSub?currCode=${itemcode}&&emp=${sto.empi}&&safe=${valueSafes.id}`;
            };
            await axios.get(Urls).then((res) => {
                itemsData = res?.data;
            }).catch((err) => {
                console.log(err);
            });
            if (itemsData) {
                const defUnit = itemsData?.unitsSub.find((x) => x.unit === itemsData?.barcodes[0].unit);
                let valQ = itemsData?.balance[0]?.Qtys ?? 0;
                if (isAuto) {
                    setLastLtem(true);
                    setRptParams({ ...rptParams, barcode: '', barcodeS: '', curr: {}, barcodeNormal: "" });
                    let oldVal = 0;
                    let totValbef = 0.0;
                    if (permistionInv.SIM == false) {
                        for (let m = 0; m < isdata.length; m++) {
                            if (itemsData?.barcodes[0].curr == isdata[m].currency_from)
                                totValbef += (isdata[m].val1 * isdata[m].val);
                        }
                        oldVal = Number(valQ) - totValbef;
                    }
                    if (checkValueQ(setting, permistionInv, itemsData?.barcodes[0]?.ctype, oldVal) == 0) {
                        getAlertValQ(valueSafes, valQ, itemsData?.barcodes[0]?.curr, itemsData?.barcodes[0]?.perc)
                    } else {
                        addnewItems({ ...itemsData?.barcodes[0] }, { ...defUnit }, itemsData?.unitsSub, valQ, isAuto);
                        playSuccess();
                    }
                    setLastLtem(true);
                } else {
                    addnewItems({ ...itemsData?.barcodes[0] }, { ...defUnit }, itemsData?.unitsSub, valQ, isAuto);
                    const valueItem = {
                        id: parseInt(itemsData?.barcodes[0]?.curr),
                        barcode: itemsData?.barcodes[0]?.barcode, units: [], name: itemsData?.barcodes[0]?.symbol, nameE: ""
                    }
                    setRptParams({ ...rptParams, barcodeS: '', curr: valueItem, barcodeNormal: itemsData?.barcodes[0].barcode });
                    if (status) document.getElementById("val11").focus();
                }
                const newItem = localCashe.find((obj) => obj.item.barcode.toString() === itemsData?.barcodes[0].barcode.toString());
                if (!newItem) {
                    const addNewItem = { item: itemsData?.barcodes[0], unit: defUnit, val: valQ, units: itemsData?.unitsSub, }
                    setLocalCashe([...localCashe, addNewItem]);
                };
            } else {
                if (status) keepautocompletFocus();
                if (isAuto) { playError() }
                alert(`لا يوجد صنف لهذا الباركود"`);
            }
            setAllowKeyboard(true);
        }
    };

    const bufferRefs = useRef([]);
    const addnewItems = (dataCode, defaultUnit, Units, Qtys, isAuto) => {
        setItemId(dataCode.curr);
        let val = Number(dataCode?.val) > 0 ? Number(dataCode?.val) : 1;
        let Price = 0.0;
        let taxperc = 0.0;
        let diaperc = 0.0;
        let dismount = 0.0;
        if (setting.PrTy_InPr === "22") {
            taxperc = 0.0;
            Price = parseFloat(dataCode?.purch).toFixed(2);
        } else if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03") {
            Price = permistionInv?.TYPEPRICE === 0 || permistionInv?.TYPEPRICE == null ? parseFloat(dataCode?.sale) :
                permistionInv?.TYPEPRICE === 1 ? parseFloat(dataCode?.dPrice) : parseFloat(dataCode?.jPrice);
            taxperc = (parseFloat(dataCode.tax)).toFixed(2);
        }
        else {
            Price = parseFloat(dataCode?.purch);
            taxperc = (parseFloat(dataCode.tax)).toFixed(2);
        };
        if (parseFloat(valueCustomers?.disc_perc) > 0) {
            dataCode.discount = valueCustomers?.disc_perc ?? 0;
            dataCode.amount_disc = 0;
        } else if (parseFloat(valueCustomers?.discount) > 0) {
            dataCode.discount = 0;
            dataCode.amount_disc = valueCustomers?.discount ?? 0;
        }
        if (valueCustomers?.WithoutTax > 0 && setting.PrTy_InPr == "01") { taxperc = 0; }
        if (parseFloat(dataCode.amount_disc) > parseFloat(Price)) dataCode.discount = 0;

        if (setting.PrTy_InPr === "03" || setting.PrTy_InPr === "04" || setting.PrTy_InPr === "22") {
            dataCode.discount = 0;
            dataCode.amount_disc = 0;
        }
        let i = {
            amount_disc: Number(dataCode.amount_disc),
            discount: Number(dataCode.discount),
        };
        diaperc = (parseFloat(i.discount)).toFixed(2);
        dismount = (parseFloat(i.amount_disc)).toFixed(2);
        let totals = parseFloat(Price).toFixed(2);
        let total_after_disc = parseFloat(Price * val).toFixed(2);
        let total_before_tax = parseFloat(Price * val).toFixed(2);
        let tax_val = 0.0;
        let net_total = 0.0;
        let total_before_tab3 = 0.0;
        if (permistionInv.DSOB == true) {
            if (checked.discRateck === true) {
                diaperc = parseFloat(invDisc.rate).toFixed(2);
                dismount = (parseFloat(invDisc.rate / 100) * parseFloat(totals)).toFixed(2);
                total_after_disc = (parseFloat(totals) - parseFloat(dismount)).toFixed(2);
            } else if (checked.discMinusck === true) {
                diaperc = ((parseFloat(idata.minus) / parseFloat(totals)) * 100).toFixed(2);
                dismount = (parseFloat(diaperc / 100) * parseFloat(totals)).toFixed(2);
                total_after_disc = (parseFloat(totals) - parseFloat(dismount)).toFixed(2);
            }
        } else {
            if (diaperc > 0) {
                diaperc = parseFloat(diaperc).toFixed(2);
                dismount = (parseFloat(diaperc / 100) * parseFloat(totals)).toFixed(2);
                total_after_disc = (parseFloat(totals) - parseFloat(dismount)).toFixed(2);
            } else if (dismount > 0) {
                diaperc = (parseFloat(dismount * 100) / parseFloat(totals)).toFixed(2);
                dismount = parseFloat(dismount).toFixed(2);
                total_after_disc = (parseFloat(totals) - parseFloat(dismount)).toFixed(2);
            }
        }
        tax_val = maths(parseFloat(total_after_disc), parseFloat(taxperc), "taxval");
        total_before_tax = maths(parseFloat(total_after_disc), parseFloat(taxperc), "before_vat");
        net_total = maths(parseFloat(total_after_disc), parseFloat(taxperc), "Net");

        if (dataCode?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
            total_before_tab3 = (parseFloat(total_before_tax) < parseFloat(25)) ?
                parseFloat(25) : parseFloat(total_before_tax).toFixed(2);
            let tot_before = (parseFloat(total_before_tax) + parseFloat(total_before_tab3)).toFixed(2);
            tax_val = mathsTab3val(parseFloat(tot_before), parseFloat(taxperc), "taxval");
            net_total = (parseFloat(total_before_tab3) + parseFloat(total_before_tax) + parseFloat(tax_val)).toFixed(2);
        }
        if (isAuto) {
            dataCode = {
                symbol: dataCode.symbol,
                unitame: dataCode.unitName,
                PricePu: dataCode.purch,
                minPrice: dataCode.mPrice,
                totJust: totals,
                totAfterDisc: total_before_tax,
                tot_before_vat_after_d: total_before_tax,
                sale_price: parseFloat(dataCode?.sale),
                tab3val_sub: total_before_tab3,
                tab3Val: total_before_tab3,
                currency_from: parseInt(dataCode.curr),
                unit: parseInt(dataCode.unit),
                val1: parseFloat(val),
                val: parseFloat(dataCode.perc),
                new_exchange_price: parseFloat(Price),
                discount: dismount,
                DiscPers: diaperc,
                taxperc: parseFloat(taxperc),
                taxval: parseFloat(tax_val),
                netAmountSub: parseFloat(net_total).toFixed(2),
                barcode: dataCode.barcode.toString(),
                sub_center: 0,
                sub_branch: sto.branchi,
                Qtys: Qtys ?? 0,
                UnitsTable: Units,
                defUnit: defaultUnit,
                no: isdata?.length,
                editAbleVal: false,
                editAblePrice: false,
                editAbleUnit: false,
                editAbleTax: false,
                editAbleDescM: false,
                editAbleDescP: false,
                editAbleDescNote: false,
                type: dataCode.ctype,
            }
            if (permistionInv?.NOREP === true) {
                bufferRefs.current.push(dataCode);
                let dataToAdd = [...isdata, ...bufferRefs.current];
                setIsData(dataToAdd);
                handSums(dataToAdd);
                setExSub(dataToAdd.length);
                bufferRefs.current = [];
                setRowUpdate(dataCode);

            } else {
                const updateItem = isdata.find((obj) => obj.barcode.toString() === dataCode.barcode.toString()
                    && obj.new_exchange_price === dataCode.new_exchange_price);
                if (updateItem?.no != null && val == 1) {
                    let add = 1;
                    let multiplier = (parseFloat(updateItem?.val1) + parseFloat(add)).toFixed(2);
                    if (!isNaN(multiplier)) {

                        let tot = parseFloat(multiplier * updateItem.new_exchange_price);
                        let desc_mount = (
                            parseFloat(tot) *
                            (updateItem.DiscPers / 100)
                        );
                        let totBe = parseFloat((multiplier * updateItem.new_exchange_price) - desc_mount);

                        let taxMount = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "taxval"
                        );
                        let betTax = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "before_vat"
                        );

                        let resNetA = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "Net"
                        );

                        if (parseFloat(updateItem?.tab3val_sub) > 0) {
                            let tot_before_new = maths(
                                parseFloat(Price),
                                parseFloat(updateItem.taxperc),
                                "before_vat"
                            );
                            total_before_tab3 = (parseFloat(tot_before_new) < parseFloat(25)) ?
                                (parseFloat(25) * multiplier) : parseFloat(betTax).toFixed(2);

                            let tot_before = (parseFloat(betTax) + parseFloat(total_before_tab3)).toFixed(2);

                            taxMount = mathsTab3val(
                                parseFloat(tot_before),
                                parseFloat(updateItem.taxperc),
                                "taxval"
                            );

                            resNetA = (parseFloat(total_before_tab3) + parseFloat(betTax)
                                + parseFloat(taxMount)).toFixed(2);
                        }
                        const newData = {
                            ...updateItem,
                            val1: multiplier,
                            totJust: tot,
                            totAfterDisc: betTax,
                            taxval: taxMount,
                            netAmountSub: resNetA,
                            discount: desc_mount,
                            tab3val_sub: total_before_tab3,
                            tab3Val: total_before_tab3,
                        };

                        const index = updateItem?.no;
                        const dataUpdate = [...isdata];
                        dataUpdate[index] = { ...newData };
                        setIsData([...dataUpdate]);
                        handSums(dataUpdate);
                        setRowUpdate(dataUpdate[index]);
                    }
                } else {
                    bufferRefs.current.push(dataCode);
                    let dataToAdd = [...isdata, ...bufferRefs.current];
                    setIsData(dataToAdd);
                    handSums(dataToAdd);
                    setExSub(dataToAdd.length);
                    bufferRefs.current = [];
                    setRowUpdate(dataCode);
                }
            }
        } else {
            setSubInfo({
                ...subInfo,
                val1: 1,
                id: parseInt(dataCode.curr),
                is_tab3_curr: dataCode?.is_tab3_curr,
                minPrice: dataCode.mPrice,
                Price: Price,
                val: dataCode.perc,
                barcode: dataCode.barcode,
                symbol: dataCode.symbol,
                type: dataCode.ctype,
                perc: dataCode.perc,
                taxperc: taxperc,
                totJust: parseFloat(Price).toFixed(2),
                discount: dismount,
                DiscPers: diaperc,
                taxval: parseFloat(tax_val).toFixed(2),
                unitame: dataCode.unitName,
                jPrice: parseFloat(dataCode.jPrice),
                dPrice: parseFloat(dataCode.dPrice),
                salePrice: parseFloat(dataCode.sale),
                PricePu: parseFloat(dataCode.purch),
                UnitsTable: Units,
                defUnit: defaultUnit,
                no: isdata?.length,
                Qtys: Number(Qtys),
            });
            // setCounts({ curr: ibance });
            setCurrUnit(defaultUnit);
            setValueItemsUnits(defaultUnit);
            setOptionsCurrUnits(Units);
        }

    }

    ///---------------------------normal download------------------
    ///---------------------------normal download------------------


    const getCustomerData = async () => {
        if (valueCustomers?.id == null) {

            alert("ooooo");
        } else {
            await axios
                .get(
                    uri +
                    `RptSales/getCustData?custId=${valueCustomers?.id}`
                )
                .then((res) => {

                    setCustData(res.data?.custData[0]);
                })
                .catch((err) => {
                    toast.error("لا يوجد بيانات لهذا العميل ");
                    console.log(err);
                });

            if (custData != null) {
                handleOpenCustomerData();
            } else {
                toast.error("لا يوجد بيانات لهذا العميل ");
            }
        }
    };
    const getNewItamsData = async () => {
        const tb = {
            wait: true,
            other: true,
            parms: {
                tname: "curr",
                branch: sto.branchi,
            },
        };

        axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setNewItemsAdd({
                    ...newItemsAdd,
                    id: res.data.other.lastid, barcode: res.data.other.barcode,
                });
                handleOpenItems();
            })
            .catch((error) => {
            });
    };

    function GetEmpFromOptions(id, options) {
        const index = options?.findIndex((op) => op.unit == id);
        return options[index];
    }
    const checkItemsBalance = async () => {
        let balanceItems = null;
        const tb = {
            wait: true,
            checksItems: true,
            parms: {
                safe: valueSafes?.id,
                branch: sto.branchi,
                _Data: isdata,
            },
        };

        axios
            .post(uri + "GetD", tb)
            .then((res) => {
                balanceItems = isdata.map((sub) => {
                    const blncData = res?.data?.itemsBalance.find((obj) => obj.currency_from === sub.currency_from);
                    let realBalnce = 0;
                    let qnt = blncData?.Qtys ?? 0;
                    let itemVal = (parseFloat(sub.val) * parseFloat(sub.val1)).toFixed(2)
                    realBalnce = (parseFloat(qnt) - parseFloat(itemVal)).toFixed(2);
                    return {
                        ...sub,
                        Qtys: blncData?.Qtys ?? 0,
                        realBalnce: parseFloat(realBalnce),
                    };
                });
                getCheckItems(balanceItems);

            })
            .catch((error) => {
                console.log(error);
                transformSale();
            });
    };

    const getCheckItems = async (balanceItems) => {
        var newData = balanceItems.filter((obj) => parseFloat(obj.realBalnce) < 0);
        if (newData != null) {
            if (newData.length == 0) {
                await transformSale();
            } else {
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: "Check For Items Balance ..You Don't Have permission For Sale in minus",
                    time: 2000,
                });
            }
        }
    };
    const transformDone = async () => {
        if (permistionInv.SIM == false) {
            await checkItemsBalance();
        } else {
            await transformSale();
        }
    };

    const GetConvertingInvoice = async (formid, PrType, isPurch) => {
        const tb = {
            other: true,
            PermissionsInvs: true,
            PermissionsCuCo: isPurch,
            parms: {
                sProcTypeInvProc: PrType,
                branch: sto.branchi,
                iempid: sto.empi,
                iuserid: sto.idi,
                tname: "invs",
                iformid: formid,
                iformidCuCo: dataF[3].id /* for curr and yashml */,
            },
            autos: {},
        };
        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setInfoInv({ ...infoInv, id: res?.data?.other?.lastid });
                setIData({
                    ...idata,
                    id: res.data.other.lastid, InvId_Return: "",
                    date: moment(new Date()).format("YYYY-MM-DD")
                });
                setPermistionInv({ ...res.data.permsInvs });
                if (isPurch) { setPrmiCuCo(res.data.permiCuCo); }
            })
            .catch((error) => { });
    };
    const transformSale = async () => {
        await GetConvertingInvoice(
            40002,
            "02",
            false
        );
        his.replace({
            pathname: `/Invoces`,
            state: transToSal,
        });
        setInvsSearchTable([]);
        location.state.setting = transToSal.setting;
        setSetting(location.state.setting);
        location.state.stor = transToSal.stor;
        setStor(location.state.stor);
        setOr({ ...or, postput: "toPost" });
        // setPermistionInv({ ...permistionInv, De: false });
    };
    const transformDonePurch = async () => {
        his.replace({
            pathname: `/Invoces`,
            state: transToPurch,
        });
        await GetConvertingInvoice(
            40001,
            "01",
            true
        );
        setInvsSearchTable([]);
        location.state.setting = transToPurch.setting;
        setSetting(location.state.setting);
        location.state.stor = transToPurch.stor;
        setStor(location.state.stor);
        setOr({ ...or, postput: "toPost" });
    };

    const onClickButton = async (procId, type) => {
        const tb = {
            ButtonSearch: true,
            parms: {
                tname: type,
                branch: sto.branchi,
                iprocid: procId,
                sProTyInvPro: setting.PrTy_InPr,
            },
        };

        axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setProcIdSearch(res.data?.procId_inv?.id);
                if (res.data?.procId_inv.id > 0) {
                    setOr({ ...or, postput: "toPut", PrAC: 0 });
                    showChosedInv(false, res.data.procId_inv.id, false);
                    setIsClick({ ...ished, hed: true });
                    if (["12", "02", "149", "150"].includes(setting.PrTy_InPr)) {
                        setIshedden(true);
                    } else {
                        setIshedden(permistionInv.Up == true ? false : true);
                    }
                }

            })
            .catch((error) => {
            });
    };
    const showChosedInv = async (t, val, fromReturn) => {
        await showChoosedInvoice(t, val, fromReturn);
    };
    const showChoosedInvoice = async (t, val, fromReturn) => {
        if (setting.PrTy_InPr === "03" || setting.PrTy_InPr === "04") {
            if (!isHedden) {
                setIsOpenUpdate(true);
            }
        };
        setProcIdSearch(val);
        setOpenButtonsSearch(true);
        setExpenseList([]);
        const tbs = {
            View_Inv_reseloving: true,
            View_Inv_Expenses: setting.PrTy_InPr === "01" ? true : false,
            parms: {
                iprocid: val,
                bol1: permiCuCo.CWVat,
                sProTyInvPro: setting.PrTy_InPr,
            },
            autos: {},
        };
        const alt = { View_Inv_reseloving: true };

        const al = Object.entries(alt).reduce((u, [n, v]) => {
            u[`${n}` + `${t ? "t" : ""}`] = v;
            return u;
        }, {});
        const alts = { ...al, ...tbs };
        await axios
            .post(uri + "Res", alts)
            .then((res) => {
                //console.log('res.data'); console.log(res.data);
                setCarOptions({
                    ...carOptions,
                    CarModel: res.data.inv?.CarModel,
                    CarYear: res.data.inv?.CarYear,
                    CarType: res.data.inv?.CarType,
                    CarStructure: res.data.inv?.CarStructure,
                    CarVactor: res.data.inv?.CarVactor,
                    CarColor: res.data.inv?.CarColor,
                    CarPlatNum: res.data.inv?.CarPlatNum,
                });
                if (fromReturn) {
                    setIData({
                        ...res.data.inv, date: moment(new Date()).format("YYYY-MM-DD"),
                        notes: '', Ishar_amout: 0, Ishar_Tax: 0, Ishar_amout_Net: 0,
                        Due_date: res.data.inv?.Due_date == null ? "" : moment(res.data.inv?.Due_date).format("YYYY-MM-DD"),
                        Delivery_date: res.data.inv?.Delivery_date == null ? "" : moment(res.data.inv?.Delivery_date).format("YYYY-MM-DD"),
                    });
                } else {
                    setIData({
                        ...res.data.inv,
                        Due_date: res.data.inv?.Due_date === null ? null : moment(res.data.inv?.Due_date).format("YYYY-MM-DD"),
                        Delivery_date: res.data.inv?.Delivery_date === null ? null : moment(res.data.inv?.Delivery_date).format("YYYY-MM-DD"),
                    });
                }
                console.log("the res data inve is", res.data.inv);
                // .then(resSub => {
                const dataItems = res.data.invS.map((row, i) => {
                    return {
                        ...row,
                        UnitsTable: [],
                        defUnit: {},
                        no: i,
                        editAbleVal: false,
                        editAblePrice: false,
                        editAbleUnit: false,
                        editAbleTax: false,
                        editAbleDescM: false,
                        editAbleDescP: false,
                        editAbleDescNote: false,
                        tab3val_sub: row?.tab3Val ?? 0,
                        Qtys: 0,
                        tab3Val: row?.tab3Val ?? 0,
                        type: 1,
                        Ishar_NewPrice: row.Ishar_NewPrice ?? 0,
                        Ishar_amout_sub: row.Ishar_amout_sub ?? 0,
                        Ishar_amout_tot_sub: row.Ishar_amout_tot_sub ?? 0,
                        NewPrice_AfterIshar: row.NewPrice_AfterIshar ?? 0,
                        NewTax_AfterIshar: row.NewTax_AfterIshar ?? 0,
                        NewTot_AfterIshar: row.NewTot_AfterIshar ?? 0,
                        Ishar_Tax_sub: row.Ishar_Tax_sub ?? 0,
                        Ishar_amout_Net_sub: row.Ishar_amout_Net_sub ?? 0,
                        Ishar_type_sub: row.Ishar_type_sub ?? 0,
                        Ishar_level_sub: row.Ishar_level_sub ?? 0,
                    };
                });

                setIsData(dataItems);
                setPayment({
                    ...payment,
                    paidup: res.data.inv?.Pay_mouny,
                    stay: res.data.inv?.Remaining,
                });

                remains.cashPart = res.data.inv?.cash_part;
                remains.agelPart = res.data.inv?.agel_part;
                remains.networkPart = res.data.inv?.network_part;
                remains.bankPart = res.data.inv?.bank_part;
                remains.empPart = res.data.inv?.emp_part;
                remains.isCash = parseFloat(res.data.inv.cashPart) > 0 ? true : false;
                remains.isAgel = parseFloat(res.data.inv.agelPart) > 0 ? true : false;
                remains.isNetwork = parseFloat(res.data.inv.networkPart) > 0 ? true : false;
                remains.isBank = parseFloat(res.data.inv.bankPart) > 0 ? true : false;
                remains.isEmp = parseFloat(res.data.inv.empPart) > 0 ? true : false;
                remains.allpart = parseFloat(res.data.inv?.netAmount);
                remains.isWindow = parseFloat(res.data.inv.bankPart) > 0 || parseFloat(res.data.inv.empPart) > 0 ? true : false;
                setSums({
                    ...sums,
                    val1: res.data.invS.reduce(
                        (totalVal1, sub) => totalVal1 + sub.val1,
                        0
                    ),
                });
                // setPrmiCuCo({ ...permiCuCo, CWVat: res.data.inv.vat_type });
                res.data.inv.inv_type === 1
                    ? setValueType(AutoOptions.types[0])
                    : setValueType(AutoOptions.types[1]);
                pinAutosValue("Safe", res.data.inv.safe);



                pinAutosValue("Stock", res.data.inv.stock);
                pinAutosValue("Customer", res.data.inv.cust_id);
                /* Autos options */
                if (res.data.inv.salesman != -1)
                    pinAutosValue("salesmen", res.data.inv.salesman);
                else {
                    setValueSalesmen(AutoOptions?.salesuser);
                }
                if (res.data.inv.center != -1)
                    pinAutosValue("costcenter", res.data.inv.center);
                else {
                    setValueCostcenter(AutoOptions?.centerUser);
                }
                let letNetworkck = false,
                    letCashck = false,
                    letcashORnetworksw = false;
                if (res.data.inv.pay_type === 1) {
                    setValueBank(insh.AutoBank);
                    letCashck = true;
                    letcashORnetworksw = false;
                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: false,
                        DeleIcon: true,
                    });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });
                }
                else if (res.data.inv.pay_type === 2) {
                    letNetworkck = true;
                    letcashORnetworksw = true;
                    setUiElement({ ...uiElement, bank: false, DeleIcon: true });
                    const text = transForm("network").toString();
                    setLbl({ ...lbl, chashNetwork: text });
                    pinAutosValue("Bank", res.data.inv.bank);
                }
                else if (res.data.inv.pay_type === -1 && parseFloat(res.data.inv.cash_part) > 0) {
                    letCashck = true;
                    letcashORnetworksw = false;
                    setSwitchState({ ...switchState, cashORnetworksw: false });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });
                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: false,
                        DeleIcon: true,
                    });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });
                }
                else if (res.data.inv.pay_type === -1 && parseFloat(res.data.inv.network_part) > 0) {
                    letNetworkck = true;
                    letcashORnetworksw = true;
                    setUiElement({ ...uiElement, bank: false, DeleIcon: true });
                    const text = transForm("network").toString();
                    setLbl({ ...lbl, chashNetwork: text });
                    // pinAutosValue("Bank", res.data.inv.bank);
                }
                else if (res.data.inv.pay_type === -1 && parseFloat(res.data.inv.Pay_mouny) === 0) {
                    // setValueStock(AutoOptions.Stocks[0]);
                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: true,
                        stock: true,
                        DeleIcon: true,
                    });
                    setValueBank(insh.AutoBank);
                }
                else {
                    // setValueStock(AutoOptions.Stocks[0]);
                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: true,
                        stock: true,
                        DeleIcon: true,
                    });
                    setValueBank(insh.AutoBank);
                }

                setInfoInv({
                    id: res.data.inv.id,
                    InvId_Return:
                        res.data.inv.InvId_Return != null
                            ? res.data.inv.InvId_Return
                            : infoInv.InvId_Return,
                });

                /* ======= S in PMD ======= */
                /* checked AND Autos */
                let cash_p = false,
                    network_p = false,
                    agel_p = false,
                    bank_p = false,
                    emp_p = false;

                if (res.data.inv.cash_part !== null || res.data.inv.cash_part === 0) {
                    cash_p = true;
                }
                if (parseFloat(res.data.inv.network_part ?? 0) > 0) {
                    if (parseFloat(res.data.inv.bank_part ?? 0) > 0 || parseFloat(res.data.inv.emp_part ?? 0) > 0) {
                        pinAutosValue("BankNET", res.data.inv.bank);
                    } else {
                        pinAutosValue("Bank", res.data.inv.bank);
                    }
                    network_p = true;
                } else {
                    setValueBankPMD(insh.AutoBank);
                }

                if (res.data.inv.agel_part !== null || res.data.inv.agel_part === 0) {
                    agel_p = true;
                }

                if (res.data.inv.bank_part !== null || res.data.inv.bank_part === 0) {
                    pinAutosValue("Bank2PMD", res.data.inv.bank2);
                    bank_p = true;
                }

                if (res.data.inv.emp_part !== null || parseFloat(res.data.inv.emp_part ?? 0) === 0) {
                    pinAutosValue("EmployeePMD", res.data.inv.emp);
                    emp_p = true;
                }

                setSwitchState({ ...switchState, cashORnetworksw: letcashORnetworksw });
                setChecked({
                    ...checked,

                    // in UP
                    cashck: letCashck,
                    networkck: letNetworkck,
                    // in PMD
                    cash_partck: cash_p,
                    network_partck: network_p,
                    agel_partck: agel_p,
                    bank_partck: bank_p,
                    emp_partck: emp_p,
                });

                /* ======= E in PMD ======= */
                // set discount values
                fcHandSumsToinvDisc(res.data.inv?.amountBefordisc, res.data.inv?.minus);
                if (setting.PrTy_InPr === "01" && res?.data?.InvExpenses?.length > 0) {
                    getExpensesInv(res?.data?.InvExpenses);
                }
                setValue(0);
                handCloseDw();

                try {
                    if (parseFloat(res.data.inv.bank_part) > 0 || parseFloat(res.data.inv.emp_part) > 0) {
                        setShowPaid(true);
                    }
                } catch { }
            })
            .catch((error) => {
                /*console.log('no res');*/
            });
    };

    const getExpensesInv = (subData) => {
        setExpenseList(
            subData.map((sub, i) => {
                const account = AutoOptions?.Accindex.find((obj) => obj.id === sub.Expense_Acc_no);
                const defOmla = gets?.omlats.find((obj) => obj.id === sub.omla);

                return {
                    ...sub,
                    omlaName: defOmla.name,
                    exchange: defOmla.exchange,
                    acc_name: account.name,
                    name: account.name,
                    editOmla: false,
                    edit_acc_no: false,
                    editNotes: false,
                    editValue: false,
                    defAcc_no: {},
                    defOmla: {},
                    no: i,
                };
            }));


    };

    useEffect(() => {
        showDialogInv();
    }, []);

    const showDialogInv = async () => {
        setExpenseList([]);
        if (props.isDialog === true) {
            setOr({ ...or, postput: "toPut", PrAC: 0 });

            if (["12", "02", "149", "150"].includes(props.invData.ProcType_InvProc)) {
                setIshedden(true);
            } else {
                setIshedden(permistionInv.Up == true ? false : true);
            }
            if (props.invData.ProcType_InvProc === "03" || props.invData.ProcType_InvProc === "04") {
                if (!isHedden) {
                    setIsOpenUpdate(true);
                }
            };
            let t = false;
            const tbs = {
                View_Inv_reseloving: true,
                View_Inv_Expenses: props.invData.ProcType_InvProc === "01" ? true : false,
                parms: {
                    iprocid: props.invData.proc_id,
                    bol1: permiCuCo.CWVat,
                    sProTyInvPro: props.invData.ProcType_InvProc,
                },
                autos: {},
            };
            const alt = { View_Inv_reseloving: true };

            const al = Object.entries(alt).reduce((u, [n, v]) => {
                u[`${n}` + `${t ? "t" : ""}`] = v;
                return u;
            }, {});
            const alts = { ...al, ...tbs };
            await axios
                .post(uri + "Res", alts)
                .then((res) => {
                    //console.log('res.data'); console.log(res.data);
                    setIData({
                        ...res.data.inv,
                        time: moment(res.data.inv.date).format(" h:mm A"),
                    });
                    console.log("the res data inve is", res.data.inv);
                    // .then(resSub => {
                    // setIData(res.data.inv);
                    const dataItems = res.data.invS.map((row, i) => {
                        return {
                            ...row,
                            UnitsTable: [],
                            defUnit: {},
                            no: i,
                            editAbleVal: false,
                            editAblePrice: false,
                            editAbleUnit: false,
                            editAbleTax: false,
                            editAbleDescM: false,
                            editAbleDescP: false,
                            editAbleDescNote: false,
                            tab3val_sub: row?.tab3Val ?? 0,
                            Qtys: 0,
                            tab3Val: row?.tab3Val ?? 0,
                            type: 1,
                            Ishar_NewPrice: row.Ishar_NewPrice ?? 0,
                            Ishar_amout_sub: row.Ishar_amout_sub ?? 0,
                            Ishar_amout_tot_sub: row.Ishar_amout_tot_sub ?? 0,
                            NewPrice_AfterIshar: row.NewPrice_AfterIshar ?? 0,
                            NewTax_AfterIshar: row.NewTax_AfterIshar ?? 0,
                            NewTot_AfterIshar: row.NewTot_AfterIshar ?? 0,
                            Ishar_Tax_sub: row.Ishar_Tax_sub ?? 0,
                            Ishar_amout_Net_sub: row.Ishar_amout_Net_sub ?? 0,
                            Ishar_type_sub: row.Ishar_type_sub ?? 0,
                            Ishar_level_sub: row.Ishar_level_sub ?? 0,
                        };
                    });

                    setIsData(dataItems);
                    // setIsData(res.data.invS);
                    setPayment({
                        ...payment,
                        paidup: res.data.inv?.Pay_mouny,
                        stay: res.data.inv?.Remaining,
                    });
                    setRemains({
                        ...remains,
                        cashPart: res.data.inv?.cash_part,
                        agelPart: res.data.inv?.agel_part,
                        networkPart: res.data.inv?.network_part,
                        bankPart: res.data.inv?.bank_part,
                        empPart: res.data.inv?.emp_part,
                    });
                    setSums({
                        ...sums,
                        val1: res.data.invS.reduce(
                            (totalVal1, sub) => totalVal1 + sub.val1,
                            0
                        ),
                    });

                    res.data.inv.inv_type === 1
                        ? setValueType(AutoOptions.types[0])
                        : setValueType(AutoOptions.types[1]);
                    pinAutosValue("Safe", res.data.inv.safe);

                    pinAutosValue("Stock", res.data.inv.stock);
                    pinAutosValue("Customer", res.data.inv.cust_id);
                    /* Autos options */
                    if (res.data.inv.salesman != -1)
                        pinAutosValue("salesmen", res.data.inv.salesman);
                    else {
                        setValueSalesmen(AutoOptions?.salesuser);
                    }
                    if (res.data.inv.center != -1)
                        pinAutosValue("costcenter", res.data.inv.center);
                    else {
                        setValueCostcenter(AutoOptions?.centerUser);
                    }
                    let letNetworkck = false,
                        letCashck = false,
                        letcashORnetworksw = false;
                    if (res.data.inv.pay_type === 1) {
                        setValueBank(insh.AutoBank);
                        letCashck = true;
                        letcashORnetworksw = false;
                        setUiElement({
                            ...uiElement,
                            bank: true,
                            payMethod: false,
                            DeleIcon: true,
                        });
                        setLbl({ ...lbl, chashNetwork: transForm("cash") });
                    }
                    else if (res.data.inv.pay_type === 2) {
                        letNetworkck = true;
                        letcashORnetworksw = true;
                        setUiElement({ ...uiElement, bank: false, DeleIcon: true });
                        const text = transForm("network").toString();
                        setLbl({ ...lbl, chashNetwork: text });
                        pinAutosValue("Bank", res.data.inv.bank);
                    }
                    else if (res.data.inv.pay_type === -1 && parseFloat(res.data.inv.cash_part) > 0) {
                        setValueBank(insh.AutoBank);
                        letCashck = true;
                        letcashORnetworksw = false;
                        setSwitchState({ ...switchState, cashORnetworksw: false });
                        setLbl({ ...lbl, chashNetwork: transForm("cash") });
                        setUiElement({
                            ...uiElement,
                            bank: true,
                            payMethod: false,
                            DeleIcon: true,
                        });
                        setLbl({ ...lbl, chashNetwork: transForm("cash") });
                    }
                    else if (res.data.inv.pay_type === -1 && parseFloat(res.data.inv.network_part) > 0) {
                        letNetworkck = true;
                        letcashORnetworksw = true;
                        setUiElement({ ...uiElement, bank: false, DeleIcon: true });

                        setValueBank(res.data.inv.bank);
                        const text = transForm("network").toString();
                        setLbl({ ...lbl, chashNetwork: text });
                        pinAutosValue("Bank", res.data.inv.bank);
                    }
                    else if (res.data.inv.pay_type === -1 && res.data.inv.Pay_mouny === 0) {
                        // setValueStock(AutoOptions.Stocks[0]);
                        setUiElement({
                            ...uiElement,
                            bank: true,
                            payMethod: true,
                            stock: true,
                            DeleIcon: true,
                        });
                        setValueBank(insh.AutoBank);
                    }
                    else {
                        // setValueStock(AutoOptions.Stocks[0]);
                        setUiElement({
                            ...uiElement,
                            bank: true,
                            payMethod: true,
                            stock: true,
                            DeleIcon: true,
                        });
                        setValueBank(insh.AutoBank);
                    }

                    setInfoInv({
                        id: res.data.inv.id,
                        InvId_Return:
                            res.data.inv.InvId_Return != null
                                ? res.data.inv.InvId_Return
                                : infoInv.InvId_Return,
                    });

                    /* ======= S in PMD ======= */
                    /* checked AND Autos */
                    let cash_p = false,
                        network_p = false,
                        agel_p = false,
                        bank_p = false,
                        emp_p = false;

                    if (res.data.inv.cash_part !== null || res.data.inv.cash_part === 0) {
                        cash_p = true;
                    }

                    if (
                        res.data.inv.network_part !== null ||
                        res.data.inv.network_part === 0
                    ) {
                        // g etAutosOptions('Bank',res.data.inv.bank,'NWinPMD');
                        pinAutosValue("BankPMD", res.data.inv.bank);
                        network_p = true;
                    } else {
                        setValueBankPMD(insh.AutoBank);
                    }

                    if (res.data.inv.agel_part !== null || res.data.inv.agel_part === 0) {
                        agel_p = true;
                    }

                    if (res.data.inv.bank_part !== null || res.data.inv.bank_part === 0) {
                        // g etAutosOptions('Bank',res.data.inv.bank,'Bk2inPMD');
                        pinAutosValue("Bank2PMD", res.data.inv.bank);
                        bank_p = true;
                    }

                    if (res.data.inv.emp_part !== null || res.data.inv.emp_part === 0) {
                        // g etAutosOptions('Employee',res.data.inv.emp,'EmpinPMD');
                        pinAutosValue("EmployeePMD", res.data.inv.emp);
                        emp_p = true;
                    }

                    setSwitchState({ ...switchState, cashORnetworksw: letcashORnetworksw });
                    setChecked({
                        ...checked,

                        // in UP
                        cashck: letCashck,
                        networkck: letNetworkck,
                        // in PMD
                        cash_partck: cash_p,
                        network_partck: network_p,
                        agel_partck: agel_p,
                        bank_partck: bank_p,
                        emp_partck: emp_p,
                    });

                    /* ======= E in PMD ======= */
                    // set discount values
                    fcHandSumsToinvDisc(res.data.inv?.amountBefordisc, res.data.inv?.minus);
                    if (props.invData.ProcType_InvProc === "01" && res?.data?.InvExpenses?.length > 0) {
                        getExpensesInv(res?.data?.InvExpenses);
                    };
                    handCloseDw();

                })
                .catch((error) => {
                });
        }
    };
    const showChosedInvt = async (t, val) => {
        const tbs = { parms: { iprocid: val, bol1: permiCuCo.CWVat }, autos: {} };
        const alt = { View_Inv_reseloving: true };
        const al = Object.entries(alt).reduce((u, [n, v]) => {
            u[`${n}` + `${t ? "t" : ""}`] = v;
            return u;
        }, {});
        const alts = { ...al, ...tbs };

        await axios
            .post(uri + "Res", alts)
            .then((res) => {
                setIData({
                    ...res.data.inv, date: moment(new Date()).format("YYYY-MM-DD"),
                    Due_date: res.data.inv?.Due_date == null ? "" : moment(res.data.inv?.Due_date).format("YYYY-MM-DD"),
                    Delivery_date: res.data.inv?.Delivery_date == null ? "" : moment(res.data.inv?.Delivery_date).format("YYYY-MM-DD"),
                });
                const dataItems = res.data.invS.map((row, i) => {
                    return {
                        ...row,
                        UnitsTable: [],
                        defUnit: {},
                        no: i,
                        editAbleVal: false,
                        editAblePrice: false,
                        editAbleUnit: false,
                        editAbleTax: false,
                        editAbleDescM: false,
                        editAbleDescP: false,
                        editAbleDescNote: false,
                        tab3val_sub: row?.tab3Val ?? 0,
                        Qtys: 0,
                        tab3Val: row?.tab3Val ?? 0,
                        type: 1,

                    };
                });

                setIsData(dataItems);
                setPayment({
                    ...payment,
                    paidup: res.data.inv?.Pay_mouny,
                    stay: res.data.inv?.Remaining,
                });
                setRemains({
                    ...remains,
                    cashPart: res.data.inv?.cash_part,
                    agelPart: res.data.inv?.agel_part,
                    networkPart: res.data.inv?.network_part,
                    empPart: res.data.inv?.emp_part,
                    bankPart: res.data.inv?.bank_part,

                });
                setSums({
                    ...sums,
                    val1: res.data.invS.reduce(
                        (totalVal1, sub) => totalVal1 + sub.val1,
                        0
                    ),
                });
                setStor({ ...stor, comt: val });
                res.data.inv.inv_type == 1
                    ? setValueType(AutoOptions.types[0])
                    : setValueType(AutoOptions.types[1]);
                pinAutosValue("Safe", res.data.inv.safe);
                pinAutosValue("Stock", res.data.inv.stock);
                pinAutosValue("Customer", res.data.inv.cust_id);



                /* Autos options */
                if (res.data.inv.salesman != -1)
                    pinAutosValue("salesmen", res.data.inv.salesman);
                else {

                    setValueSalesmen(AutoOptions?.salesuser);
                }
                if (res.data.inv.center != -1)
                    pinAutosValue("costcenter", res.data.inv.center);
                else {
                    setValueCostcenter(AutoOptions?.centerUser);
                }
                let letNetworkck = false,
                    letCashck = false,
                    letcashORnetworksw = false;
                if (res.data.inv.pay_type == 1) {
                    setValueBank(insh.AutoBank);
                    letCashck = true;
                    letcashORnetworksw = false;

                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: false,
                        DeleIcon: true,
                    });
                } else if (res.data.inv.pay_type == 2) {
                    letNetworkck = true;
                    letcashORnetworksw = true;
                    setUiElement({ ...uiElement, bank: false, DeleIcon: true });
                    setLbl({ ...lbl, chashNetwork: transForm("network") });
                    pinAutosValue("Bank", res.data.inv.bank);
                }
                else if (res.data.inv.pay_type == -1 && parseFloat(res.data.inv.cash_part) > 0) {
                    setValueBank(insh.AutoBank);
                    letCashck = true;
                    letcashORnetworksw = false;
                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: false,
                        DeleIcon: true,
                    });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });
                }
                else if (res.data.inv.pay_type == -1 && parseFloat(res.data.inv.network_part) > 0) {
                    letNetworkck = true;
                    letcashORnetworksw = true;
                    setUiElement({ ...uiElement, bank: false, DeleIcon: true });
                    const text = transForm("network").toString();
                    setLbl({ ...lbl, chashNetwork: text });
                    pinAutosValue("Bank", res.data.inv.bank);
                }
                else if (res.data.inv.pay_type == -1 && parseFloat(res.data.inv.Pay_mouny) == 0) {
                    setValueStock(AutoOptions.Stocks[0]);
                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: true,
                        stock: true,
                        DeleIcon: true,
                    });
                    setValueBank(insh.AutoBank);
                }
                else {
                    setValueStock(AutoOptions.Stocks[0]);
                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: true,
                        stock: true,
                        DeleIcon: true,
                    });
                    setValueBank(insh.AutoBank);
                }
                setInfoInv({
                    id: res.data.inv.id,
                    InvId_Return:
                        res.data.inv.InvId_Return != null
                            ? res.data.inv.InvId_Return
                            : infoInv.InvId_Return,
                });

                /* ======= S in PMD ======= */
                /* checked AND Autos */
                let cash_p = false,
                    network_p = false,
                    agel_p = false,
                    bank_p = false,
                    emp_p = false;

                if (res.data.inv.cash_part !== null || res.data.inv.cash_part === 0) {
                    cash_p = true;
                }

                if (
                    res.data.inv.network_part !== null ||
                    res.data.inv.network_part === 0
                ) {
                    pinAutosValue("BankPMD", res.data.inv.bank);
                    network_p = true;
                } else {
                    setValueBankPMD(insh.AutoBank);
                }

                if (res.data.inv.agel_part !== null || res.data.inv.agel_part === 0) {
                    agel_p = true;
                }

                if (res.data.inv.bank_part !== null || res.data.inv.bank_part === 0) {
                    pinAutosValue("Bank2PMD", res.data.inv.bank);
                    bank_p = true;
                }

                if (res.data.inv.emp_part !== null || res.data.inv.emp_part === 0) {
                    pinAutosValue("EmployeePMD", res.data.inv.emp);
                    emp_p = true;
                }

                setSwitchState({ ...switchState, cashORnetworksw: letcashORnetworksw });
                setChecked({
                    ...checked,
                    // in UP
                    cashck: letCashck,
                    networkck: letNetworkck,
                    // in PMD
                    cash_partck: cash_p,
                    network_partck: network_p,
                    agel_partck: agel_p,
                    bank_partck: bank_p,
                    emp_partck: emp_p,
                });

                /* ======= E in PMD ======= */
                handCloseDwt();
                setValue(0);
            })
            .catch((error) => {
                /*console.log('no res');*/
            });
    };

    const [voucherDialog, setVoucherDialog] = useState({
        isOpen: false,
        data: "",
        onSucsess: "",
        onEnd: ""
    });


    const blurPaid2 = (pay) => {
        if (parseFloat(pay) > parseFloat(idata.netAmount)) {
            let valueVcher = (pay - parseFloat(idata.netAmount)).toFixed(2);
            //event.stopPropagation();
            setVoucherDialog({
                isOpen: true,
                data: {
                    ...idata, id: infoInv.id,
                    omlaId: omlaValue.id,
                    exchange: omlaValue.exchange,
                    valueOfVoucher: valueVcher,
                    cust_id: valueCustomers.id,
                    acc_no: valueCustomers?.acc_no,
                    cust_name: valueCustomers?.name,
                    bankAcc: valueBanksPaid?.i,
                    networkAcc: valueBank?.i,
                    stockAcc: valueStock?.acc ?? 0,
                    type: idata.pay_type === 1 ? "1" : "2",
                    safe_bank_id: idata.pay_type === 1 ? valueStock.id : valueBank?.id,
                },
                onSuccess: () => {
                    // toDiloa
                    setVoucherDialog({ ...voucherDialog, isOpen: false });
                    toDoIdata("notes", "Receipt voucher for the amount:" + valueVcher);
                },

            });
            payment.paidupPMDcn = parseFloat(idata.netAmount);
            payment.stayPMDcn = payment.stay;
            payment.paidup = idata.netAmount;
            payment.stay = 0;
            //setPayment({ ...payment, paidup: parseFloat(idata.netAmount), stay: 0 });
        }
    };

    const changPayment = (prop) => (event) => {

        if (prop === "paidup") {

            let total = (parseFloat(idata.netAmount) - event.target.value).toFixed(2);
            // toDiloag
            payment.paidupPMDcn = event.target.value;
            payment.stayPMDcn = payment.stay;
            setPayment({ ...payment, paidup: event.target.value, stay: total });
            setRemains({ ...remains, cashPart: event.target.value, agelPart: total, bankPart: 0, networkPart: 0 });

            if (valueType.id === 1) {

                if (switchState.cashORnetworksw == false) {
                    setUiElement({
                        ...uiElement,
                        stock: false,
                        payMethod: false,
                        bank: true,
                    });

                    setRemains({ ...remains, cashPart: event.target.value, agelPart: total, bankPart: 0, networkPart: 0 });

                    const reet = reInshAuto(0, "");
                    setValueBank(reet);
                    setValueStock(AutoOptions.Stocks[0]);
                    setSwitchState({ ...switchState, cashORnetworksw: false });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });
                } else if (switchState.cashORnetworksw == true) {
                    setRemains({ ...remains, cashPart: 0, agelPart: total, bankPart: 0, networkPart: event.target.value });

                    setUiElement({
                        ...uiElement,
                        stock: true,
                        payMethod: false,
                        bank: false,
                    });

                    setSwitchState({ ...switchState, cashORnetworksw: true });
                    setLbl({ ...lbl, chashNetwork: transForm("network") });
                }
                else {
                    setUiElement({
                        ...uiElement,
                        stock: false,
                        payMethod: false,
                        bank: true,
                    });

                    setRemains({ ...remains, cashPart: event.target.value, agelPart: total, bankPart: 0, networkPart: 0 });

                    const reet = reInshAuto(0, "");
                    setValueBank(reet);
                    setValueStock(AutoOptions.Stocks[0]);
                    setSwitchState({ ...switchState, cashORnetworksw: false });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });

                }


            }

        } else if (prop === "paidupPMDcn") {
            payment.stayPMDcn = (
                event.target.value - parseFloat(idata.netAmount)
            ).toFixed(2);
            setPayment({ ...payment, [prop]: event.target.value });
        }
    };

    const MathChckedIdata = (prop, val) => {
        let res = Number(val);
        res += idata.cash_part;
        setIData({ ...idata, [prop]: "", cash_part: res });
    };

    const MathChangIdata = (prop, val) => {
        let ii = {
            totinv: Number(idata.netAmount),
            res: Number(val),
            sum: Number(0),
        };
        let i = {
            cashPart: Number(remains.cashPart),
            networkPart: Number(remains.networkPart),
            agelPart: Number(remains.agelPart),
            bankPart: Number(remains.bankPart),
            empPart: Number(remains.empPart),
        };
        let kind = "";
        const otherField = Object.keys(i).filter((f) => f !== prop);
        const remainaing = ii.totinv - ii.res;
        let newValue = { ...i, [prop]: ii.res };
        if (parseFloat(remainaing) < 0) {
            if (remains.isAgel == true && parseFloat(remains.agelPart) > 0 && prop !== "agelPart") {
                newValue[prop] = 0;
                otherField.forEach((f) => (newValue[f] = 0));
                newValue["agelPart"] = ii.totinv;
            } else {
                newValue[prop] = ii.totinv;
                otherField.forEach((f) => (newValue[f] = 0));
            }
        } else {
            newValue[prop] = ii.res;
            if (switchState.cashORnetworksw == false && remains.isCash == true &&
                remains.isAgel == false && prop !== "cashPart") {
                const cashFeild = Object.keys(i).filter((f) => f !== prop && f !== "cashPart");
                let sumOthers = cashFeild.reduce((acc, f) => acc + parseFloat(i[f]) || 0, 0);
                newValue["cashPart"] = (ii.totinv - (ii.res) - parseFloat(sumOthers)).toFixed(2);
            }
            else if (switchState.cashORnetworksw === true && remains.isNetwork == true
                && remains.isAgel == false && prop !== "networkPart") {
                const networkFeild = Object.keys(i).filter((f) => f !== prop && f !== "networkPart");
                let sumOthers = networkFeild.reduce((acc, f) => acc + parseFloat(i[f]) || 0, 0);
                newValue["networkPart"] = (ii.totinv - (ii.res) - parseFloat(sumOthers)).toFixed(2);
            } else if (remains.isAgel == true && parseFloat(remains.agelPart) > 0 && prop !== "agelPart") {
                const agelFeild = Object.keys(i).filter((f) => f !== prop && f !== "agelPart");
                let sumOthers = agelFeild.reduce((acc, f) => acc + parseFloat(i[f]) || 0, 0);
                if (ii.res >= ii.totinv) {
                    newValue[prop] = 0;
                    newValue["agelPart"] = ii.totinv.toFixed(2);
                } else {
                    newValue["agelPart"] = (ii.totinv - (ii.res) - parseFloat(sumOthers)).toFixed(2);
                }
            }
        }
        let all = parseFloat(newValue.cashPart) + parseFloat(newValue.agelPart) +
            parseFloat(newValue.bankPart) + parseFloat(newValue.empPart) + parseFloat(newValue.networkPart);
        if (prop === "bankPart" && (idata.bank2 == -1 || idata.bank2 == 0)) {
            idata.bank2 = AutoOptions.Banks[0].id;
        } else if (prop === "networkPart" && (idata.bank == -1 || idata.bank == 0)) {
            idata.bank = AutoOptions.Banks[0].id;
        };

        let payMony = (parseFloat(newValue.bankPart) + parseFloat(newValue.cashPart) + parseFloat(newValue.networkPart) +
            parseFloat(newValue.empPart)).toFixed(2);
        let raimMony = (parseFloat(idata.netAmount) - parseFloat(payMony)).toFixed(2);
        setPayment({ ...payment, paidup: payMony ?? 0, stay: raimMony ?? 0 });
        if (parseFloat(newValue.agelPart) == 0 && valueType.id === 1) { idata.inv_type = 2; setValueType(AutoOptions.types[1]); }

        if (parseFloat(newValue.cashPart) === 0 && idata.pay_type === 1 &&
            (parseFloat(newValue.bankPart) > 0 || parseFloat(newValue.networkPart) > 0)) {
            idata.pay_type = 2; uiElement.bank = false; uiElement.stock = false; uiElement.payMethod = false;
            const text = transForm("network").toString(); lbl.chashNetwork = text;
        } else if (parseFloat(newValue.cashPart) === parseFloat(idata.netAmount) && idata.pay_type !== 1) {
            idata.pay_type = 1; idata.inv_type = 2; uiElement.bank = false; uiElement.stock = false; uiElement.payMethod = false;
            const text = transForm("network").toString();
            lbl.chashNetwork = text;
        } else if (parseFloat(newValue.agelPart) > 0 && idata.inv_type !== 1 && idata.pay_type !== -1) {
            idata.inv_type = 1; idata.pay_type = -1; setValueType(AutoOptions.types[0]);
        }

        setRemains({
            ...remains,
            agelPart: newValue.agelPart,
            bankPart: newValue.bankPart,
            cashPart: newValue.cashPart,
            networkPart: newValue.networkPart,
            empPart: newValue.empPart,
            isCash: parseFloat(newValue.cashPart) > 0 ? true : false,
            isAgel: parseFloat(newValue.agelPart) > 0 ? true : false,
            isNetwork: parseFloat(newValue.networkPart) > 0 ? true : false,
            isBank: parseFloat(newValue.bankPart) > 0 ? true : false,
            isEmp: parseFloat(newValue.empPart) > 0 ? true : false,
            allpart: all,
            isWindow: true,
        });
    };
    const changIdata = (prop) => (event) => {
        if (prop === "cashPart" && remains.isCash === true) {
            MathChangIdata(prop, event.target.value);
        } if (prop === "networkPart" && remains.isNetwork === true) {
            MathChangIdata(prop, event.target.value);
        } else if (prop === "agelPart" && remains.isAgel === true) {
            MathChangIdata(prop, event.target.value);
        } else if (prop === "bankPart" && remains.isBank === true) {
            MathChangIdata(prop, event.target.value);
        }
        else if (prop === "empPart" && remains.isEmp === true) {
            MathChangIdata(prop, event.target.value);
        }
        else if (prop == "check_refno" && remains.isBank == true) {
            toDoIdata(prop, event.target.value);
        } else if (prop == "refno") {
            toDoIdata(prop, event.target.value);
        } else if (prop == "date") {
            toDoIdata(prop, event.target.value);
        } else if (prop == "notes") {
            toDoIdata(prop, event.target.value);
        }
        else if (prop == "Due_date") {
            toDoIdata(prop, event.target.value);
        }
        else if (prop == "Delivery_date") {
            toDoIdata(prop, event.target.value);
        } else {
            toDoIdata(prop, event.target.value);
        }
    };

    const changeIdataIshar = (prop) => async (event) => {
        await mathIdataIshar(event);
    };
    const mathIdataIshar = async (event) => {
        let tot = Number(event.target.value);

        let tot_ishar_before = 0, tot_ishar_tax = 0, tot_ishar_net = 0, tot_ishar = 0;
        const totalsItems = isdata.reduce((sum, item) => {
            return sum + (item.totJust || 0);
        }, 0);
        if (parseFloat(tot) > parseFloat(totalsItems)) tot = 0;
        for (let m = 0; m < isdata.length; m++) {

            let old_price = idata.vat_type === 0 ? isdata[m].new_exchange_price :
                (isdata[m].new_exchange_price - (isdata[m].new_exchange_price / ((100 + isdata[m].taxperc) / isdata[m].taxperc)));

            let price_Ishar = parseFloat((isdata[m].new_exchange_price / totalsItems) * tot);

            let new_price_Dept = (parseFloat(old_price) + parseFloat(price_Ishar));

            let new_price_Cre = (parseFloat(old_price) - parseFloat(price_Ishar));

            let new_price = setting.PrTy_InPr === "149" ? new_price_Cre : new_price_Dept;

            let tot_ishar_sub = (parseFloat(price_Ishar) * parseFloat(isdata[m].val1));

            let price_after_desc = idata.vat_type === 0 ? isdata[m].exchange_price - parseFloat(isdata[m].discount / isdata[m].val1) :
                isdata[m].exchange_price;
            let price_after_Eshar = setting.PrTy_InPr === "149" ? (parseFloat(price_after_desc) - parseFloat(price_Ishar)) :
                (parseFloat(price_after_desc) + parseFloat(price_Ishar));

            let tot_safi = parseFloat(price_after_Eshar * isdata[m].val1);

            // let totbef = (parseFloat(tot_ishar_sub) - parseFloat(desc_mount));
            let totbef = parseFloat(tot_ishar_sub);

            let taxMount_eshar = mathsEshar(
                parseFloat(totbef),
                parseFloat(isdata[m].taxperc),
                "taxval"
            );
            let betTax_eshar = mathsEshar(
                parseFloat(totbef),
                parseFloat(isdata[m].taxperc),
                "before_vat"
            );
            let resNetA_eshar = mathsEshar(
                parseFloat(totbef),
                parseFloat(isdata[m].taxperc),
                "Net"
            );
            let taxMount_sub = maths(
                parseFloat(tot_safi),
                parseFloat(isdata[m].taxperc),
                "taxval"
            );
            let resNetA_sub = maths(
                parseFloat(tot_safi),
                parseFloat(isdata[m].taxperc),
                "Net"
            );
            tot_ishar_before += parseFloat(betTax_eshar);
            tot_ishar_tax += parseFloat(taxMount_eshar);
            tot_ishar_net += parseFloat(resNetA_eshar);
            tot_ishar += parseFloat(tot_ishar_sub);


            isdata[m].Ishar_NewPrice = parseFloat(new_price).toFixed(4);

            isdata[m].NewPrice_AfterIshar = parseFloat(price_after_Eshar).toFixed(4);
            isdata[m].Ishar_amout_sub = parseFloat(price_Ishar).toFixed(4);
            isdata[m].Ishar_amout_tot_sub = parseFloat(price_Ishar * isdata[m].val1).toFixed(4);

            isdata[m].NewTax_AfterIshar = parseFloat(taxMount_sub).toFixed(4);
            isdata[m].NewTot_AfterIshar = parseFloat(resNetA_sub).toFixed(4);

            isdata[m].Ishar_Tax_sub = parseFloat(taxMount_eshar).toFixed(4);
            isdata[m].Ishar_amout_Net_sub = parseFloat(resNetA_eshar).toFixed(4);
            isdata[m].Ishar_type_sub = setting.PrTy_InPr === "149" ? 0 : 1;
            isdata[m].Ishar_level_sub = 0;
        };
        tot_ishar_before = (
            parseFloat(tot)
        ).toFixed(2);
        tot_ishar_tax = (
            parseFloat(tot_ishar_tax)
        ).toFixed(2);
        tot_ishar_net = (
            parseFloat(tot) + parseFloat(tot_ishar_tax)
        ).toFixed(2);
        setIData({
            ...idata,
            amountAfterDisc: tot_ishar_before,
            amountWithVat: tot_ishar_net,
            tot_sale: tot_ishar_before,
            tot_purch: tot_ishar_before,
            netAmount: tot_ishar_net,
            amountBefordisc: tot_ishar_before,
            amountOfVat: tot_ishar_tax,
            Ishar_amout: event.target.value,
            Ishar_Tax: tot_ishar_tax,
            Ishar_amout_Net: tot_ishar_net,
            minus: 0,
            tab3Val: 0,
            Ishar_type: setting.PrTy_InPr === "149" ? 0 : 1,
            Ishar_level: 0,
        });
        await fcHandSumsToPayment(tot_ishar_net);
    };

    const mathIdataIsharItem = async (rowItem, row, setRowItem, type) => {
        let i = {
            NewPrice_AfterIshar: Number(rowItem.NewPrice_AfterIshar),
            Ishar_amout_sub: Number(rowItem.Ishar_amout_sub),
        };
        let tot_eshar = 0;
        let tot_ishar_before = 0, tot_ishar_tax = 0, tot_ishar_net = 0;

        let old_price = idata.vat_type === 0 ? rowItem.new_exchange_price :
            (rowItem.new_exchange_price - (rowItem.new_exchange_price / ((100 + rowItem.taxperc) / rowItem.taxperc)));

        let price_after_desc = idata.vat_type === 0 ? rowItem.exchange_price - parseFloat(rowItem.discount / rowItem.val1) :
            rowItem.exchange_price;

        if (type === "Ishar_amout_sub") {
            tot_eshar = i.Ishar_amout_sub;
        } else {
            tot_eshar = setting.PrTy_InPr === "149" ? parseFloat(price_after_desc - i.NewPrice_AfterIshar) :
                parseFloat(i.NewPrice_AfterIshar - price_after_desc);
        }
        let price_Ishar = parseFloat(tot_eshar);

        let new_price_Dept = (parseFloat(old_price) + parseFloat(price_Ishar));

        let new_price_Cre = (parseFloat(old_price) - parseFloat(price_Ishar));

        let new_price = setting.PrTy_InPr === "149" ? new_price_Cre : new_price_Dept;

        let newPriceAfter = type === "Ishar_amout_sub" ? new_price : rowItem.NewPrice_AfterIshar;

        if (parseFloat(newPriceAfter) <= 0 || parseFloat(tot_eshar) <= 0) {
            const index = row?.no;
            const dontUpdateData = [...isdata];
            dontUpdateData[index] = {
                ...row,
                editIshar_amout: false, editNewPrice_AfterIshar: false,
            };
            setIsData([...dontUpdateData]);
            setRowItem({});
            handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text: `مبلغ الاشعار اكبر من سعر الصنف`,
                time: 3000,
            });
        } else if (type === "NewPrice_AfterIshar" && setting.PrTy_InPr === "150" &&
            parseFloat(rowItem.NewPrice_AfterIshar) < parseFloat(old_price)) {
            const index = row?.no;
            const dontUpdateData = [...isdata];
            dontUpdateData[index] = {
                ...row,
                editIshar_amout: false, editNewPrice_AfterIshar: false,
            };
            setIsData([...dontUpdateData]);
            setRowItem({});
            handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text: "Price After Ishar Less than Acial price",
                time: 3000,
            });
        }
        else {

            let price_after_Eshar = setting.PrTy_InPr === "149" ? (parseFloat(price_after_desc) - parseFloat(price_Ishar)) :
                (parseFloat(price_after_desc) + parseFloat(price_Ishar));

            let new_Price_After = type === "Ishar_amout_sub" ? price_after_Eshar : rowItem.NewPrice_AfterIshar;

            let tot_safi = parseFloat(price_after_Eshar * rowItem.val1);

            let tot_ishar_sub = (parseFloat(price_Ishar) * parseFloat(rowItem.val1));

            let totbef = parseFloat(tot_ishar_sub);

            let taxMount_eshar = mathsEshar(
                parseFloat(totbef),
                parseFloat(rowItem.taxperc),
                "taxval"
            );
            let resNetA_eshar = mathsEshar(
                parseFloat(totbef),
                parseFloat(rowItem.taxperc),
                "Net"
            );
            let taxMount_sub = maths(
                parseFloat(tot_safi),
                parseFloat(rowItem.taxperc),
                "taxval"
            );
            let resNetA_sub = maths(
                parseFloat(tot_safi),
                parseFloat(rowItem.taxperc),
                "Net"
            );

            rowItem.Ishar_NewPrice = parseFloat(new_price).toFixed(4);
            // rowItem.NewPrice_AfterIshar = newPriceAfter;
            rowItem.NewPrice_AfterIshar = parseFloat(new_Price_After).toFixed(4);;
            rowItem.Ishar_amout_sub = parseFloat(price_Ishar).toFixed(4);
            rowItem.Ishar_amout_tot_sub = parseFloat(price_Ishar * rowItem.val1).toFixed(4);

            rowItem.NewTax_AfterIshar = parseFloat(taxMount_sub).toFixed(4);
            rowItem.NewTot_AfterIshar = parseFloat(resNetA_sub).toFixed(4);
            rowItem.Ishar_Tax_sub = parseFloat(taxMount_eshar).toFixed(4);
            rowItem.Ishar_amout_Net_sub = parseFloat(resNetA_eshar).toFixed(4);
            rowItem.Ishar_type_sub = setting.PrTy_InPr === "149" ? 0 : 1;
            rowItem.Ishar_level_sub = 1;
            const dataUpdate = [...isdata];
            const index = rowItem?.no;

            dataUpdate[index] = { ...rowItem, editIshar_amout: false, editNewPrice_AfterIshar: false };

            for (var m = 0; m < dataUpdate.length; m++) {
                tot_ishar_before += parseFloat(dataUpdate[m].Ishar_amout_tot_sub);
                tot_ishar_tax += parseFloat(dataUpdate[m].Ishar_Tax_sub);
                tot_ishar_net += parseFloat(dataUpdate[m].Ishar_amout_Net_sub);
            }
            setIsData([...dataUpdate]);
            setRowItem({});
            tot_ishar_before = (
                parseFloat(tot_ishar_before)
            ).toFixed(2);
            tot_ishar_tax = (
                parseFloat(tot_ishar_tax)
            ).toFixed(2);
            tot_ishar_net = (
                parseFloat(tot_ishar_before) + parseFloat(tot_ishar_tax)
            ).toFixed(2);


            setIData({
                ...idata,
                amountAfterDisc: tot_ishar_before,
                amountWithVat: tot_ishar_net,
                tot_sale: tot_ishar_before,
                tot_purch: tot_ishar_before,
                netAmount: tot_ishar_net,
                amountBefordisc: tot_ishar_before,
                amountOfVat: tot_ishar_tax,
                Ishar_amout: tot_ishar_before,
                Ishar_Tax: tot_ishar_tax,
                Ishar_amout_Net: tot_ishar_net,
                minus: 0,
                tab3Val: 0,
                Ishar_type: setting.PrTy_InPr === "149" ? 0 : 1,
                Ishar_level: 1,
            });
            await fcHandSumsToPayment(tot_ishar_net);
        }
    };
    const change_discount_cust = (prop, value) => {
        console.log("the permissions is", permistionInv);

        let ret = null,
            evenTargetValue = null;
        if (isdata.length !== 0) {
            if (prop === "minus") {
                let value_dsc = Number(value);

                if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03")
                    evenTargetValue = (
                        (value_dsc * 100) /
                        parseFloat(idata.tot_sale)
                    );
                else
                    evenTargetValue = (
                        (value_dsc * 100) /
                        parseFloat(idata.tot_purch)
                    );


                if (permistionInv.SDV !== 0)
                    ret = retPrmiSDPandSDV(
                        parseFloat(value_dsc),
                        permistionInv.SDV,
                        "DiscC"
                    );

                else ret = retPrmiSDPandSDV(evenTargetValue, permistionInv.SDP, "DiscP");

                if (ret === "") {
                    value = "";
          /*invDisc.rate='';*/ afterInvDescount(0, value_dsc);
                } else {
                    afterInvDescount(evenTargetValue, value_dsc);
                }
            }
            else if (prop === "rate") {
                let value_perc = Number(value);

                if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03")
                    evenTargetValue = (
                        parseFloat(idata.tot_sale) *
                        (value_perc / 100)
                    );
                else
                    evenTargetValue = (
                        parseFloat(idata.tot_purch) *
                        (value_perc / 100)
                    );

                if (permistionInv.SDP !== 0)
                    ret = retPrmiSDPandSDV(
                        parseFloat(value_perc),
                        permistionInv.SDP,
                        "DiscP"
                    );
                else ret = retPrmiSDPandSDV(evenTargetValue, permistionInv.SDV, "DiscC");
                if (ret === "") {
                    value = "";
          /*idata.minus='';*/ afterInvDescount(0, evenTargetValue);
                } else {
                    afterInvDescount(value_perc, evenTargetValue);
                }
            }
        }
        prop === "minus"
            ? setInvDisc({
                ...invDisc,
                [prop]: value,
                rate: parseFloat(evenTargetValue).toFixed(2),
            })
            : setInvDisc({
                ...invDisc,
                [prop]: value,
                minus: parseFloat(evenTargetValue).toFixed(2),
            });
    };

    const clickChangeCusomers = (newValue) => {
        if (newValue?.discount != null && newValue?.disc_perc != null && parseFloat(newValue?.discount) != 0 &&
            parseFloat(newValue?.disc_perc)) {
            if (newValue?.disc_perc > 0) {
                change_discount_cust("rate", newValue?.disc_perc);
            } else if (newValue?.discount > 0) {
                change_discount_cust("minus", newValue?.discount);
            } else if (newValue?.discount == 0 && newValue?.disc_perc == 0) {
                change_discount_cust("rate", 0);
            }
        }
    }

    const changinvDisc = (prop) => (event) => {

        let ret = null,
            evenTargetValue = null;
        if (isdata.length !== 0) {
            if (prop === "minus") {
                let value_dsc = Number(event.target.value);
                if (parseFloat(value_dsc) < 0) return;

                if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03")
                    evenTargetValue = (
                        (value_dsc * 100) /
                        parseFloat(idata.tot_sale)
                    );
                else
                    evenTargetValue = (
                        (value_dsc * 100) /
                        parseFloat(idata.tot_purch)
                    );
                if (permistionInv.SDV !== 0)
                    ret = retPrmiSDPandSDV(
                        parseFloat(value_dsc),
                        permistionInv.SDV,
                        "DiscC"
                    );

                else ret = retPrmiSDPandSDV(evenTargetValue, permistionInv.SDP, "DiscP");

                if (ret === "") {
                    event.target.value = "";
          /*invDisc.rate='';*/ afterInvDescount(0, value_dsc);
                } else {
                    afterInvDescount(evenTargetValue, value_dsc);
                }
            }
            else if (prop === "rate") {
                let value_perc = Number(event.target.value);
                if (parseFloat(value_perc) < 0) return;
                if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03") {
                    evenTargetValue = (
                        parseFloat(idata.tot_sale) *
                        (value_perc / 100)
                    );
                }
                else {
                    evenTargetValue = (
                        parseFloat(idata.tot_purch) *
                        (value_perc / 100)
                    );
                }
                if (permistionInv.SDP !== 0)
                    ret = retPrmiSDPandSDV(
                        parseFloat(value_perc),
                        permistionInv.SDP,
                        "DiscP"
                    );
                else ret = retPrmiSDPandSDV(evenTargetValue, permistionInv.SDV, "DiscC");
                if (ret === "") {
                    event.target.value = "";
          /*idata.minus='';*/ afterInvDescount(0, evenTargetValue);
                } else {
                    afterInvDescount(value_perc, evenTargetValue);
                }
            }
        }
        prop === "minus"
            ? setInvDisc({
                ...invDisc,
                [prop]: event.target.value,
                rate: parseFloat(evenTargetValue).toFixed(2),
            })
            : setInvDisc({
                ...invDisc,
                [prop]: event.target.value,
                minus: parseFloat(evenTargetValue).toFixed(2),
            });
    };

    const afterInvDescount = (rate, desc_mount) => {
        const isdataU = [...isdata];
        if (rate === "") rate = 0;
        for (let m = 0; m < isdata.length; m++) {
            let percRate = Number(rate);
            isdataU[m].DiscPers = percRate.toFixed(5);
            isdataU[m].barcode = isdata[m].barcode;
            isdataU[m].currency_from = isdata[m].currency_from;
            isdataU[m].discountTotal = ((isdata[m].totJust * percRate) / 100);
            isdataU[m].discount = ((isdata[m].totJust * percRate) / 100).toFixed(5);
            // isdataU[m].discountTotal = ((isdata[m].totJust * percRate) / 100);
            // isdataU[m].discount = ((isdata[m].totJust * percRate) / 100).toFixed(5);
            isdataU[m].new_exchange_price = isdata[m].new_exchange_price;
            isdataU[m].sub_branch = isdata[m].sub_branch;
            isdataU[m].sub_center = isdata[m].sub_center;
            isdataU[m].symbol = isdata[m].symbol;
            isdataU[m].totJust = isdata[m].totJust;
            isdataU[m].tot_before_vat_after_d =
                parseFloat(isdataU[m].totJust) - parseFloat(isdataU[m].discount);
            isdataU[m].taxperc = isdata[m].taxperc;

            /* from samer */
            isdataU[m].taxval = permistionInv?.RE_DISC && ["02", "12"].includes(setting.PrTy_InPr) &&
                parseFloat(isdataU[m].discount) > 0 ? maths(
                    parseFloat(isdataU[m].totJust),
                    parseFloat(isdataU[m].taxperc),
                    "taxval"
                ) : maths(
                    parseFloat(isdataU[m].tot_before_vat_after_d),
                    parseFloat(isdataU[m].taxperc),
                    "taxval"
                );

            if (permiCuCo.CWVat == 1) {
                isdataU[m].netAmountSub = maths(
                    parseFloat(isdataU[m].tot_before_vat_after_d),
                    parseFloat(isdataU[m].taxperc),
                    "Net"
                );
                isdataU[m].totAfterDisc = permistionInv?.RE_DISC && ["02", "12"].includes(setting.PrTy_InPr) &&
                    parseFloat(isdataU[m].discount) > 0 ?
                    (parseFloat(isdataU[m].netAmountSub) - parseFloat(isdataU[m].taxval))
                    : maths(
                        parseFloat(isdataU[m].tot_before_vat_after_d),
                        parseFloat(isdataU[m].taxperc),
                        "before_vat"
                    );
            } else {
                isdataU[m].totAfterDisc = maths(
                    parseFloat(isdataU[m].tot_before_vat_after_d),
                    parseFloat(isdataU[m].taxperc),
                    "before_vat"
                );
                isdataU[m].netAmountSub = permistionInv?.RE_DISC && ["02", "12"].includes(setting.PrTy_InPr) ?
                    (parseFloat(isdataU[m].totAfterDisc) + parseFloat(isdataU[m].taxval)).toFixed(2) :
                    maths(
                        parseFloat(isdataU[m].tot_before_vat_after_d),
                        parseFloat(isdataU[m].taxperc),
                        "Net"
                    );
            }

            /* from me */
            // console.log("memememememmemmememmm");
            isdataU[m].totJust = isdata[m].totJust;
            isdataU[m].unit = isdata[m].unit;
            isdataU[m].unitame = isdata[m].unitame;
            isdataU[m].val = isdata[m].val;
            isdataU[m].val1 = isdata[m].val1;
            isdataU[m].tab3Val = subInfo?.is_tab3_curr == 1 ? parseFloat(isdataU[m].tot_before_vat_after_d) : 0;
        }

        SumAfterDesc(isdataU, desc_mount);
        setIsData([...isdataU]);
    };

    const SumAfterDesc = (data, desc_mount) => {
        let val1s = 0,
            tot_sale_or_purch = 0,
      /*tot_sales=0,tot_purchs=0,*/ amountOfVats = 0,
            netAmounts = 0,
            amountAfterDiscs = 0,
            amount_after_disc_before_vat = 0,
            discounts = 0,
            amountWithVats = 0,
            invTab3Val = 0,
            taxpercs;


        for (var m = 0; m < data.length; m++) {
            val1s += parseFloat(data[m].val1);
            tot_sale_or_purch += parseFloat(data[m].totJust);
            taxpercs = data[m].taxperc;
            /* جمالي القيمة المضافة */
            amountOfVats += parseFloat(data[m].taxval);
            netAmounts += parseFloat(data[m].netAmountSub);
            /* إجمالي قبل الضريبة */
            amountAfterDiscs += parseFloat(data[m].totAfterDisc);
            discounts += parseFloat(data[m].discount).toFixed(2);

            // tobacco tax
            invTab3Val += parseFloat(data[m].tab3Val);
            amount_after_disc_before_vat += parseFloat(data[m].totAfterDisc);
        }

        /* في الحالتين */
        /* إجمالي بعد الخصم */
        amountWithVats = (
            parseFloat(tot_sale_or_purch) - parseFloat(desc_mount)
        ).toFixed(2);
        /* يشمل */
        if (permiCuCo.CWVat == 1) {
            if (permistionInv?.RE_DISC && ["02", "12"].includes(setting.PrTy_InPr) && parseFloat(desc_mount) > 0) {
                amountAfterDiscs = (parseFloat(amount_after_disc_before_vat)).toFixed(2);
                amountOfVats = (parseFloat(amountOfVats)).toFixed(2);
                netAmounts = parseFloat(amountWithVats).toFixed(2);
            } else {
                amountAfterDiscs = (parseFloat(amount_after_disc_before_vat)).toFixed(2);
                amountOfVats = (parseFloat(amountWithVats) - parseFloat(amountAfterDiscs)).toFixed(2);
                netAmounts = (parseFloat(amountWithVats)).toFixed(2);
            }
        } else {
            /*لا يشمل */
            amountAfterDiscs = (
                parseFloat(amount_after_disc_before_vat)
            ).toFixed(2);

            netAmounts = (
                parseFloat(amountAfterDiscs) + parseFloat(amountOfVats)
            ).toFixed(2);

            amountWithVats = (
                parseFloat(amountAfterDiscs) + parseFloat(amountOfVats)
            ).toFixed(2);
        }

        setSums({ val1: val1s });
        setIData({
            ...idata,
            amountAfterDisc: amountAfterDiscs,
            amountWithVat: amountWithVats,
            tot_sale: tot_sale_or_purch,
            tot_purch: tot_sale_or_purch,
            netAmount: netAmounts,
            amountBefordisc: tot_sale_or_purch,
            amountOfVat: amountOfVats,
            minus: desc_mount,
            tab3Val: invTab3Val,
        });



        fcHandSumsToPayment(netAmounts);

        fcHandSumsToinvDisc(tot_sale_or_purch, discounts);
    };


    const afterGetCurrMathRate = (rate) => {
        const isdataU = [...isdata];
        if (rate === "") rate = 0;
        for (let m = 0; m < isdata.length; m++) {
            isdataU[m].DiscPers = rate;
            isdataU[m].barcode = isdata[m].barcode;
            isdataU[m].currency_from = isdata[m].currency_from;
            isdataU[m].discount = ((isdata[m].totJust * rate) / 100).toFixed(2);
            isdataU[m].new_exchange_price = isdata[m].new_exchange_price;
            isdataU[m].sub_branch = isdata[m].sub_branch;
            isdataU[m].sub_center = isdata[m].sub_center;
            isdataU[m].symbol = isdata[m].symbol;
            isdataU[m].totJust = isdata[m].totJust;


            // isdataU[m].totAfterDisc =
            //   isdata[m].totJust - parseFloat(isdataU[m].discount);

            isdataU[m].tot_before_vat_after_d =
                parseFloat(isdataU[m].totJust) - parseFloat(isdataU[m].discount);
            isdataU[m].taxperc = isdata[m].taxperc;

            /* from samer */
            isdataU[m].taxval = maths(
                parseFloat(isdataU[m].tot_before_vat_after_d),
                parseFloat(isdataU[m].taxperc),
                "taxval"
            );
            isdataU[m].netAmountSub = maths(
                parseFloat(isdataU[m].tot_before_vat_after_d),
                parseFloat(isdataU[m].taxperc),
                "Net"
            );
            isdataU[m].totAfterDisc = maths(
                parseFloat(isdataU[m].tot_before_vat_after_d),
                parseFloat(isdataU[m].taxperc),
                "before_vat"
            );

            /* from me */
            // console.log("memememememmemmememmm");
            isdataU[m].totJust = isdata[m].totJust;
            isdataU[m].unit = isdata[m].unit;
            isdataU[m].unitame = isdata[m].unitame;
            isdataU[m].val = isdata[m].val;
            isdataU[m].val1 = isdata[m].val1;
            isdataU[m].tab3Val = subInfo?.is_tab3_curr == 1 ? parseFloat(isdataU[m].tot_before_vat_after_d) : 0;
        }

        handSums(isdataU);
        setIsData([...isdataU]);
    };

    /* s toggle btn */
    const [toggle, setToggle] = React.useState(null);
    const [pdfToggle, setPdfToggle] = React.useState(null);

    const clickOpenToggle = (event, no = 1) => {
        if (isdata.length !== 0) {
            if (no != 1) setPdfToggle(event.currentTarget);
            else setToggle(event.currentTarget);
        } else {
            handOSnack({
                vertical: "top",
                horizontal: "right",
                severit: "warning",
                text: "يجب تنزيل اصناف أو إختيار فاتورة",
                time: 2000,
            });
        }
    };

    const clickOpenTogglePrint = (event) => {
        if (isdata.length !== 0) {
            setToggle(event.currentTarget);
        } else {
            handOSnack({
                vertical: "top",
                horizontal: "right",
                severit: "warning",
                text: "يجب تنزيل اصناف أو إختيار فاتورة",
                time: 2000,
            });
        }
    };


    const clickCloseToggle = () => {
        setToggle(null);
    };
    /* e toggle btn */
    // ========================================== s Snack

    /* 'error' 'warning' 'info' 'success'
       'top' 'bottom' 'center' 'left' 'right' */
    const [snack, setSnack] = React.useState(insh.Snack);

    const { vertical, horizontal, openSnak } = snack;

    const elmntBtn = (title, icondiv) => {
        return (
            <Button
                variant="contained"
                color="primary"
                size="large"
                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                disabled={true}
                startIcon={icondiv}
            >
                {" "}
                {title}
            </Button>
        );
    };

    const elmntIcon = (icondiv, dis) => {
        return (
            <Fab
                size="medium"
                color="primary"
                disabled={dis}
                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
            >
                {icondiv}
            </Fab>
        );
    };

    const styBtn = {
        dis: { color: "#3b773d", background: "#4fa152" },
        undis: { color: "#fff" },
    };
    const handOSnack = (newState) => {
        setSnack({ openSnak: true, ...newState });
    };

    const handCSnack = (event, reason) => {
        // if (reason === 'clickaway') { return; }
        setSnack({ ...snack, openSnak: false });
    };

    const frontSnack = () => {
        return (
            <div className={clasSN.rootSN}>
                <Toaster />

                <Snackbar
                    anchorOrigin={{ vertical, horizontal }}
                    open={openSnak}
                    autoHideDuration={snack.time}
                    onClose={handCSnack}
                    key={vertical + horizontal}
                    className={clasSN.snackbarSN}
                >
                    <Alert onClose={handCSnack} severity={snack.severit}>
                        {" "}
                        {snack.text}{" "}
                    </Alert>
                </Snackbar>
            </div>
        );
    };

    const downNormalItems = () => {
        return (
            <MainInvoiceDownItems {...{
                rptParams,
                subInfo,
                isOpenUpdate,
                isStock,
                isPurches,
                valueItemUnits,
                optionsCurrUnits,
                changAutoCurrUnits,
                setting,
                onChangeSearchNormal,
                onChangeData,
                onChangeAutoCurrNormal,
                changInfo,
                getrowDataCurrencie,
                permistionInv,
                or,
                handleFocus,
                valuePricePay,
                changAutoPricePay,
                optionsItemsSearch,
                handleInputSearch,
                handleIconSearch,
                searchText,
                setAllowKeyboard
            }}
            />

        );
    };

    //----alter1
    const hedInv = () => {
        return (
            <MainInvoiceHeader {...{
                AutoOptions,
                isPurches,
                setting,
                handleOpenCustomer,
                changAutoCustomers
                , optionsCustomers,
                changAutoSalesMen,
                valueSalesmen,
                changAutoCostcenter,
                valueCostcenter,
                idata,
                changAutoType,
                valueType,
                valueSafes,
                changAutoSafes,
                changAutoStock,
                valueStock,
                changAutoBank,
                valueBank,
                changSwitch,
                uiElement,
                switchState,
                lbl,
                claslbl,
                gets,
                handleFocus,
                onChangeData,
                rptParams,
                setShowPaid,
                exsub,
                handClickInvs,
                infoInv,
                changIdata,
                omlaValue,
                showPaid,
                onChangeAutoDataSubCurr,
                clasCAB,
                changInvs,
                loading,
                toWhere,
                buttonClassnameSavetmp,
                changAutoOmla,
                SaleCheckbox,
                valueCustomers,
                itmTble,
                footerInvoices,
                maxShifts,
                isStock,
                isMake,
                idSearch,
                permistionInv,
                getCustomerData,
                showCarOptions,
                setShowCarOptions,
                onChangeCarData,
                carOptions,
                isdata,
                or,
                isOpenUpdate,
                isUpdateDate,
                downNormalItems,
                getNewItamsData,
                keepDate,
                setKeepDate,
                inputRef,
                addnewItems,
                getBarcodeMulti,
                localCashe,
                getBarcodeMezan,
                optionsItemsSearch,
                handleInputSearch,
                handleInputSearchCust,
                handleIconSearch,
                handleIconSearchCust,
                searchCustText,
                searchText,
                autoNormal,
                downItemsType,
                setAllowKeyboard,
                setOpenGetItems,
                // getNewItemData,
                getBarcodeFast,
                valueIsharLevel,
                changAutoIsharLevel,
                changeIdataIshar,
                playSuccess
            }}
            />

        );
    };

    const itmTble = () => {

        return (
            <>
                <Hidden smUp>
                    <Grid item container className={clasup.rootupMu}
                    >
                        <Grid item lg={12} md={12} sm={12} xs={12} spacing={1}>
                            <MaterialTable
                                style={{ boxShadow: "none" }}
                                options={{
                                    showTitle: false,
                                    toolbar: true,
                                    search: false,
                                    sorting: false,
                                    selection: true,
                                    searchFieldAlignment: "left",
                                    searchFieldVariant: "outlined",
                                    showSelectAllCheckbox: false,
                                    showTextRowsSelected: false,
                                    cellStyle: stElemnt.SubR,
                                    headerStyle: isPurches ? stElemnt.SubHPruch : isStock ? stElemnt.SubHSafes : isMake ? stElemnt.SubHMake : stElemnt.SubHMu,
                                    pageSize: 5,
                                    paginationType: "stepped",
                                    showFirstLastPageButtons: false,
                                    paging: false,
                                    maxBodyHeight: Mtb.minmaxBHSub,
                                    minBodyHeight: Mtb.minmaxBHSub,
                                }}
                                components={{
                                    Toolbar: (props) => (
                                        <Fragment>
                                            <div
                                                className={clstoolbar.toolbarWrapper}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    height: "2.7vh",
                                                }}
                                            >
                                                <MTableToolbar
                                                    {...props}

                                                    searchFieldStyle={{ height: "2.4vh" }}
                                                />
                                            </div>
                                        </Fragment>
                                    ),
                                }}

                                actions={

                                    (!isHedden
                                        ?
                                        ([
                                            {
                                                icon: () => <Delete />,
                                                tooltip: "حذف الأصناف",
                                                onClick: hRowDelete,
                                            },
                                        ])
                                        : or.postput == "toPost" && isHeddenReturn ?
                                            ([
                                                {
                                                    icon: () => <Delete />,
                                                    tooltip: "حذف الأصناف",
                                                    onClick: hRowDelete,
                                                },
                                            ])
                                            :
                                            false
                                    )

                                }
                                localization={{
                                    body: {
                                        emptyDataSourceMessage: (
                                            <h3 style={{ color: "#000" }}></h3>
                                        ),
                                    },
                                    toolbar: [{ searchPlaceholder: "بحث في السجل" }],
                                }}
                                columns={columnsInvSub}
                                data={isdata}
                                icons={
                                    (!isHedden
                                        ?
                                        tableIcons
                                        : or.postput == "toPost" && isHeddenReturn ? tableIcons :
                                            false
                                    )
                                }


                                editable={
                                    (!isHedden
                                        ?
                                        ({
                                            onRowUpdate: (newData, oldData) =>
                                                new Promise((resolve) => {
                                                    hRowUpdate(newData, oldData, resolve);
                                                })
                                        })
                                        : or.postput == "toPost" && isHeddenReturn ?
                                            ({
                                                onRowUpdate: (newData, oldData) =>
                                                    new Promise((resolve) => {
                                                        hRowUpdate(newData, oldData, resolve);
                                                    })
                                            }) :

                                            false
                                    )
                                }

                            />
                        </Grid>
                    </Grid>
                </Hidden>
                <Hidden only={"xs"}>
                    {setting.PrTy_InPr === "01" ?
                        (
                            itmTblePurchase()
                        ) :
                        (
                            <InvItemsTable {...{
                                isdata, setIsData, maths, handSums, isPurches, isStock,
                                isMake, permistionInv, handOSnack, setting, setConfirmDialog, isHedden, or,
                                isOpenUpdate, setRowUpdate, mathsTab3val, AutoOptions, setAllowKeyboard, lastItem,
                                setLastLtem, mathIdataIsharItem, valueIsharLevel, rowUpdate
                            }}
                            />
                        )
                    }

                </Hidden>

            </>
        );
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleChangeE = (event, newValue) => {
        setValueE(newValue);
    };
    const itmTblePurchase = () => {

        return (
            <>
                <AppBar position="static" style={{ backgroundColor: "fff" }} >
                    <Tabs
                        style={{ backgroundColor: "#fff" }}
                        value={valueE}
                        onChange={handleChangeE}
                        aria-label="simple tabs example"
                    >
                        <Tab style={{ fontWeight: "bold", color: "#000" }} label="بيانات الاصناف" {...a11yProps(0)} />
                        <Tab style={{ fontWeight: "bold", color: "#000" }} label="اعباء الفاتورة"{...a11yProps(1)} />
                    </Tabs>
                </AppBar>
                <TabPanel value={valueE} index={0}>
                    <InvItemsTable {...{
                        isdata, setIsData, maths, handSums, isPurches, isStock,
                        isMake, permistionInv, handOSnack, setting, setConfirmDialog, isHedden,
                        or, isOpenUpdate, setRowUpdate, mathsTab3val, setAllowKeyboard, lastItem, setLastLtem, rowUpdate
                    }}
                    />
                </TabPanel>
                <TabPanel value={valueE} index={1}>
                    <InvoicesExpenses {...{
                        AutoOptions,
                        expenseList,
                        setExpenseList,
                        or, isOpenUpdate,
                        gets, setConfirmDialog
                    }}
                    />
                </TabPanel>



            </>
        );
    };
    const footerInvoices = () => {
        return (
            <InvoiceFooter {...{
                isPurches,
                setting,
                idata,
                valueType,
                uiElement,
                changIdata,
                isStock,
                isMake,
                permistionInv,
                changinvDisc,
                invDisc,
                changClick,
                payment,
                changPayment,
                sums,
                currentUserName,
                isHedden,
                permiCuCo,
                or,
                setFile,
                handleDownload,
                setFiles,
                files
            }}
            />

        );
    };

    const footAppbar = () => {
        return (
            <MainInvoiceAppar {...{
                ...props,
                buttonClassnameSave,
                buttonClassnameDelete,
                clasCAB,
                setting,
                loading,
                backHome,
                uiElement,
                success,
                handOpenDw,
                clickOpenToggle,
                isHedden,
                permistionInv,
                style,
                stElemnt,
                clasBA,
                switchState,
                handCOpenCu,
                TransitionUp,
                toWhere,
                toPrint,
                transForm,
                buttonClassnamePrint,
                elmntBtn,
                or,
                stor,
                setPdfToggle,
                generating,
                StyledMenuItem,
                deleteTos,
                transformDone,
                transformDonePurch,
                setConfirmDialog,
                pdfToggle,
                StyledMenu,
                handOpenDwt,
                handNewInv,
                HomeBcode,
                TransitionDown,
                styBtn,
                clickCloseToggle,
                toggle,
                clickOpenTogglePrint,
                isDialog,
                idata,
                AutoOptions,
                sendToZatca,
                isOpenUpdate,
                setIsOpenUpdate,
                onClickButton,
                procIdSearch,
                openButtonsSearch,
                setOpenButtonsSearch,
                isLoading,
                toPrintTemplate,
            }}
            />

        );
    };

    function ScrollTop(props) {
        const { children, window } = props;
        const trigger = useScrollTrigger({
            target: window ? window() : undefined,
            disableHysteresis: true,
            threshold: 100,
        });

        const handUp = (event) => {
            const anchor = (event.target.ownerDocument || document).querySelector(
                "#back-to-top-anchor"
            );
            if (anchor) {
                anchor.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        };

        return (
            <Zoom in={trigger}>
                <div onClick={handUp} role="presentation" className={clasFu.root}>
                    {children}
                </div>
            </Zoom>
        );
    }
    ScrollTop.propTypes = {
        children: PropTypes.element.isRequired,
        window: PropTypes.func,
    };




    const frontInvst = () => {
        return (
            <OutstandingInvoice
                {...{
                    AutoOptions,
                    showChosedInvt,
                    setting,
                    isPurches,
                    isStock,
                    outstandData,
                    setOutstandData
                }}
            />
        );
    };



    const [scroll, setScroll] = React.useState("paper");

    const CurrFavorite = () => {
        return (
            <div>
                <Dialog
                    fullWidth={true}
                    maxWidth="md"
                    open={dialog.fav}
                    onClose={handleClDia}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle
                        className={clasSM.dialogTitleSM}
                        id="customized-dialog-title"
                    >
                        <Tabs
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs example"
                        >
                            {gets?.FavGroup.map((group, i) => (
                                <Tab
                                    key={i}
                                    label={group?.name}
                                    onClick={() => changFavSlides(group?.id)}
                                />
                            ))}
                        </Tabs>
                    </DialogTitle>

                    <DialogContent dividers={scroll === "paper"}>
                        <DialogContentText id="scroll-dialog-description">
                            <FavCard
                                prop={favGroups}
                            // onclick={(id, barcode) => BefrowDataCurrencie(id, barcode)}
                            />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => handleClDia("fav", false)} color="primary">
                            {transForm("cancel")}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    };

    const stylesserch = {
        input: {
            "&::placeholder": {
                textOverflow: "ellipsis !important",
                color: "blue",
                fontSize: 10,
            },
        },
    };
    const backHome = () => {
        if (isdata?.length > 0 && or.postput === "toPst") {
            setExitDialog({
                isOpen: true,
                text: "Yau have data in table... Are you still want to log out",
                onConfirm: () => {
                    his.goBack();
                    //   his.push({ pathname: "/" });
                    // window.location.reload(false);
                },
            });
        } else {
            his.goBack();
        }
    };
    useEffect(() => {
        const handleUnload = (e) => {
            if (isdata.length > 0) {
                e.preventDefault();
                e.returnValue = "you can not refresh the page";
            }
        };
        window.addEventListener('beforeunload', handleUnload);
        return () => {
            window.removeEventListener('beforeunload', handleUnload);
        };
    }, [isdata]);

    useEffect(() => {

        if (isMobileDevice()) return;
        if (AutoOptions?.StepTwo?.id === 1 && or.postput == "toPut" &&
            (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12")
        ) return;
        const handleKeyDown = async (event) => {
            if (event.key === 'F6') {
                if (or.postput == "toPut" && permistionInv.Up) {
                    event.preventDefault();
                    let balanceItems = null;
                    const tb = {
                        wait: true,
                        checksItems: true,
                        parms: {
                            safe: valueSafes?.id,
                            branch: sto.branchi,
                            _Data: isdata,
                        },
                    };

                    axios
                        .post(uri + "GetD", tb)
                        .then((res) => {
                            balanceItems = isdata.map((sub) => {
                                const blncData = res?.data?.itemsBalance.find((obj) => obj.currency_from === sub.currency_from);
                                let valQuantity = (parseFloat(blncData?.Qtys ?? 0) + parseFloat(sub?.val1 * sub?.val)).toFixed(2);
                                return {
                                    ...sub,
                                    Qtys: setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11" ?
                                        valQuantity : blncData?.Qtys ?? 0,
                                    PricePu: blncData.avgCost,
                                    minPrice: blncData.avgCost,
                                };
                            });
                            setIsData([...balanceItems]);
                            setIshedden(false);
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            }
            if (event.ctrlKey && event.key === "u") {

                if (or.postput == "toPut" && permistionInv.Up) {
                    event.preventDefault();
                    let balanceItems = null;
                    const tb = {
                        wait: true,
                        checksItems: true,
                        parms: {
                            safe: valueSafes?.id,
                            branch: sto.branchi,
                            _Data: isdata,
                        },
                    };

                    axios
                        .post(uri + "GetD", tb)
                        .then((res) => {
                            balanceItems = isdata.map((sub) => {
                                const blncData = res?.data?.itemsBalance.find((obj) => obj.currency_from === sub.currency_from);
                                return {
                                    ...sub,
                                    Qtys: blncData?.Qtys ?? 0,
                                    PricePu: blncData.avgCost,
                                    minPrice: blncData.avgCost,
                                };
                            });
                            setIsData([...balanceItems]);
                            setIshedden(false);
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            }
            if (event.altKey && event.key === "y") {
                event.preventDefault();
                setConfirmDialog({
                    isOpen: true,
                    onConfirm: () => {
                        deleteTos(event);
                    },
                })
            }
            if (event.ctrlKey && event.key === "d") {
                if (or.postput == "toPost") {
                    event.preventDefault();
                    setIsUpdateDate(true);
                }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isHedden, isdata, or, AutoOptions, setting, isUpdateDate]);
    useEffect(() => {
        if (isMobileDevice()) return;
        if (isLoading) return;
        if (openPMD || voucherDialog.isOpen || allow.it) return;
        const handleKeyDown = async (event) => {
            if (event.key === 'F3') {
                event.preventDefault();
                // or.PrAC = 1;
                if (isdata.length == 0) {
                    handOSnack({
                        vertical: "top",
                        horizontal: "center",
                        severit: "warning",
                        text: transForm("most_download_item"),
                        time: 2000,
                    });
                } else {
                    toPrint("print", "e", 1);
                }

            }
            if (event.key === 'F5') {

                event.preventDefault();

                or.PrAC = 3;
                if (isdata.length == 0) {
                    handOSnack({
                        vertical: "top",
                        horizontal: "center",
                        severit: "warning",
                        text: transForm("most_download_item"),
                        time: 2000,
                    });
                } else {
                    await toWhere("print", "e");
                }

            }
            if (event.key === 'F10') {
                if (AutoOptions?.StepTwo?.id === 1 && or.postput == "toPut" &&
                    (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12")
                ) return;
                if (isLoading) return;
                event.preventDefault();
                if (isdata.length == 0) {
                    handOSnack({
                        vertical: "top",
                        horizontal: "center",
                        severit: "warning",
                        text: transForm("most_download_item"),
                        time: 2000,
                    });
                } else {
                    await toWhere("save", "e");
                }

            }
            if (event.key === 'F11') {
                event.preventDefault();
                or.PrAC = 2;

                if (isdata.length == 0) {
                    handOSnack({
                        vertical: "top",
                        horizontal: "center",
                        severit: "warning",
                        text: transForm("most_download_item"),
                        time: 2000,
                    });
                } else {
                    await toWhere("print", "e");
                }

            }
            if (event.key === 'F1') {
                event.preventDefault();
                // or.PrAC = 2;
                if (isdata.length == 0) {
                    handOSnack({
                        vertical: "top",
                        horizontal: "center",
                        severit: "warning",
                        text: transForm("most_download_item"),
                        time: 2000,
                    });
                } else {
                    await toPrintCashOrNetwork("print", "e", 1, false);
                }

            } if (event.key === 'F2') {
                event.preventDefault();
                await handNewInv();
            }
            if (event.key === 'F7') {
                event.preventDefault();
                // or.PrAC = 2;
                if (isdata.length == 0) {
                    handOSnack({
                        vertical: "top",
                        horizontal: "center",
                        severit: "warning",
                        text: transForm("most_download_item"),
                        time: 2000,
                    });
                } else {
                    await toPrintCashOrNetwork("print", "e", 1, true);
                }

            }
            if (event.key === 'F8') {
                event.preventDefault();
                if(isdata.length > 0 ){
                    await toWhere("savetmp", "e");
                }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };

    }, [idata, isdata, remains, payment, or, setting, isLoading, AutoOptions, voucherDialog, openPMD, allow]);

    useEffect(() => {

        if (setting.PrTy_InPr == "12" || setting.PrTy_InPr == "11") {
            if (setting.PrTy_InPr == "12") {
                if (AutoOptions?.StepTwo?.id == 1) {
                    setIshedden(true);
                    setIsheddenReturn(true);
                } else {

                }
            }
            if (!permistionInv?.ALLOWRETURN) {
                setIshedden(true);
                setIsheddenReturn(true);
            }
        }
    }, [setting, permistionInv, isHedden]);



    const [awaitingMultiply, setAwaitingMultiply] = useState(false);
    const [buffer, setBuffer] = useState("");
    const [electedItemIndesk, setSelectedItemIndesk] = useState(null);

    const QuantitFunctions = (rowItem, multiplier, type) => {
        if (type === "+" || type === "-") {
            const lastRow = rowUpdate?.no != null ? isdata.find((obj) =>
                obj.no === rowUpdate.no) :
                isdata.reduce((max, item) =>
                    item.no > max.no ? item : max
                );
            rowItem = lastRow;
            if (type === "+") {
                multiplier = (parseFloat(lastRow?.val1) + parseFloat(1)).toFixed(2);
            } else {
                multiplier = lastRow.val1 > 1 ? (parseFloat(lastRow?.val1) - parseFloat(1)).toFixed(2) : parseFloat(lastRow?.val1).toFixed(2);
            }
        }
        if (!isNaN(multiplier) && rowItem?.no !== null && allowKeyboard === true) {
            let maxQty = parseFloat(permistionInv?.MAXQTY ?? 100000);
            let tot = parseFloat(multiplier * rowItem.new_exchange_price);
            let desc_mount = (
                parseFloat(tot) *
                (rowItem.DiscPers / 100)
            );
            let totBe = parseFloat((multiplier * rowItem.new_exchange_price) - desc_mount);
            let taxMount = maths(
                parseFloat(totBe),
                parseFloat(rowItem.taxperc),
                "taxval"
            );
            let betTax = maths(
                parseFloat(totBe),
                parseFloat(rowItem.taxperc),
                "before_vat"
            );

            let resNetA = maths(
                parseFloat(totBe),
                parseFloat(rowItem.taxperc),
                "Net"
            );
            let tot_before_vat_with_tab3val = 0;
            if (parseFloat(rowItem?.tab3val_sub) > 0) {
                let tot_before_new = maths(parseFloat(rowItem.new_exchange_price), parseFloat(rowItem.taxperc), "before_vat");
                tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                    (parseFloat(25) * multiplier) : parseFloat(betTax).toFixed(2);

                let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

                taxMount = mathsTab3val(parseFloat(tot_before), parseFloat(rowItem.taxperc), "taxval");

                resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax) + parseFloat(taxMount)).toFixed(2);
            }
            let subInfoVal1_perc = multiplier * rowItem.val;
            let totValbef = 0.0;
            for (let m = 0; m < isdata.length; m++) {
                if (rowItem.currency_from == isdata[m].currency_from && rowItem.no != isdata[m]?.no)
                    totValbef += (isdata[m].val1 * isdata[m].val);
            };
            let countsCurr = Number(rowItem?.Qtys) - Number(totValbef);

            if (permistionInv.SIM == false && type !== "-" &&
                countsCurr < subInfoVal1_perc &&
                (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
                setRowUpdate(rowItem);
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: "الكمية المدخلة للصنف أكبر من رصيد المخزن",
                    time: 2000,
                });
            }
            else if (parseFloat(multiplier) > parseFloat(maxQty) &&
                (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
                setRowUpdate(rowItem);
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: `لقد تجاوزت حد الكمية المسموح فيها... برجاء الذهاب لاعدادات النظام لزيادة الحد: 
    ${maxQty}`,
                    time: 2000,
                });
            }
            else {
                const newData = {
                    ...rowItem,
                    val1: multiplier,
                    totJust: tot,
                    totAfterDisc: betTax,
                    taxval: taxMount,
                    netAmountSub: resNetA,
                    discount: desc_mount,
                    tab3val_sub: tot_before_vat_with_tab3val,
                    tab3Val: tot_before_vat_with_tab3val,
                };

                const index = rowItem?.no;
                const dataUpdate = [...isdata];
                dataUpdate[index] = { ...newData };
                setIsData([...dataUpdate]);
                handSums(dataUpdate);
            }
        }
    };

    useEffect(() => {
        if (isMobileDevice()) return;
        if (openPMD || voucherDialog.isOpen) return;
        if (or.postput == "toPut" && !isOpenUpdate) return;
        if (AutoOptions?.StepTwo?.id === 1 && or.postput == "toPut" &&
            (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12")
        ) return;
        if (isdata.length == 0) return;
        const handleKeyDown = async (event) => {
            if (openPMD || voucherDialog.isOpen) return;

            if (event.key === "*") {
                setAwaitingMultiply(true);
                setBuffer("");
                return;
            }
            if (awaitingMultiply) {
                if (!isNaN(event.key)) {
                    setBuffer((prev) => prev + event.key);
                } else if (event.key === "Enter") {
                    const multiplier = parseFloat(buffer);
                    if (!isNaN(multiplier) && rowUpdate?.no !== null) {
                        await QuantitFunctions({ ...rowUpdate }, multiplier, "add");
                    }
                    setAwaitingMultiply(false);
                    setBuffer("");
                } else {
                    setAwaitingMultiply(false);
                    setBuffer("");
                }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };

    }, [isdata, buffer, awaitingMultiply, idata, rptParams,
        permiCuCo, sums, rowUpdate, AutoOptions, or, setting, openPMD, voucherDialog]);

    const el = document.activeElement;

    useEffect(() => {
        // if (!allowKeyboard) return;
        if (isMobileDevice()) return;
        if (isdata.length === 0) return;
        if (or.postput == "toPut" && !isOpenUpdate) return;
        if (AutoOptions?.StepTwo?.id === 1 && or.postput == "toPut" &&
            (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12")
        ) return;
        const handleKeyDown = async (event) => {
            if (event.ctrlKey && (event.key === "+" || event.key === "-")) {
                event.preventDefault();
                QuantitFunctions(rowUpdate, 1, event.key);
            }
            else if (event.key === "Delete") {
                const lastRow = rowUpdate?.no != null ? isdata.find((obj) =>
                    obj.no === rowUpdate.no) :
                    isdata.reduce((max, item) =>
                        item.no > max.no ? item : max
                    );
                if (isdata?.length > 0 && lastRow.no != null) {
                    setConfirmDialog({
                        isOpen: true,
                        onConfirm: () => {
                            var newData = isdata.filter((obj) => obj.no !== lastRow.no);
                            const newItems = newData.map((row, i) => {
                                return {
                                    ...row,
                                    no: i,
                                };
                            });
                            setIsData([...newItems]);
                            handSums(newData);
                            setConfirmDialog(false);
                            setRowUpdate({});
                        },
                    })

                }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isdata, idata, permiCuCo, sums, rowUpdate, el,
        confirmDialog, AutoOptions, or, setting, allowKeyboard]);

    const clickUpdate = () => {
        if (AutoOptions?.StepTwo?.id === 1 && or.postput == "toPut" &&
            ["12", "02", "149", "150"].includes(setting.PrTy_InPr)) return;
        if (!permistionInv.Up) return;
        if (["12", "02", "149", "150"].includes(setting.PrTy_InPr)) {
            {
                setIshedden(false);
            }
        }
    };
    const frontCurrencis = () => {

        return (
            <InvoiceItemsModals
                {...{
                    openCuD,
                    handleCloseCuD,
                    transition,
                    switchState,
                    groups,
                    groupsSub,
                    changSlides,
                    subInfo,
                    cuRows,
                    permiCuCo,
                    setting,
                    changAutoPricePay,
                    valuePricePay,
                    changAutoCurrUnits,
                    changInfo,
                    optionsPricePay,
                    optionsCurrUnits,
                    checked,
                    changSwitch,
                    _onDetected,
                    changChcked,
                    getrowDataCurrencie,
                    stElemnt,
                    permistionInv,
                    rptParams,
                    onChangeSearchD,
                    AutoOptions,
                    isPurches,
                    onChangeData,
                    onChangeDataA,
                    onChangeAutoDataG,
                    groupsSubs,
                    onChangeAutoDataSub,
                    onRowClicks,
                    viewHandle,
                    groupsOptions,
                    isStock,
                    valueItemUnits,
                    getNewItamsData
                }}
            />
        );
    };

    if (!isApiConnect) return <ReConnect />;

    return showSc ? (
        <BackdropScI />
    ) : (
        <div
            style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }} >
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <Grid
                    container
                    justifyContent="center"
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                >
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <div style={{ backgroundColor: "fff" }}>
                            <AppBar position="static" style={{ backgroundColor: "fff" }} >
                                <Tabs
                                    style={{
                                        backgroundColor: isPurches ? colors.blue[50] : colors.green[50],
                                        textAlign: "center",
                                        fontSize: 20,
                                        width: "100%",
                                        direction: "rtl"
                                    }}
                                    value={value}
                                    onChange={handleChange}
                                    aria-label="simple tabs example"
                                >
                                    <Tab
                                        onDoubleClick={(event) => clickUpdate()}
                                        style={{ fontWeight: "bold", color: "#000" }} label={setting.PrTy_InPr === "02" ? transForm('sales_invoice') : setting.PrTy_InPr === "12" ? transForm('return_sales')
                                            : setting.PrTy_InPr === "01" ? transForm('purchase_invoice') : setting.PrTy_InPr === "11" ? transForm('return_purchase') :
                                                setting.PrTy_InPr === "03" ? post === 1 ? "فاتورة أولية" : transForm("quotation") : setting.PrTy_InPr === "04" ? transForm("purchase_order") :
                                                    setting.PrTy_InPr === "22" ? transForm("first_stock") : setting.PrTy_InPr === "33" ? transForm("made_Order") : setting.titleHed}
                                        {...a11yProps(0)} />
                                    {!props.isDialog && permistionInv?.Se &&
                                        (

                                            <Tab style={{ fontWeight: "bold", color: "#000" }} label={transForm("invoice-search")}{...a11yProps(1)} />
                                        )}
                                    {!props.isDialog &&
                                        (

                                            <Tab style={{ fontWeight: "bold", color: "#000" }} label={transForm("out-billing")}{...a11yProps(2)} />
                                        )}
                                    {!props.isDialog &&
                                        (

                                            <Tab style={{ fontWeight: "bold", color: "#000" }} label="استيراد من اكسل"{...a11yProps(3)} />
                                        )}
                                </Tabs>
                            </AppBar>

                            <TabPanel value={value} index={0} keepMounted>
                                <div
                                    style={{ direction: i18next.language == "ar" ? "ltr" : "rtl" }}
                                >
                                    {frontSnack()}
                                    {footAppbar()}
                                    {hedInv()}

                                    {openCuD && (frontCurrencis())}
                                    {/* s currFavD */}
                                    {/* e currFavD */}
                                    {
                                        allow.c ? (
                                            <CustomersDialog
                                                open={isOpenCustomer}
                                                type={location.state.setting.cusType}
                                                onClose={() => {
                                                    setIsOpenCustomer(false);
                                                }}
                                                onSave={(custData) => {
                                                    setIsOpenCustomer(false);
                                                    reLoadCust(custData);
                                                }}

                                            />
                                        ) : null}
                                    {
                                        allow.cud ? (
                                            <CustomerDialogData
                                                open={isOpenCustomerData}
                                                type={location.state.setting.cusType}
                                                onClose={() => {
                                                    setIsOpenCustomerData(false);
                                                }}
                                                onSave={(updateData) => {
                                                    setIsOpenCustomerData(false);
                                                    reUpdateCust(updateData);
                                                }}
                                                custData={custData}
                                            />
                                        ) : null}

                                    {
                                        allow.it ? (
                                            <ItemsDialog
                                                open={isOpenItems}
                                                onClose={() => {
                                                    setIsOpenItems(false);
                                                }}
                                                itemdata={newItemsAdd}
                                            />
                                        ) : null}
                                    {(openGetItems && or.postput != "toPut" && setting.PrTy_InPr != "12" && setting.PrTy_InPr != "11") ?
                                        <ItemsFromOthers openGetItems={openGetItems} setOpenGetItems={setOpenGetItems} PrTy_InPr={setting.PrTy_InPr}
                                            setIsData={setIsData} handSums={handSums} permiCuCo={permiCuCo.CWVat}
                                            transForm={transForm} /> : null}

                                    {confirmDialog.isOpen && (
                                        <DeleteConfirmDialog
                                            confirmDialog={confirmDialog}
                                            setConfirmDialog={setConfirmDialog}
                                        />
                                    )}
                                    {exitDialog.isOpen && (
                                        <ExitConfirmDialog
                                            exitDialog={exitDialog}
                                            setExitDialog={setExitDialog}
                                        />
                                    )}
                                    {voucherDialog.isOpen && (
                                        <ExtVoucherDialog
                                            voucherDialog={voucherDialog}
                                            setVoucherDialog={setVoucherDialog}
                                        />
                                    )}
                                    {openPrint.open ?
                                        <InvoiceTypePrintA4 isFocus={true} openPrint={openPrint} handNewInv={handNewInv} keepFocus={keepFocus} /> : null}
                                    {openPMD &&
                                        (<PaidWindowForm
                                            {... {
                                                idata,
                                                remains,
                                                setRemains,
                                                invDisc,
                                                payment,
                                                changPayment,
                                                buttonClassnameSavePMD,
                                                toDB, loading,
                                                handClosePMD,
                                                style,
                                                gets,
                                                openPMD,
                                                valueEmployePMD,
                                                transition,
                                                clasAo,
                                                valueBankPMD,
                                                changAutoBankPMD,
                                                changIdata,
                                                changAutoEmployee,
                                                valueType,
                                                setIData,
                                                valueAutoBankPaid,
                                                valueBanksPaid,
                                                AutoOptions,
                                                permistionInv
                                            }}
                                        />)}
                                </div>
                            </TabPanel>

                            {permistionInv?.Se &&
                                (
                                    <TabPanel value={value} index={1} keepMounted>
                                        <SearchInvoiceScreean
                                            {...{
                                                openDw,
                                                handCloseDw,
                                                transition,
                                                showChosedInv,
                                                invsShow,
                                                stElemnt,
                                                style,
                                                valueTypeFltr,
                                                gets,
                                                searchedInvShow,
                                                setOr,
                                                or,
                                                optionsCustomers,
                                                PcIdIvPc: setting.PrTy_InPr,
                                                setting,
                                                setIsClick,
                                                ished,
                                                AutoOptions,
                                                isHedden,
                                                permistionInv,
                                                setIshedden,
                                                isStock,
                                                isMake,
                                                isPurches,
                                                invsSearchTable,
                                                setInvsSearchTable,
                                                setValue,
                                                post,
                                                rptParamsSearch,
                                                setRptParamsSearch
                                            }}
                                        />
                                    </TabPanel>
                                )}

                            <TabPanel value={value} index={!permistionInv?.Se ? 1 : 2} keepMounted>
                                {frontInvst()}
                            </TabPanel>
                            <TabPanel value={value} index={!permistionInv?.Se ? 2 : 3} keepMounted>
                                {/* <b>استيراد من اكسل</b> */}
                                <ImportExcel
                                    {...{
                                        isPurches: isPurches,
                                        isStock: isStock,
                                        isItem: false,
                                        isSales: !isPurches && !isStock && !isMake ? true : false,
                                        getFormExcelData,
                                        excelData,
                                        setExcelData,
                                        loadingExcel
                                    }}
                                />


                            </TabPanel>
                        </div>
                    </Grid>
                </Grid>

            </Typography>
        </div>
    );
}
